/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.protos || ($protobuf.roots.protos = {});

export const common = $root.common = (() => {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    const common = {};

    common.Timestamp = (function() {

        /**
         * Properties of a Timestamp.
         * @memberof common
         * @interface ITimestamp
         * @property {number|Long|null} [seconds] Timestamp seconds
         * @property {number|null} [nanos] Timestamp nanos
         */

        /**
         * Constructs a new Timestamp.
         * @memberof common
         * @classdesc Represents a Timestamp.
         * @implements ITimestamp
         * @constructor
         * @param {common.ITimestamp=} [properties] Properties to set
         */
        function Timestamp(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Timestamp seconds.
         * @member {number|Long} seconds
         * @memberof common.Timestamp
         * @instance
         */
        Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Timestamp nanos.
         * @member {number} nanos
         * @memberof common.Timestamp
         * @instance
         */
        Timestamp.prototype.nanos = 0;

        /**
         * Creates a new Timestamp instance using the specified properties.
         * @function create
         * @memberof common.Timestamp
         * @static
         * @param {common.ITimestamp=} [properties] Properties to set
         * @returns {common.Timestamp} Timestamp instance
         */
        Timestamp.create = function create(properties) {
            return new Timestamp(properties);
        };

        /**
         * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Timestamp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Timestamp} Timestamp
         */
        Timestamp.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Timestamp)
                return object;
            let message = new $root.common.Timestamp();
            if (object.seconds != null)
                if ($util.Long)
                    (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                else if (typeof object.seconds === "string")
                    message.seconds = parseInt(object.seconds, 10);
                else if (typeof object.seconds === "number")
                    message.seconds = object.seconds;
                else if (typeof object.seconds === "object")
                    message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
            if (object.nanos != null)
                message.nanos = object.nanos | 0;
            return message;
        };

        /**
         * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Timestamp
         * @static
         * @param {common.Timestamp} message Timestamp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Timestamp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.seconds = options.longs === String ? "0" : 0;
                object.nanos = 0;
            }
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                if (typeof message.seconds === "number")
                    object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                else
                    object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
            if (message.nanos != null && message.hasOwnProperty("nanos"))
                object.nanos = message.nanos;
            return object;
        };

        /**
         * Converts this Timestamp to JSON.
         * @function toJSON
         * @memberof common.Timestamp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Timestamp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Timestamp;
    })();

    common.HealthCheckRequest = (function() {

        /**
         * Properties of a HealthCheckRequest.
         * @memberof common
         * @interface IHealthCheckRequest
         * @property {string|null} [service] HealthCheckRequest service
         */

        /**
         * Constructs a new HealthCheckRequest.
         * @memberof common
         * @classdesc Represents a HealthCheckRequest.
         * @implements IHealthCheckRequest
         * @constructor
         * @param {common.IHealthCheckRequest=} [properties] Properties to set
         */
        function HealthCheckRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HealthCheckRequest service.
         * @member {string} service
         * @memberof common.HealthCheckRequest
         * @instance
         */
        HealthCheckRequest.prototype.service = "";

        /**
         * Creates a new HealthCheckRequest instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckRequest
         * @static
         * @param {common.IHealthCheckRequest=} [properties] Properties to set
         * @returns {common.HealthCheckRequest} HealthCheckRequest instance
         */
        HealthCheckRequest.create = function create(properties) {
            return new HealthCheckRequest(properties);
        };

        /**
         * Creates a HealthCheckRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.HealthCheckRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.HealthCheckRequest} HealthCheckRequest
         */
        HealthCheckRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.common.HealthCheckRequest)
                return object;
            let message = new $root.common.HealthCheckRequest();
            if (object.service != null)
                message.service = String(object.service);
            return message;
        };

        /**
         * Creates a plain object from a HealthCheckRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.HealthCheckRequest
         * @static
         * @param {common.HealthCheckRequest} message HealthCheckRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HealthCheckRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.service = "";
            if (message.service != null && message.hasOwnProperty("service"))
                object.service = message.service;
            return object;
        };

        /**
         * Converts this HealthCheckRequest to JSON.
         * @function toJSON
         * @memberof common.HealthCheckRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HealthCheckRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HealthCheckRequest;
    })();

    common.HealthCheckResponse = (function() {

        /**
         * Properties of a HealthCheckResponse.
         * @memberof common
         * @interface IHealthCheckResponse
         * @property {common.HealthCheckResponse.ServingStatus|null} [status] HealthCheckResponse status
         */

        /**
         * Constructs a new HealthCheckResponse.
         * @memberof common
         * @classdesc Represents a HealthCheckResponse.
         * @implements IHealthCheckResponse
         * @constructor
         * @param {common.IHealthCheckResponse=} [properties] Properties to set
         */
        function HealthCheckResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HealthCheckResponse status.
         * @member {common.HealthCheckResponse.ServingStatus} status
         * @memberof common.HealthCheckResponse
         * @instance
         */
        HealthCheckResponse.prototype.status = 0;

        /**
         * Creates a new HealthCheckResponse instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.IHealthCheckResponse=} [properties] Properties to set
         * @returns {common.HealthCheckResponse} HealthCheckResponse instance
         */
        HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
        };

        /**
         * Creates a HealthCheckResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.HealthCheckResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.HealthCheckResponse} HealthCheckResponse
         */
        HealthCheckResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.common.HealthCheckResponse)
                return object;
            let message = new $root.common.HealthCheckResponse();
            switch (object.status) {
            case "UNKNOWN":
            case 0:
                message.status = 0;
                break;
            case "SERVING":
            case 1:
                message.status = 1;
                break;
            case "NOT_SERVING":
            case 2:
                message.status = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a HealthCheckResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.HealthCheckResponse} message HealthCheckResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HealthCheckResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "UNKNOWN" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.common.HealthCheckResponse.ServingStatus[message.status] : message.status;
            return object;
        };

        /**
         * Converts this HealthCheckResponse to JSON.
         * @function toJSON
         * @memberof common.HealthCheckResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HealthCheckResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * ServingStatus enum.
         * @name common.HealthCheckResponse.ServingStatus
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} SERVING=1 SERVING value
         * @property {number} NOT_SERVING=2 NOT_SERVING value
         */
        HealthCheckResponse.ServingStatus = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "SERVING"] = 1;
            values[valuesById[2] = "NOT_SERVING"] = 2;
            return values;
        })();

        return HealthCheckResponse;
    })();

    common.Date = (function() {

        /**
         * Properties of a Date.
         * @memberof common
         * @interface IDate
         * @property {number|null} [day] Date day
         * @property {number|null} [month] Date month
         * @property {number|null} [year] Date year
         */

        /**
         * Constructs a new Date.
         * @memberof common
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {common.IDate=} [properties] Properties to set
         */
        function Date(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Date day.
         * @member {number} day
         * @memberof common.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof common.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date year.
         * @member {number} year
         * @memberof common.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof common.Date
         * @static
         * @param {common.IDate=} [properties] Properties to set
         * @returns {common.Date} Date instance
         */
        Date.create = function create(properties) {
            return new Date(properties);
        };

        /**
         * Creates a Date message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Date
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Date} Date
         */
        Date.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Date)
                return object;
            let message = new $root.common.Date();
            if (object.day != null)
                message.day = object.day | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.year != null)
                message.year = object.year | 0;
            return message;
        };

        /**
         * Creates a plain object from a Date message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Date
         * @static
         * @param {common.Date} message Date
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Date.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.day = 0;
                object.month = 0;
                object.year = 0;
            }
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            return object;
        };

        /**
         * Converts this Date to JSON.
         * @function toJSON
         * @memberof common.Date
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Date.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Date;
    })();

    common.Address = (function() {

        /**
         * Properties of an Address.
         * @memberof common
         * @interface IAddress
         * @property {string|null} [houseNumber] Address houseNumber
         * @property {string|null} [roadNumber] Address roadNumber
         * @property {string|null} [sector] Address sector
         * @property {string|null} [postCode] Address postCode
         * @property {string|null} [policeStationCode] Address policeStationCode
         * @property {string|null} [districtCode] Address districtCode
         * @property {string|null} [countryCode] Address countryCode
         * @property {Array.<string>|null} [emails] Address emails
         * @property {Array.<common.Address.IPhoneNumber>|null} [phones] Address phones
         * @property {common.ILocation|null} [location] Address location
         */

        /**
         * Constructs a new Address.
         * @memberof common
         * @classdesc Represents an Address.
         * @implements IAddress
         * @constructor
         * @param {common.IAddress=} [properties] Properties to set
         */
        function Address(properties) {
            this.emails = [];
            this.phones = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Address houseNumber.
         * @member {string} houseNumber
         * @memberof common.Address
         * @instance
         */
        Address.prototype.houseNumber = "";

        /**
         * Address roadNumber.
         * @member {string} roadNumber
         * @memberof common.Address
         * @instance
         */
        Address.prototype.roadNumber = "";

        /**
         * Address sector.
         * @member {string} sector
         * @memberof common.Address
         * @instance
         */
        Address.prototype.sector = "";

        /**
         * Address postCode.
         * @member {string} postCode
         * @memberof common.Address
         * @instance
         */
        Address.prototype.postCode = "";

        /**
         * Address policeStationCode.
         * @member {string} policeStationCode
         * @memberof common.Address
         * @instance
         */
        Address.prototype.policeStationCode = "";

        /**
         * Address districtCode.
         * @member {string} districtCode
         * @memberof common.Address
         * @instance
         */
        Address.prototype.districtCode = "";

        /**
         * Address countryCode.
         * @member {string} countryCode
         * @memberof common.Address
         * @instance
         */
        Address.prototype.countryCode = "";

        /**
         * Address emails.
         * @member {Array.<string>} emails
         * @memberof common.Address
         * @instance
         */
        Address.prototype.emails = $util.emptyArray;

        /**
         * Address phones.
         * @member {Array.<common.Address.IPhoneNumber>} phones
         * @memberof common.Address
         * @instance
         */
        Address.prototype.phones = $util.emptyArray;

        /**
         * Address location.
         * @member {common.ILocation|null|undefined} location
         * @memberof common.Address
         * @instance
         */
        Address.prototype.location = null;

        /**
         * Creates a new Address instance using the specified properties.
         * @function create
         * @memberof common.Address
         * @static
         * @param {common.IAddress=} [properties] Properties to set
         * @returns {common.Address} Address instance
         */
        Address.create = function create(properties) {
            return new Address(properties);
        };

        /**
         * Creates an Address message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Address
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Address} Address
         */
        Address.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Address)
                return object;
            let message = new $root.common.Address();
            if (object.houseNumber != null)
                message.houseNumber = String(object.houseNumber);
            if (object.roadNumber != null)
                message.roadNumber = String(object.roadNumber);
            if (object.sector != null)
                message.sector = String(object.sector);
            if (object.postCode != null)
                message.postCode = String(object.postCode);
            if (object.policeStationCode != null)
                message.policeStationCode = String(object.policeStationCode);
            if (object.districtCode != null)
                message.districtCode = String(object.districtCode);
            if (object.countryCode != null)
                message.countryCode = String(object.countryCode);
            if (object.emails) {
                if (!Array.isArray(object.emails))
                    throw TypeError(".common.Address.emails: array expected");
                message.emails = [];
                for (let i = 0; i < object.emails.length; ++i)
                    message.emails[i] = String(object.emails[i]);
            }
            if (object.phones) {
                if (!Array.isArray(object.phones))
                    throw TypeError(".common.Address.phones: array expected");
                message.phones = [];
                for (let i = 0; i < object.phones.length; ++i) {
                    if (typeof object.phones[i] !== "object")
                        throw TypeError(".common.Address.phones: object expected");
                    message.phones[i] = $root.common.Address.PhoneNumber.fromObject(object.phones[i]);
                }
            }
            if (object.location != null) {
                if (typeof object.location !== "object")
                    throw TypeError(".common.Address.location: object expected");
                message.location = $root.common.Location.fromObject(object.location);
            }
            return message;
        };

        /**
         * Creates a plain object from an Address message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Address
         * @static
         * @param {common.Address} message Address
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Address.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.emails = [];
                object.phones = [];
            }
            if (options.defaults) {
                object.houseNumber = "";
                object.roadNumber = "";
                object.sector = "";
                object.postCode = "";
                object.policeStationCode = "";
                object.districtCode = "";
                object.countryCode = "";
                object.location = null;
            }
            if (message.houseNumber != null && message.hasOwnProperty("houseNumber"))
                object.houseNumber = message.houseNumber;
            if (message.roadNumber != null && message.hasOwnProperty("roadNumber"))
                object.roadNumber = message.roadNumber;
            if (message.sector != null && message.hasOwnProperty("sector"))
                object.sector = message.sector;
            if (message.postCode != null && message.hasOwnProperty("postCode"))
                object.postCode = message.postCode;
            if (message.policeStationCode != null && message.hasOwnProperty("policeStationCode"))
                object.policeStationCode = message.policeStationCode;
            if (message.districtCode != null && message.hasOwnProperty("districtCode"))
                object.districtCode = message.districtCode;
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                object.countryCode = message.countryCode;
            if (message.emails && message.emails.length) {
                object.emails = [];
                for (let j = 0; j < message.emails.length; ++j)
                    object.emails[j] = message.emails[j];
            }
            if (message.phones && message.phones.length) {
                object.phones = [];
                for (let j = 0; j < message.phones.length; ++j)
                    object.phones[j] = $root.common.Address.PhoneNumber.toObject(message.phones[j], options);
            }
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = $root.common.Location.toObject(message.location, options);
            return object;
        };

        /**
         * Converts this Address to JSON.
         * @function toJSON
         * @memberof common.Address
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Address.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * PhoneType enum.
         * @name common.Address.PhoneType
         * @enum {number}
         * @property {number} MOBILE=0 MOBILE value
         * @property {number} HOME=1 HOME value
         * @property {number} WORK=2 WORK value
         */
        Address.PhoneType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "MOBILE"] = 0;
            values[valuesById[1] = "HOME"] = 1;
            values[valuesById[2] = "WORK"] = 2;
            return values;
        })();

        Address.PhoneNumber = (function() {

            /**
             * Properties of a PhoneNumber.
             * @memberof common.Address
             * @interface IPhoneNumber
             * @property {string|null} [number] PhoneNumber number
             * @property {common.Address.PhoneType|null} [type] PhoneNumber type
             */

            /**
             * Constructs a new PhoneNumber.
             * @memberof common.Address
             * @classdesc Represents a PhoneNumber.
             * @implements IPhoneNumber
             * @constructor
             * @param {common.Address.IPhoneNumber=} [properties] Properties to set
             */
            function PhoneNumber(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PhoneNumber number.
             * @member {string} number
             * @memberof common.Address.PhoneNumber
             * @instance
             */
            PhoneNumber.prototype.number = "";

            /**
             * PhoneNumber type.
             * @member {common.Address.PhoneType} type
             * @memberof common.Address.PhoneNumber
             * @instance
             */
            PhoneNumber.prototype.type = 0;

            /**
             * Creates a new PhoneNumber instance using the specified properties.
             * @function create
             * @memberof common.Address.PhoneNumber
             * @static
             * @param {common.Address.IPhoneNumber=} [properties] Properties to set
             * @returns {common.Address.PhoneNumber} PhoneNumber instance
             */
            PhoneNumber.create = function create(properties) {
                return new PhoneNumber(properties);
            };

            /**
             * Creates a PhoneNumber message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof common.Address.PhoneNumber
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {common.Address.PhoneNumber} PhoneNumber
             */
            PhoneNumber.fromObject = function fromObject(object) {
                if (object instanceof $root.common.Address.PhoneNumber)
                    return object;
                let message = new $root.common.Address.PhoneNumber();
                if (object.number != null)
                    message.number = String(object.number);
                switch (object.type) {
                case "MOBILE":
                case 0:
                    message.type = 0;
                    break;
                case "HOME":
                case 1:
                    message.type = 1;
                    break;
                case "WORK":
                case 2:
                    message.type = 2;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a PhoneNumber message. Also converts values to other types if specified.
             * @function toObject
             * @memberof common.Address.PhoneNumber
             * @static
             * @param {common.Address.PhoneNumber} message PhoneNumber
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PhoneNumber.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.number = "";
                    object.type = options.enums === String ? "MOBILE" : 0;
                }
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.common.Address.PhoneType[message.type] : message.type;
                return object;
            };

            /**
             * Converts this PhoneNumber to JSON.
             * @function toJSON
             * @memberof common.Address.PhoneNumber
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PhoneNumber.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PhoneNumber;
        })();

        return Address;
    })();

    common.Location = (function() {

        /**
         * Properties of a Location.
         * @memberof common
         * @interface ILocation
         * @property {number|null} [latitude] Location latitude
         * @property {number|null} [longitude] Location longitude
         */

        /**
         * Constructs a new Location.
         * @memberof common
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {common.ILocation=} [properties] Properties to set
         */
        function Location(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Location latitude.
         * @member {number} latitude
         * @memberof common.Location
         * @instance
         */
        Location.prototype.latitude = 0;

        /**
         * Location longitude.
         * @member {number} longitude
         * @memberof common.Location
         * @instance
         */
        Location.prototype.longitude = 0;

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof common.Location
         * @static
         * @param {common.ILocation=} [properties] Properties to set
         * @returns {common.Location} Location instance
         */
        Location.create = function create(properties) {
            return new Location(properties);
        };

        /**
         * Creates a Location message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Location
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Location} Location
         */
        Location.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Location)
                return object;
            let message = new $root.common.Location();
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            return message;
        };

        /**
         * Creates a plain object from a Location message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Location
         * @static
         * @param {common.Location} message Location
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Location.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.latitude = 0;
                object.longitude = 0;
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            return object;
        };

        /**
         * Converts this Location to JSON.
         * @function toJSON
         * @memberof common.Location
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Location;
    })();

    common.Currency = (function() {

        /**
         * Properties of a Currency.
         * @memberof common
         * @interface ICurrency
         */

        /**
         * Constructs a new Currency.
         * @memberof common
         * @classdesc Represents a Currency.
         * @implements ICurrency
         * @constructor
         * @param {common.ICurrency=} [properties] Properties to set
         */
        function Currency(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Currency instance using the specified properties.
         * @function create
         * @memberof common.Currency
         * @static
         * @param {common.ICurrency=} [properties] Properties to set
         * @returns {common.Currency} Currency instance
         */
        Currency.create = function create(properties) {
            return new Currency(properties);
        };

        /**
         * Creates a Currency message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Currency
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Currency} Currency
         */
        Currency.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Currency)
                return object;
            return new $root.common.Currency();
        };

        /**
         * Creates a plain object from a Currency message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Currency
         * @static
         * @param {common.Currency} message Currency
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Currency.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Currency to JSON.
         * @function toJSON
         * @memberof common.Currency
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Currency.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.Currency.Enum
         * @enum {number}
         * @property {number} BDT=0 BDT value
         * @property {number} GBP=1 GBP value
         * @property {number} USD=2 USD value
         * @property {number} RS=3 RS value
         */
        Currency.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BDT"] = 0;
            values[valuesById[1] = "GBP"] = 1;
            values[valuesById[2] = "USD"] = 2;
            values[valuesById[3] = "RS"] = 3;
            return values;
        })();

        return Currency;
    })();

    common.Language = (function() {

        /**
         * Properties of a Language.
         * @memberof common
         * @interface ILanguage
         */

        /**
         * Constructs a new Language.
         * @memberof common
         * @classdesc Represents a Language.
         * @implements ILanguage
         * @constructor
         * @param {common.ILanguage=} [properties] Properties to set
         */
        function Language(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Language instance using the specified properties.
         * @function create
         * @memberof common.Language
         * @static
         * @param {common.ILanguage=} [properties] Properties to set
         * @returns {common.Language} Language instance
         */
        Language.create = function create(properties) {
            return new Language(properties);
        };

        /**
         * Creates a Language message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Language
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Language} Language
         */
        Language.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Language)
                return object;
            return new $root.common.Language();
        };

        /**
         * Creates a plain object from a Language message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Language
         * @static
         * @param {common.Language} message Language
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Language.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Language to JSON.
         * @function toJSON
         * @memberof common.Language
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Language.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.Language.Enum
         * @enum {number}
         * @property {number} EN=0 EN value
         * @property {number} BN=1 BN value
         * @property {number} HI=2 HI value
         * @property {number} TE=3 TE value
         * @property {number} TA=4 TA value
         * @property {number} AR=5 AR value
         * @property {number} KO=6 KO value
         * @property {number} ZH=7 ZH value
         * @property {number} JA=8 JA value
         * @property {number} UNKNOWN=9 UNKNOWN value
         * @property {number} ALL=10 ALL value
         */
        Language.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EN"] = 0;
            values[valuesById[1] = "BN"] = 1;
            values[valuesById[2] = "HI"] = 2;
            values[valuesById[3] = "TE"] = 3;
            values[valuesById[4] = "TA"] = 4;
            values[valuesById[5] = "AR"] = 5;
            values[valuesById[6] = "KO"] = 6;
            values[valuesById[7] = "ZH"] = 7;
            values[valuesById[8] = "JA"] = 8;
            values[valuesById[9] = "UNKNOWN"] = 9;
            values[valuesById[10] = "ALL"] = 10;
            return values;
        })();

        return Language;
    })();

    common.Region = (function() {

        /**
         * Properties of a Region.
         * @memberof common
         * @interface IRegion
         */

        /**
         * Constructs a new Region.
         * @memberof common
         * @classdesc Represents a Region.
         * @implements IRegion
         * @constructor
         * @param {common.IRegion=} [properties] Properties to set
         */
        function Region(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Region instance using the specified properties.
         * @function create
         * @memberof common.Region
         * @static
         * @param {common.IRegion=} [properties] Properties to set
         * @returns {common.Region} Region instance
         */
        Region.create = function create(properties) {
            return new Region(properties);
        };

        /**
         * Creates a Region message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Region
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Region} Region
         */
        Region.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Region)
                return object;
            return new $root.common.Region();
        };

        /**
         * Creates a plain object from a Region message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Region
         * @static
         * @param {common.Region} message Region
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Region.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Region to JSON.
         * @function toJSON
         * @memberof common.Region
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Region.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.Region.Enum
         * @enum {number}
         * @property {number} GLOBAL=0 GLOBAL value
         * @property {number} BANGLADESH=1 BANGLADESH value
         * @property {number} INDIA=2 INDIA value
         * @property {number} UNITED_KINGDOM=3 UNITED_KINGDOM value
         * @property {number} UNITED_STATES=4 UNITED_STATES value
         * @property {number} CHINA=5 CHINA value
         * @property {number} RUSSIA=6 RUSSIA value
         * @property {number} MIDDLE_EAST=7 MIDDLE_EAST value
         * @property {number} EUROPE=8 EUROPE value
         */
        Region.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "GLOBAL"] = 0;
            values[valuesById[1] = "BANGLADESH"] = 1;
            values[valuesById[2] = "INDIA"] = 2;
            values[valuesById[3] = "UNITED_KINGDOM"] = 3;
            values[valuesById[4] = "UNITED_STATES"] = 4;
            values[valuesById[5] = "CHINA"] = 5;
            values[valuesById[6] = "RUSSIA"] = 6;
            values[valuesById[7] = "MIDDLE_EAST"] = 7;
            values[valuesById[8] = "EUROPE"] = 8;
            return values;
        })();

        return Region;
    })();

    common.EnvironmentType = (function() {

        /**
         * Properties of an EnvironmentType.
         * @memberof common
         * @interface IEnvironmentType
         */

        /**
         * Constructs a new EnvironmentType.
         * @memberof common
         * @classdesc Represents an EnvironmentType.
         * @implements IEnvironmentType
         * @constructor
         * @param {common.IEnvironmentType=} [properties] Properties to set
         */
        function EnvironmentType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EnvironmentType instance using the specified properties.
         * @function create
         * @memberof common.EnvironmentType
         * @static
         * @param {common.IEnvironmentType=} [properties] Properties to set
         * @returns {common.EnvironmentType} EnvironmentType instance
         */
        EnvironmentType.create = function create(properties) {
            return new EnvironmentType(properties);
        };

        /**
         * Creates an EnvironmentType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.EnvironmentType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.EnvironmentType} EnvironmentType
         */
        EnvironmentType.fromObject = function fromObject(object) {
            if (object instanceof $root.common.EnvironmentType)
                return object;
            return new $root.common.EnvironmentType();
        };

        /**
         * Creates a plain object from an EnvironmentType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.EnvironmentType
         * @static
         * @param {common.EnvironmentType} message EnvironmentType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnvironmentType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EnvironmentType to JSON.
         * @function toJSON
         * @memberof common.EnvironmentType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnvironmentType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.EnvironmentType.Enum
         * @enum {number}
         * @property {number} DEV=0 DEV value
         * @property {number} CANARY=1 CANARY value
         * @property {number} PROD=2 PROD value
         */
        EnvironmentType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DEV"] = 0;
            values[valuesById[1] = "CANARY"] = 1;
            values[valuesById[2] = "PROD"] = 2;
            return values;
        })();

        return EnvironmentType;
    })();

    common.DeviceInfo = (function() {

        /**
         * Properties of a DeviceInfo.
         * @memberof common
         * @interface IDeviceInfo
         * @property {common.DeviceType.Enum|null} [deviceType] DeviceInfo deviceType
         * @property {common.IDeviceDimension|null} [dimension] DeviceInfo dimension
         * @property {common.IDeviceOrientationMode|null} [orientationMode] DeviceInfo orientationMode
         */

        /**
         * Constructs a new DeviceInfo.
         * @memberof common
         * @classdesc Represents a DeviceInfo.
         * @implements IDeviceInfo
         * @constructor
         * @param {common.IDeviceInfo=} [properties] Properties to set
         */
        function DeviceInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceInfo deviceType.
         * @member {common.DeviceType.Enum} deviceType
         * @memberof common.DeviceInfo
         * @instance
         */
        DeviceInfo.prototype.deviceType = 0;

        /**
         * DeviceInfo dimension.
         * @member {common.IDeviceDimension|null|undefined} dimension
         * @memberof common.DeviceInfo
         * @instance
         */
        DeviceInfo.prototype.dimension = null;

        /**
         * DeviceInfo orientationMode.
         * @member {common.IDeviceOrientationMode|null|undefined} orientationMode
         * @memberof common.DeviceInfo
         * @instance
         */
        DeviceInfo.prototype.orientationMode = null;

        /**
         * Creates a new DeviceInfo instance using the specified properties.
         * @function create
         * @memberof common.DeviceInfo
         * @static
         * @param {common.IDeviceInfo=} [properties] Properties to set
         * @returns {common.DeviceInfo} DeviceInfo instance
         */
        DeviceInfo.create = function create(properties) {
            return new DeviceInfo(properties);
        };

        /**
         * Creates a DeviceInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DeviceInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DeviceInfo} DeviceInfo
         */
        DeviceInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DeviceInfo)
                return object;
            let message = new $root.common.DeviceInfo();
            switch (object.deviceType) {
            case "DESKTOP":
            case 0:
                message.deviceType = 0;
                break;
            case "MOBILE_WEB":
            case 1:
                message.deviceType = 1;
                break;
            case "MOBILE_ANDROID":
            case 2:
                message.deviceType = 2;
                break;
            case "MOBILE_IOS":
            case 3:
                message.deviceType = 3;
                break;
            case "MOBILE":
            case 4:
                message.deviceType = 4;
                break;
            case "TABLET":
            case 5:
                message.deviceType = 5;
                break;
            }
            if (object.dimension != null) {
                if (typeof object.dimension !== "object")
                    throw TypeError(".common.DeviceInfo.dimension: object expected");
                message.dimension = $root.common.DeviceDimension.fromObject(object.dimension);
            }
            if (object.orientationMode != null) {
                if (typeof object.orientationMode !== "object")
                    throw TypeError(".common.DeviceInfo.orientationMode: object expected");
                message.orientationMode = $root.common.DeviceOrientationMode.fromObject(object.orientationMode);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DeviceInfo
         * @static
         * @param {common.DeviceInfo} message DeviceInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.deviceType = options.enums === String ? "DESKTOP" : 0;
                object.dimension = null;
                object.orientationMode = null;
            }
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.common.DeviceType.Enum[message.deviceType] : message.deviceType;
            if (message.dimension != null && message.hasOwnProperty("dimension"))
                object.dimension = $root.common.DeviceDimension.toObject(message.dimension, options);
            if (message.orientationMode != null && message.hasOwnProperty("orientationMode"))
                object.orientationMode = $root.common.DeviceOrientationMode.toObject(message.orientationMode, options);
            return object;
        };

        /**
         * Converts this DeviceInfo to JSON.
         * @function toJSON
         * @memberof common.DeviceInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceInfo;
    })();

    common.DeviceType = (function() {

        /**
         * Properties of a DeviceType.
         * @memberof common
         * @interface IDeviceType
         */

        /**
         * Constructs a new DeviceType.
         * @memberof common
         * @classdesc Represents a DeviceType.
         * @implements IDeviceType
         * @constructor
         * @param {common.IDeviceType=} [properties] Properties to set
         */
        function DeviceType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeviceType instance using the specified properties.
         * @function create
         * @memberof common.DeviceType
         * @static
         * @param {common.IDeviceType=} [properties] Properties to set
         * @returns {common.DeviceType} DeviceType instance
         */
        DeviceType.create = function create(properties) {
            return new DeviceType(properties);
        };

        /**
         * Creates a DeviceType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DeviceType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DeviceType} DeviceType
         */
        DeviceType.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DeviceType)
                return object;
            return new $root.common.DeviceType();
        };

        /**
         * Creates a plain object from a DeviceType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DeviceType
         * @static
         * @param {common.DeviceType} message DeviceType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeviceType to JSON.
         * @function toJSON
         * @memberof common.DeviceType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.DeviceType.Enum
         * @enum {number}
         * @property {number} DESKTOP=0 DESKTOP value
         * @property {number} MOBILE_WEB=1 MOBILE_WEB value
         * @property {number} MOBILE_ANDROID=2 MOBILE_ANDROID value
         * @property {number} MOBILE_IOS=3 MOBILE_IOS value
         * @property {number} MOBILE=4 MOBILE value
         * @property {number} TABLET=5 TABLET value
         */
        DeviceType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DESKTOP"] = 0;
            values[valuesById[1] = "MOBILE_WEB"] = 1;
            values[valuesById[2] = "MOBILE_ANDROID"] = 2;
            values[valuesById[3] = "MOBILE_IOS"] = 3;
            values[valuesById[4] = "MOBILE"] = 4;
            values[valuesById[5] = "TABLET"] = 5;
            return values;
        })();

        return DeviceType;
    })();

    common.DeviceOrientationMode = (function() {

        /**
         * Properties of a DeviceOrientationMode.
         * @memberof common
         * @interface IDeviceOrientationMode
         */

        /**
         * Constructs a new DeviceOrientationMode.
         * @memberof common
         * @classdesc Represents a DeviceOrientationMode.
         * @implements IDeviceOrientationMode
         * @constructor
         * @param {common.IDeviceOrientationMode=} [properties] Properties to set
         */
        function DeviceOrientationMode(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeviceOrientationMode instance using the specified properties.
         * @function create
         * @memberof common.DeviceOrientationMode
         * @static
         * @param {common.IDeviceOrientationMode=} [properties] Properties to set
         * @returns {common.DeviceOrientationMode} DeviceOrientationMode instance
         */
        DeviceOrientationMode.create = function create(properties) {
            return new DeviceOrientationMode(properties);
        };

        /**
         * Creates a DeviceOrientationMode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DeviceOrientationMode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DeviceOrientationMode} DeviceOrientationMode
         */
        DeviceOrientationMode.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DeviceOrientationMode)
                return object;
            return new $root.common.DeviceOrientationMode();
        };

        /**
         * Creates a plain object from a DeviceOrientationMode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DeviceOrientationMode
         * @static
         * @param {common.DeviceOrientationMode} message DeviceOrientationMode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceOrientationMode.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeviceOrientationMode to JSON.
         * @function toJSON
         * @memberof common.DeviceOrientationMode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceOrientationMode.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.DeviceOrientationMode.Enum
         * @enum {number}
         * @property {number} PORTRAIT=0 PORTRAIT value
         * @property {number} LANDSCAPE=1 LANDSCAPE value
         */
        DeviceOrientationMode.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PORTRAIT"] = 0;
            values[valuesById[1] = "LANDSCAPE"] = 1;
            return values;
        })();

        return DeviceOrientationMode;
    })();

    common.DeviceDimension = (function() {

        /**
         * Properties of a DeviceDimension.
         * @memberof common
         * @interface IDeviceDimension
         * @property {number|null} [widthPx] DeviceDimension widthPx
         * @property {number|null} [heightPx] DeviceDimension heightPx
         */

        /**
         * Constructs a new DeviceDimension.
         * @memberof common
         * @classdesc Represents a DeviceDimension.
         * @implements IDeviceDimension
         * @constructor
         * @param {common.IDeviceDimension=} [properties] Properties to set
         */
        function DeviceDimension(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceDimension widthPx.
         * @member {number} widthPx
         * @memberof common.DeviceDimension
         * @instance
         */
        DeviceDimension.prototype.widthPx = 0;

        /**
         * DeviceDimension heightPx.
         * @member {number} heightPx
         * @memberof common.DeviceDimension
         * @instance
         */
        DeviceDimension.prototype.heightPx = 0;

        /**
         * Creates a new DeviceDimension instance using the specified properties.
         * @function create
         * @memberof common.DeviceDimension
         * @static
         * @param {common.IDeviceDimension=} [properties] Properties to set
         * @returns {common.DeviceDimension} DeviceDimension instance
         */
        DeviceDimension.create = function create(properties) {
            return new DeviceDimension(properties);
        };

        /**
         * Creates a DeviceDimension message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DeviceDimension
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DeviceDimension} DeviceDimension
         */
        DeviceDimension.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DeviceDimension)
                return object;
            let message = new $root.common.DeviceDimension();
            if (object.widthPx != null)
                message.widthPx = object.widthPx | 0;
            if (object.heightPx != null)
                message.heightPx = object.heightPx | 0;
            return message;
        };

        /**
         * Creates a plain object from a DeviceDimension message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DeviceDimension
         * @static
         * @param {common.DeviceDimension} message DeviceDimension
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceDimension.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.widthPx = 0;
                object.heightPx = 0;
            }
            if (message.widthPx != null && message.hasOwnProperty("widthPx"))
                object.widthPx = message.widthPx;
            if (message.heightPx != null && message.hasOwnProperty("heightPx"))
                object.heightPx = message.heightPx;
            return object;
        };

        /**
         * Converts this DeviceDimension to JSON.
         * @function toJSON
         * @memberof common.DeviceDimension
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceDimension.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceDimension;
    })();

    common.ResponseCode = (function() {

        /**
         * Properties of a ResponseCode.
         * @memberof common
         * @interface IResponseCode
         */

        /**
         * Constructs a new ResponseCode.
         * @memberof common
         * @classdesc Represents a ResponseCode.
         * @implements IResponseCode
         * @constructor
         * @param {common.IResponseCode=} [properties] Properties to set
         */
        function ResponseCode(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ResponseCode instance using the specified properties.
         * @function create
         * @memberof common.ResponseCode
         * @static
         * @param {common.IResponseCode=} [properties] Properties to set
         * @returns {common.ResponseCode} ResponseCode instance
         */
        ResponseCode.create = function create(properties) {
            return new ResponseCode(properties);
        };

        /**
         * Creates a ResponseCode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.ResponseCode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.ResponseCode} ResponseCode
         */
        ResponseCode.fromObject = function fromObject(object) {
            if (object instanceof $root.common.ResponseCode)
                return object;
            return new $root.common.ResponseCode();
        };

        /**
         * Creates a plain object from a ResponseCode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.ResponseCode
         * @static
         * @param {common.ResponseCode} message ResponseCode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseCode.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ResponseCode to JSON.
         * @function toJSON
         * @memberof common.ResponseCode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseCode.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name common.ResponseCode.Enum
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} SUCCESS=1 SUCCESS value
         * @property {number} AUTH_TOKEN_INVALID=2 AUTH_TOKEN_INVALID value
         * @property {number} AUTH_HAS_NO_PERMISSION=3 AUTH_HAS_NO_PERMISSION value
         * @property {number} INPUT_INVALID=4 INPUT_INVALID value
         * @property {number} RESOURCE_NOT_FOUND=5 RESOURCE_NOT_FOUND value
         */
        ResponseCode.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "SUCCESS"] = 1;
            values[valuesById[2] = "AUTH_TOKEN_INVALID"] = 2;
            values[valuesById[3] = "AUTH_HAS_NO_PERMISSION"] = 3;
            values[valuesById[4] = "INPUT_INVALID"] = 4;
            values[valuesById[5] = "RESOURCE_NOT_FOUND"] = 5;
            return values;
        })();

        return ResponseCode;
    })();

    common.Response = (function() {

        /**
         * Properties of a Response.
         * @memberof common
         * @interface IResponse
         * @property {boolean|null} [success] Response success
         * @property {string|null} [message] Response message
         * @property {number|null} [statusCode] Response statusCode
         */

        /**
         * Constructs a new Response.
         * @memberof common
         * @classdesc Represents a Response.
         * @implements IResponse
         * @constructor
         * @param {common.IResponse=} [properties] Properties to set
         */
        function Response(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Response success.
         * @member {boolean} success
         * @memberof common.Response
         * @instance
         */
        Response.prototype.success = false;

        /**
         * Response message.
         * @member {string} message
         * @memberof common.Response
         * @instance
         */
        Response.prototype.message = "";

        /**
         * Response statusCode.
         * @member {number} statusCode
         * @memberof common.Response
         * @instance
         */
        Response.prototype.statusCode = 0;

        /**
         * Creates a new Response instance using the specified properties.
         * @function create
         * @memberof common.Response
         * @static
         * @param {common.IResponse=} [properties] Properties to set
         * @returns {common.Response} Response instance
         */
        Response.create = function create(properties) {
            return new Response(properties);
        };

        /**
         * Creates a Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Response} Response
         */
        Response.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Response)
                return object;
            let message = new $root.common.Response();
            if (object.success != null)
                message.success = Boolean(object.success);
            if (object.message != null)
                message.message = String(object.message);
            if (object.statusCode != null)
                message.statusCode = object.statusCode | 0;
            return message;
        };

        /**
         * Creates a plain object from a Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Response
         * @static
         * @param {common.Response} message Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.success = false;
                object.message = "";
                object.statusCode = 0;
            }
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                object.statusCode = message.statusCode;
            return object;
        };

        /**
         * Converts this Response to JSON.
         * @function toJSON
         * @memberof common.Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Response;
    })();

    common.EmptyRequest = (function() {

        /**
         * Properties of an EmptyRequest.
         * @memberof common
         * @interface IEmptyRequest
         */

        /**
         * Constructs a new EmptyRequest.
         * @memberof common
         * @classdesc Represents an EmptyRequest.
         * @implements IEmptyRequest
         * @constructor
         * @param {common.IEmptyRequest=} [properties] Properties to set
         */
        function EmptyRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EmptyRequest instance using the specified properties.
         * @function create
         * @memberof common.EmptyRequest
         * @static
         * @param {common.IEmptyRequest=} [properties] Properties to set
         * @returns {common.EmptyRequest} EmptyRequest instance
         */
        EmptyRequest.create = function create(properties) {
            return new EmptyRequest(properties);
        };

        /**
         * Creates an EmptyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.EmptyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.EmptyRequest} EmptyRequest
         */
        EmptyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.common.EmptyRequest)
                return object;
            return new $root.common.EmptyRequest();
        };

        /**
         * Creates a plain object from an EmptyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.EmptyRequest
         * @static
         * @param {common.EmptyRequest} message EmptyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EmptyRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EmptyRequest to JSON.
         * @function toJSON
         * @memberof common.EmptyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EmptyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EmptyRequest;
    })();

    common.EmptyResponse = (function() {

        /**
         * Properties of an EmptyResponse.
         * @memberof common
         * @interface IEmptyResponse
         */

        /**
         * Constructs a new EmptyResponse.
         * @memberof common
         * @classdesc Represents an EmptyResponse.
         * @implements IEmptyResponse
         * @constructor
         * @param {common.IEmptyResponse=} [properties] Properties to set
         */
        function EmptyResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EmptyResponse instance using the specified properties.
         * @function create
         * @memberof common.EmptyResponse
         * @static
         * @param {common.IEmptyResponse=} [properties] Properties to set
         * @returns {common.EmptyResponse} EmptyResponse instance
         */
        EmptyResponse.create = function create(properties) {
            return new EmptyResponse(properties);
        };

        /**
         * Creates an EmptyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.EmptyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.EmptyResponse} EmptyResponse
         */
        EmptyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.common.EmptyResponse)
                return object;
            return new $root.common.EmptyResponse();
        };

        /**
         * Creates a plain object from an EmptyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.EmptyResponse
         * @static
         * @param {common.EmptyResponse} message EmptyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EmptyResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EmptyResponse to JSON.
         * @function toJSON
         * @memberof common.EmptyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EmptyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EmptyResponse;
    })();

    return common;
})();

export const auth = $root.auth = (() => {

    /**
     * Namespace auth.
     * @exports auth
     * @namespace
     */
    const auth = {};

    auth.AuthCredential = (function() {

        /**
         * Properties of an AuthCredential.
         * @memberof auth
         * @interface IAuthCredential
         * @property {number|Long|null} [userId] AuthCredential userId
         * @property {number|null} [userVersion] AuthCredential userVersion
         * @property {auth.DomainName.Enum|null} [domain] AuthCredential domain
         * @property {auth.SignInType.Enum|null} [signInType] AuthCredential signInType
         * @property {auth.UserRole.Enum|null} [userRole] AuthCredential userRole
         * @property {auth.KeyType.Enum|null} [keyType] AuthCredential keyType
         * @property {string|null} [jwtToken] AuthCredential jwtToken
         * @property {string|null} [secretToken] AuthCredential secretToken
         * @property {string|null} [apiKey] AuthCredential apiKey
         * @property {number|Long|null} [tokenCreatedTime] AuthCredential tokenCreatedTime
         * @property {number|Long|null} [tokenExpiredTime] AuthCredential tokenExpiredTime
         * @property {string|null} [refreshToken] AuthCredential refreshToken
         * @property {number|Long|null} [refreshTokenExpiredTime] AuthCredential refreshTokenExpiredTime
         * @property {string|null} [jwtAlgorithm] AuthCredential jwtAlgorithm
         * @property {common.DeviceType.Enum|null} [deviceType] AuthCredential deviceType
         * @property {string|null} [deviceId] AuthCredential deviceId
         * @property {number|null} [authApiVersionCode] AuthCredential authApiVersionCode
         */

        /**
         * Constructs a new AuthCredential.
         * @memberof auth
         * @classdesc Represents an AuthCredential.
         * @implements IAuthCredential
         * @constructor
         * @param {auth.IAuthCredential=} [properties] Properties to set
         */
        function AuthCredential(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuthCredential userId.
         * @member {number|Long} userId
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuthCredential userVersion.
         * @member {number} userVersion
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.userVersion = 0;

        /**
         * AuthCredential domain.
         * @member {auth.DomainName.Enum} domain
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.domain = 0;

        /**
         * AuthCredential signInType.
         * @member {auth.SignInType.Enum} signInType
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.signInType = 0;

        /**
         * AuthCredential userRole.
         * @member {auth.UserRole.Enum} userRole
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.userRole = 0;

        /**
         * AuthCredential keyType.
         * @member {auth.KeyType.Enum} keyType
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.keyType = 0;

        /**
         * AuthCredential jwtToken.
         * @member {string} jwtToken
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.jwtToken = "";

        /**
         * AuthCredential secretToken.
         * @member {string} secretToken
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.secretToken = "";

        /**
         * AuthCredential apiKey.
         * @member {string} apiKey
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.apiKey = "";

        /**
         * AuthCredential tokenCreatedTime.
         * @member {number|Long} tokenCreatedTime
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.tokenCreatedTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuthCredential tokenExpiredTime.
         * @member {number|Long} tokenExpiredTime
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.tokenExpiredTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuthCredential refreshToken.
         * @member {string} refreshToken
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.refreshToken = "";

        /**
         * AuthCredential refreshTokenExpiredTime.
         * @member {number|Long} refreshTokenExpiredTime
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.refreshTokenExpiredTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuthCredential jwtAlgorithm.
         * @member {string} jwtAlgorithm
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.jwtAlgorithm = "";

        /**
         * AuthCredential deviceType.
         * @member {common.DeviceType.Enum} deviceType
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.deviceType = 0;

        /**
         * AuthCredential deviceId.
         * @member {string} deviceId
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.deviceId = "";

        /**
         * AuthCredential authApiVersionCode.
         * @member {number} authApiVersionCode
         * @memberof auth.AuthCredential
         * @instance
         */
        AuthCredential.prototype.authApiVersionCode = 0;

        /**
         * Creates a new AuthCredential instance using the specified properties.
         * @function create
         * @memberof auth.AuthCredential
         * @static
         * @param {auth.IAuthCredential=} [properties] Properties to set
         * @returns {auth.AuthCredential} AuthCredential instance
         */
        AuthCredential.create = function create(properties) {
            return new AuthCredential(properties);
        };

        /**
         * Creates an AuthCredential message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.AuthCredential
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.AuthCredential} AuthCredential
         */
        AuthCredential.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.AuthCredential)
                return object;
            let message = new $root.auth.AuthCredential();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.userVersion != null)
                message.userVersion = object.userVersion | 0;
            switch (object.domain) {
            case "DUNGULIE":
            case 0:
                message.domain = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domain = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domain = 2;
                break;
            case "TIMELY":
            case 3:
                message.domain = 3;
                break;
            }
            switch (object.signInType) {
            case "EMAIL_PASS":
            case 0:
                message.signInType = 0;
                break;
            case "USERNAME_PASS":
            case 1:
                message.signInType = 1;
                break;
            case "FACEBOOK":
            case 2:
                message.signInType = 2;
                break;
            case "GOOGLE":
            case 3:
                message.signInType = 3;
                break;
            case "PHONE":
            case 4:
                message.signInType = 4;
                break;
            case "FIREBASE":
            case 5:
                message.signInType = 5;
                break;
            case "GITHUB":
            case 6:
                message.signInType = 6;
                break;
            case "API_KEY":
            case 7:
                message.signInType = 7;
                break;
            case "ANONYMOUS":
            case 8:
                message.signInType = 8;
                break;
            }
            switch (object.userRole) {
            case "GENERAL":
            case 0:
                message.userRole = 0;
                break;
            case "MODERATOR":
            case 1:
                message.userRole = 1;
                break;
            case "ADMIN":
            case 2:
                message.userRole = 2;
                break;
            case "SUPER_ADMIN":
            case 3:
                message.userRole = 3;
                break;
            case "OWNER":
            case 4:
                message.userRole = 4;
                break;
            }
            switch (object.keyType) {
            case "JWT":
            case 0:
                message.keyType = 0;
                break;
            case "SECRET_KEY":
            case 1:
                message.keyType = 1;
                break;
            case "API_KEY":
            case 2:
                message.keyType = 2;
                break;
            }
            if (object.jwtToken != null)
                message.jwtToken = String(object.jwtToken);
            if (object.secretToken != null)
                message.secretToken = String(object.secretToken);
            if (object.apiKey != null)
                message.apiKey = String(object.apiKey);
            if (object.tokenCreatedTime != null)
                if ($util.Long)
                    (message.tokenCreatedTime = $util.Long.fromValue(object.tokenCreatedTime)).unsigned = false;
                else if (typeof object.tokenCreatedTime === "string")
                    message.tokenCreatedTime = parseInt(object.tokenCreatedTime, 10);
                else if (typeof object.tokenCreatedTime === "number")
                    message.tokenCreatedTime = object.tokenCreatedTime;
                else if (typeof object.tokenCreatedTime === "object")
                    message.tokenCreatedTime = new $util.LongBits(object.tokenCreatedTime.low >>> 0, object.tokenCreatedTime.high >>> 0).toNumber();
            if (object.tokenExpiredTime != null)
                if ($util.Long)
                    (message.tokenExpiredTime = $util.Long.fromValue(object.tokenExpiredTime)).unsigned = false;
                else if (typeof object.tokenExpiredTime === "string")
                    message.tokenExpiredTime = parseInt(object.tokenExpiredTime, 10);
                else if (typeof object.tokenExpiredTime === "number")
                    message.tokenExpiredTime = object.tokenExpiredTime;
                else if (typeof object.tokenExpiredTime === "object")
                    message.tokenExpiredTime = new $util.LongBits(object.tokenExpiredTime.low >>> 0, object.tokenExpiredTime.high >>> 0).toNumber();
            if (object.refreshToken != null)
                message.refreshToken = String(object.refreshToken);
            if (object.refreshTokenExpiredTime != null)
                if ($util.Long)
                    (message.refreshTokenExpiredTime = $util.Long.fromValue(object.refreshTokenExpiredTime)).unsigned = false;
                else if (typeof object.refreshTokenExpiredTime === "string")
                    message.refreshTokenExpiredTime = parseInt(object.refreshTokenExpiredTime, 10);
                else if (typeof object.refreshTokenExpiredTime === "number")
                    message.refreshTokenExpiredTime = object.refreshTokenExpiredTime;
                else if (typeof object.refreshTokenExpiredTime === "object")
                    message.refreshTokenExpiredTime = new $util.LongBits(object.refreshTokenExpiredTime.low >>> 0, object.refreshTokenExpiredTime.high >>> 0).toNumber();
            if (object.jwtAlgorithm != null)
                message.jwtAlgorithm = String(object.jwtAlgorithm);
            switch (object.deviceType) {
            case "DESKTOP":
            case 0:
                message.deviceType = 0;
                break;
            case "MOBILE_WEB":
            case 1:
                message.deviceType = 1;
                break;
            case "MOBILE_ANDROID":
            case 2:
                message.deviceType = 2;
                break;
            case "MOBILE_IOS":
            case 3:
                message.deviceType = 3;
                break;
            case "MOBILE":
            case 4:
                message.deviceType = 4;
                break;
            case "TABLET":
            case 5:
                message.deviceType = 5;
                break;
            }
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.authApiVersionCode != null)
                message.authApiVersionCode = object.authApiVersionCode | 0;
            return message;
        };

        /**
         * Creates a plain object from an AuthCredential message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.AuthCredential
         * @static
         * @param {auth.AuthCredential} message AuthCredential
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuthCredential.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.userVersion = 0;
                object.domain = options.enums === String ? "DUNGULIE" : 0;
                object.signInType = options.enums === String ? "EMAIL_PASS" : 0;
                object.userRole = options.enums === String ? "GENERAL" : 0;
                object.keyType = options.enums === String ? "JWT" : 0;
                object.jwtToken = "";
                object.secretToken = "";
                object.apiKey = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.tokenCreatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.tokenCreatedTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.tokenExpiredTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.tokenExpiredTime = options.longs === String ? "0" : 0;
                object.refreshToken = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.refreshTokenExpiredTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.refreshTokenExpiredTime = options.longs === String ? "0" : 0;
                object.jwtAlgorithm = "";
                object.deviceType = options.enums === String ? "DESKTOP" : 0;
                object.deviceId = "";
                object.authApiVersionCode = 0;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.userVersion != null && message.hasOwnProperty("userVersion"))
                object.userVersion = message.userVersion;
            if (message.domain != null && message.hasOwnProperty("domain"))
                object.domain = options.enums === String ? $root.auth.DomainName.Enum[message.domain] : message.domain;
            if (message.signInType != null && message.hasOwnProperty("signInType"))
                object.signInType = options.enums === String ? $root.auth.SignInType.Enum[message.signInType] : message.signInType;
            if (message.userRole != null && message.hasOwnProperty("userRole"))
                object.userRole = options.enums === String ? $root.auth.UserRole.Enum[message.userRole] : message.userRole;
            if (message.keyType != null && message.hasOwnProperty("keyType"))
                object.keyType = options.enums === String ? $root.auth.KeyType.Enum[message.keyType] : message.keyType;
            if (message.jwtToken != null && message.hasOwnProperty("jwtToken"))
                object.jwtToken = message.jwtToken;
            if (message.secretToken != null && message.hasOwnProperty("secretToken"))
                object.secretToken = message.secretToken;
            if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                object.apiKey = message.apiKey;
            if (message.tokenCreatedTime != null && message.hasOwnProperty("tokenCreatedTime"))
                if (typeof message.tokenCreatedTime === "number")
                    object.tokenCreatedTime = options.longs === String ? String(message.tokenCreatedTime) : message.tokenCreatedTime;
                else
                    object.tokenCreatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.tokenCreatedTime) : options.longs === Number ? new $util.LongBits(message.tokenCreatedTime.low >>> 0, message.tokenCreatedTime.high >>> 0).toNumber() : message.tokenCreatedTime;
            if (message.tokenExpiredTime != null && message.hasOwnProperty("tokenExpiredTime"))
                if (typeof message.tokenExpiredTime === "number")
                    object.tokenExpiredTime = options.longs === String ? String(message.tokenExpiredTime) : message.tokenExpiredTime;
                else
                    object.tokenExpiredTime = options.longs === String ? $util.Long.prototype.toString.call(message.tokenExpiredTime) : options.longs === Number ? new $util.LongBits(message.tokenExpiredTime.low >>> 0, message.tokenExpiredTime.high >>> 0).toNumber() : message.tokenExpiredTime;
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                object.refreshToken = message.refreshToken;
            if (message.refreshTokenExpiredTime != null && message.hasOwnProperty("refreshTokenExpiredTime"))
                if (typeof message.refreshTokenExpiredTime === "number")
                    object.refreshTokenExpiredTime = options.longs === String ? String(message.refreshTokenExpiredTime) : message.refreshTokenExpiredTime;
                else
                    object.refreshTokenExpiredTime = options.longs === String ? $util.Long.prototype.toString.call(message.refreshTokenExpiredTime) : options.longs === Number ? new $util.LongBits(message.refreshTokenExpiredTime.low >>> 0, message.refreshTokenExpiredTime.high >>> 0).toNumber() : message.refreshTokenExpiredTime;
            if (message.jwtAlgorithm != null && message.hasOwnProperty("jwtAlgorithm"))
                object.jwtAlgorithm = message.jwtAlgorithm;
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.common.DeviceType.Enum[message.deviceType] : message.deviceType;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.authApiVersionCode != null && message.hasOwnProperty("authApiVersionCode"))
                object.authApiVersionCode = message.authApiVersionCode;
            return object;
        };

        /**
         * Converts this AuthCredential to JSON.
         * @function toJSON
         * @memberof auth.AuthCredential
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuthCredential.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AuthCredential;
    })();

    auth.KeyType = (function() {

        /**
         * Properties of a KeyType.
         * @memberof auth
         * @interface IKeyType
         */

        /**
         * Constructs a new KeyType.
         * @memberof auth
         * @classdesc Represents a KeyType.
         * @implements IKeyType
         * @constructor
         * @param {auth.IKeyType=} [properties] Properties to set
         */
        function KeyType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new KeyType instance using the specified properties.
         * @function create
         * @memberof auth.KeyType
         * @static
         * @param {auth.IKeyType=} [properties] Properties to set
         * @returns {auth.KeyType} KeyType instance
         */
        KeyType.create = function create(properties) {
            return new KeyType(properties);
        };

        /**
         * Creates a KeyType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.KeyType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.KeyType} KeyType
         */
        KeyType.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.KeyType)
                return object;
            return new $root.auth.KeyType();
        };

        /**
         * Creates a plain object from a KeyType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.KeyType
         * @static
         * @param {auth.KeyType} message KeyType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this KeyType to JSON.
         * @function toJSON
         * @memberof auth.KeyType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.KeyType.Enum
         * @enum {number}
         * @property {number} JWT=0 JWT value
         * @property {number} SECRET_KEY=1 SECRET_KEY value
         * @property {number} API_KEY=2 API_KEY value
         */
        KeyType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "JWT"] = 0;
            values[valuesById[1] = "SECRET_KEY"] = 1;
            values[valuesById[2] = "API_KEY"] = 2;
            return values;
        })();

        return KeyType;
    })();

    auth.RequestPayload = (function() {

        /**
         * Properties of a RequestPayload.
         * @memberof auth
         * @interface IRequestPayload
         * @property {number|Long|null} [id] RequestPayload id
         * @property {auth.IAuthCredential|null} [authCredential] RequestPayload authCredential
         * @property {number|Long|null} [deviceUuid] RequestPayload deviceUuid
         * @property {common.DeviceType.Enum|null} [deviceType] RequestPayload deviceType
         * @property {number|null} [apiVersion] RequestPayload apiVersion
         * @property {common.ILocation|null} [currentLocation] RequestPayload currentLocation
         * @property {number|Long|null} [createdTime] RequestPayload createdTime
         */

        /**
         * Constructs a new RequestPayload.
         * @memberof auth
         * @classdesc Represents a RequestPayload.
         * @implements IRequestPayload
         * @constructor
         * @param {auth.IRequestPayload=} [properties] Properties to set
         */
        function RequestPayload(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestPayload id.
         * @member {number|Long} id
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RequestPayload authCredential.
         * @member {auth.IAuthCredential|null|undefined} authCredential
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.authCredential = null;

        /**
         * RequestPayload deviceUuid.
         * @member {number|Long} deviceUuid
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.deviceUuid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RequestPayload deviceType.
         * @member {common.DeviceType.Enum} deviceType
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.deviceType = 0;

        /**
         * RequestPayload apiVersion.
         * @member {number} apiVersion
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.apiVersion = 0;

        /**
         * RequestPayload currentLocation.
         * @member {common.ILocation|null|undefined} currentLocation
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.currentLocation = null;

        /**
         * RequestPayload createdTime.
         * @member {number|Long} createdTime
         * @memberof auth.RequestPayload
         * @instance
         */
        RequestPayload.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new RequestPayload instance using the specified properties.
         * @function create
         * @memberof auth.RequestPayload
         * @static
         * @param {auth.IRequestPayload=} [properties] Properties to set
         * @returns {auth.RequestPayload} RequestPayload instance
         */
        RequestPayload.create = function create(properties) {
            return new RequestPayload(properties);
        };

        /**
         * Creates a RequestPayload message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.RequestPayload
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.RequestPayload} RequestPayload
         */
        RequestPayload.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.RequestPayload)
                return object;
            let message = new $root.auth.RequestPayload();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.authCredential != null) {
                if (typeof object.authCredential !== "object")
                    throw TypeError(".auth.RequestPayload.authCredential: object expected");
                message.authCredential = $root.auth.AuthCredential.fromObject(object.authCredential);
            }
            if (object.deviceUuid != null)
                if ($util.Long)
                    (message.deviceUuid = $util.Long.fromValue(object.deviceUuid)).unsigned = false;
                else if (typeof object.deviceUuid === "string")
                    message.deviceUuid = parseInt(object.deviceUuid, 10);
                else if (typeof object.deviceUuid === "number")
                    message.deviceUuid = object.deviceUuid;
                else if (typeof object.deviceUuid === "object")
                    message.deviceUuid = new $util.LongBits(object.deviceUuid.low >>> 0, object.deviceUuid.high >>> 0).toNumber();
            switch (object.deviceType) {
            case "DESKTOP":
            case 0:
                message.deviceType = 0;
                break;
            case "MOBILE_WEB":
            case 1:
                message.deviceType = 1;
                break;
            case "MOBILE_ANDROID":
            case 2:
                message.deviceType = 2;
                break;
            case "MOBILE_IOS":
            case 3:
                message.deviceType = 3;
                break;
            case "MOBILE":
            case 4:
                message.deviceType = 4;
                break;
            case "TABLET":
            case 5:
                message.deviceType = 5;
                break;
            }
            if (object.apiVersion != null)
                message.apiVersion = object.apiVersion | 0;
            if (object.currentLocation != null) {
                if (typeof object.currentLocation !== "object")
                    throw TypeError(".auth.RequestPayload.currentLocation: object expected");
                message.currentLocation = $root.common.Location.fromObject(object.currentLocation);
            }
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = false;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a RequestPayload message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.RequestPayload
         * @static
         * @param {auth.RequestPayload} message RequestPayload
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestPayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.authCredential = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.deviceUuid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceUuid = options.longs === String ? "0" : 0;
                object.deviceType = options.enums === String ? "DESKTOP" : 0;
                object.apiVersion = 0;
                object.currentLocation = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.authCredential != null && message.hasOwnProperty("authCredential"))
                object.authCredential = $root.auth.AuthCredential.toObject(message.authCredential, options);
            if (message.deviceUuid != null && message.hasOwnProperty("deviceUuid"))
                if (typeof message.deviceUuid === "number")
                    object.deviceUuid = options.longs === String ? String(message.deviceUuid) : message.deviceUuid;
                else
                    object.deviceUuid = options.longs === String ? $util.Long.prototype.toString.call(message.deviceUuid) : options.longs === Number ? new $util.LongBits(message.deviceUuid.low >>> 0, message.deviceUuid.high >>> 0).toNumber() : message.deviceUuid;
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.common.DeviceType.Enum[message.deviceType] : message.deviceType;
            if (message.apiVersion != null && message.hasOwnProperty("apiVersion"))
                object.apiVersion = message.apiVersion;
            if (message.currentLocation != null && message.hasOwnProperty("currentLocation"))
                object.currentLocation = $root.common.Location.toObject(message.currentLocation, options);
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber() : message.createdTime;
            return object;
        };

        /**
         * Converts this RequestPayload to JSON.
         * @function toJSON
         * @memberof auth.RequestPayload
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestPayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestPayload;
    })();

    auth.AuthService = (function() {

        /**
         * Constructs a new AuthService service.
         * @memberof auth
         * @classdesc Represents an AuthService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function AuthService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (AuthService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AuthService;

        /**
         * Creates new AuthService service using the specified rpc implementation.
         * @function create
         * @memberof auth.AuthService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {AuthService} RPC service. Useful where requests and/or responses are streamed.
         */
        AuthService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link auth.AuthService#signUp}.
         * @memberof auth.AuthService
         * @typedef SignUpCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.SignUpResponse} [response] SignUpResponse
         */

        /**
         * Calls SignUp.
         * @function signUp
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISignUpRequest} request SignUpRequest message or plain object
         * @param {auth.AuthService.SignUpCallback} callback Node-style callback called with the error, if any, and SignUpResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.signUp = function signUp(request, callback) {
            return this.rpcCall(signUp, $root.auth.SignUpRequest, $root.auth.SignUpResponse, request, callback);
        }, "name", { value: "SignUp" });

        /**
         * Calls SignUp.
         * @function signUp
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISignUpRequest} request SignUpRequest message or plain object
         * @returns {Promise<auth.SignUpResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#signIn}.
         * @memberof auth.AuthService
         * @typedef SignInCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.SignInResponse} [response] SignInResponse
         */

        /**
         * Calls SignIn.
         * @function signIn
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISignInRequest} request SignInRequest message or plain object
         * @param {auth.AuthService.SignInCallback} callback Node-style callback called with the error, if any, and SignInResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.signIn = function signIn(request, callback) {
            return this.rpcCall(signIn, $root.auth.SignInRequest, $root.auth.SignInResponse, request, callback);
        }, "name", { value: "SignIn" });

        /**
         * Calls SignIn.
         * @function signIn
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISignInRequest} request SignInRequest message or plain object
         * @returns {Promise<auth.SignInResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#getUser}.
         * @memberof auth.AuthService
         * @typedef GetUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.GetUserResponse} [response] GetUserResponse
         */

        /**
         * Calls GetUser.
         * @function getUser
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserRequest} request GetUserRequest message or plain object
         * @param {auth.AuthService.GetUserCallback} callback Node-style callback called with the error, if any, and GetUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.getUser = function getUser(request, callback) {
            return this.rpcCall(getUser, $root.auth.GetUserRequest, $root.auth.GetUserResponse, request, callback);
        }, "name", { value: "GetUser" });

        /**
         * Calls GetUser.
         * @function getUser
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserRequest} request GetUserRequest message or plain object
         * @returns {Promise<auth.GetUserResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#getUserList}.
         * @memberof auth.AuthService
         * @typedef GetUserListCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.GetUserListResponse} [response] GetUserListResponse
         */

        /**
         * Calls GetUserList.
         * @function getUserList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserListRequest} request GetUserListRequest message or plain object
         * @param {auth.AuthService.GetUserListCallback} callback Node-style callback called with the error, if any, and GetUserListResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.getUserList = function getUserList(request, callback) {
            return this.rpcCall(getUserList, $root.auth.GetUserListRequest, $root.auth.GetUserListResponse, request, callback);
        }, "name", { value: "GetUserList" });

        /**
         * Calls GetUserList.
         * @function getUserList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserListRequest} request GetUserListRequest message or plain object
         * @returns {Promise<auth.GetUserListResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#getUserIDVersionList}.
         * @memberof auth.AuthService
         * @typedef GetUserIDVersionListCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.GetUserIDVersionListResponse} [response] GetUserIDVersionListResponse
         */

        /**
         * Calls GetUserIDVersionList.
         * @function getUserIDVersionList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserIDVersionListRequest} request GetUserIDVersionListRequest message or plain object
         * @param {auth.AuthService.GetUserIDVersionListCallback} callback Node-style callback called with the error, if any, and GetUserIDVersionListResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.getUserIDVersionList = function getUserIDVersionList(request, callback) {
            return this.rpcCall(getUserIDVersionList, $root.auth.GetUserIDVersionListRequest, $root.auth.GetUserIDVersionListResponse, request, callback);
        }, "name", { value: "GetUserIDVersionList" });

        /**
         * Calls GetUserIDVersionList.
         * @function getUserIDVersionList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserIDVersionListRequest} request GetUserIDVersionListRequest message or plain object
         * @returns {Promise<auth.GetUserIDVersionListResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#updateUserProfile}.
         * @memberof auth.AuthService
         * @typedef UpdateUserProfileCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.UpdateUserProfileResponse} [response] UpdateUserProfileResponse
         */

        /**
         * Calls UpdateUserProfile.
         * @function updateUserProfile
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserProfileRequest} request UpdateUserProfileRequest message or plain object
         * @param {auth.AuthService.UpdateUserProfileCallback} callback Node-style callback called with the error, if any, and UpdateUserProfileResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.updateUserProfile = function updateUserProfile(request, callback) {
            return this.rpcCall(updateUserProfile, $root.auth.UpdateUserProfileRequest, $root.auth.UpdateUserProfileResponse, request, callback);
        }, "name", { value: "UpdateUserProfile" });

        /**
         * Calls UpdateUserProfile.
         * @function updateUserProfile
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserProfileRequest} request UpdateUserProfileRequest message or plain object
         * @returns {Promise<auth.UpdateUserProfileResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#updateUserRole}.
         * @memberof auth.AuthService
         * @typedef UpdateUserRoleCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.UpdateUserRoleResponse} [response] UpdateUserRoleResponse
         */

        /**
         * Calls UpdateUserRole.
         * @function updateUserRole
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserRoleRequest} request UpdateUserRoleRequest message or plain object
         * @param {auth.AuthService.UpdateUserRoleCallback} callback Node-style callback called with the error, if any, and UpdateUserRoleResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.updateUserRole = function updateUserRole(request, callback) {
            return this.rpcCall(updateUserRole, $root.auth.UpdateUserRoleRequest, $root.auth.UpdateUserRoleResponse, request, callback);
        }, "name", { value: "UpdateUserRole" });

        /**
         * Calls UpdateUserRole.
         * @function updateUserRole
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserRoleRequest} request UpdateUserRoleRequest message or plain object
         * @returns {Promise<auth.UpdateUserRoleResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#updateUserStatus}.
         * @memberof auth.AuthService
         * @typedef UpdateUserStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.UpdateUserStatusResponse} [response] UpdateUserStatusResponse
         */

        /**
         * Calls UpdateUserStatus.
         * @function updateUserStatus
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserStatusRequest} request UpdateUserStatusRequest message or plain object
         * @param {auth.AuthService.UpdateUserStatusCallback} callback Node-style callback called with the error, if any, and UpdateUserStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.updateUserStatus = function updateUserStatus(request, callback) {
            return this.rpcCall(updateUserStatus, $root.auth.UpdateUserStatusRequest, $root.auth.UpdateUserStatusResponse, request, callback);
        }, "name", { value: "UpdateUserStatus" });

        /**
         * Calls UpdateUserStatus.
         * @function updateUserStatus
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IUpdateUserStatusRequest} request UpdateUserStatusRequest message or plain object
         * @returns {Promise<auth.UpdateUserStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#getActiveUserList}.
         * @memberof auth.AuthService
         * @typedef GetActiveUserListCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.GetActiveUserListResponse} [response] GetActiveUserListResponse
         */

        /**
         * Calls GetActiveUserList.
         * @function getActiveUserList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetActiveUserListRequest} request GetActiveUserListRequest message or plain object
         * @param {auth.AuthService.GetActiveUserListCallback} callback Node-style callback called with the error, if any, and GetActiveUserListResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.getActiveUserList = function getActiveUserList(request, callback) {
            return this.rpcCall(getActiveUserList, $root.auth.GetActiveUserListRequest, $root.auth.GetActiveUserListResponse, request, callback);
        }, "name", { value: "GetActiveUserList" });

        /**
         * Calls GetActiveUserList.
         * @function getActiveUserList
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetActiveUserListRequest} request GetActiveUserListRequest message or plain object
         * @returns {Promise<auth.GetActiveUserListResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#validateAuthCredential}.
         * @memberof auth.AuthService
         * @typedef ValidateAuthCredentialCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.ValidateAuthCredentialResponse} [response] ValidateAuthCredentialResponse
         */

        /**
         * Calls ValidateAuthCredential.
         * @function validateAuthCredential
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IValidateAuthCredentialRequest} request ValidateAuthCredentialRequest message or plain object
         * @param {auth.AuthService.ValidateAuthCredentialCallback} callback Node-style callback called with the error, if any, and ValidateAuthCredentialResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.validateAuthCredential = function validateAuthCredential(request, callback) {
            return this.rpcCall(validateAuthCredential, $root.auth.ValidateAuthCredentialRequest, $root.auth.ValidateAuthCredentialResponse, request, callback);
        }, "name", { value: "ValidateAuthCredential" });

        /**
         * Calls ValidateAuthCredential.
         * @function validateAuthCredential
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IValidateAuthCredentialRequest} request ValidateAuthCredentialRequest message or plain object
         * @returns {Promise<auth.ValidateAuthCredentialResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#renewAuthCredential}.
         * @memberof auth.AuthService
         * @typedef RenewAuthCredentialCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.RenewAuthCredentialResponse} [response] RenewAuthCredentialResponse
         */

        /**
         * Calls RenewAuthCredential.
         * @function renewAuthCredential
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IRenewAuthCredentialRequest} request RenewAuthCredentialRequest message or plain object
         * @param {auth.AuthService.RenewAuthCredentialCallback} callback Node-style callback called with the error, if any, and RenewAuthCredentialResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.renewAuthCredential = function renewAuthCredential(request, callback) {
            return this.rpcCall(renewAuthCredential, $root.auth.RenewAuthCredentialRequest, $root.auth.RenewAuthCredentialResponse, request, callback);
        }, "name", { value: "RenewAuthCredential" });

        /**
         * Calls RenewAuthCredential.
         * @function renewAuthCredential
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IRenewAuthCredentialRequest} request RenewAuthCredentialRequest message or plain object
         * @returns {Promise<auth.RenewAuthCredentialResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#sendPasswordResetEmail}.
         * @memberof auth.AuthService
         * @typedef SendPasswordResetEmailCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.SendPasswordResetEmailResponse} [response] SendPasswordResetEmailResponse
         */

        /**
         * Calls SendPasswordResetEmail.
         * @function sendPasswordResetEmail
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISendPasswordResetEmailRequest} request SendPasswordResetEmailRequest message or plain object
         * @param {auth.AuthService.SendPasswordResetEmailCallback} callback Node-style callback called with the error, if any, and SendPasswordResetEmailResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.sendPasswordResetEmail = function sendPasswordResetEmail(request, callback) {
            return this.rpcCall(sendPasswordResetEmail, $root.auth.SendPasswordResetEmailRequest, $root.auth.SendPasswordResetEmailResponse, request, callback);
        }, "name", { value: "SendPasswordResetEmail" });

        /**
         * Calls SendPasswordResetEmail.
         * @function sendPasswordResetEmail
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISendPasswordResetEmailRequest} request SendPasswordResetEmailRequest message or plain object
         * @returns {Promise<auth.SendPasswordResetEmailResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#resetPassword}.
         * @memberof auth.AuthService
         * @typedef ResetPasswordCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.ResetPasswordResponse} [response] ResetPasswordResponse
         */

        /**
         * Calls ResetPassword.
         * @function resetPassword
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IResetPasswordRequest} request ResetPasswordRequest message or plain object
         * @param {auth.AuthService.ResetPasswordCallback} callback Node-style callback called with the error, if any, and ResetPasswordResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.resetPassword = function resetPassword(request, callback) {
            return this.rpcCall(resetPassword, $root.auth.ResetPasswordRequest, $root.auth.ResetPasswordResponse, request, callback);
        }, "name", { value: "ResetPassword" });

        /**
         * Calls ResetPassword.
         * @function resetPassword
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IResetPasswordRequest} request ResetPasswordRequest message or plain object
         * @returns {Promise<auth.ResetPasswordResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#changePassword}.
         * @memberof auth.AuthService
         * @typedef ChangePasswordCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.ChangePasswordResponse} [response] ChangePasswordResponse
         */

        /**
         * Calls ChangePassword.
         * @function changePassword
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IChangePasswordRequest} request ChangePasswordRequest message or plain object
         * @param {auth.AuthService.ChangePasswordCallback} callback Node-style callback called with the error, if any, and ChangePasswordResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.changePassword = function changePassword(request, callback) {
            return this.rpcCall(changePassword, $root.auth.ChangePasswordRequest, $root.auth.ChangePasswordResponse, request, callback);
        }, "name", { value: "ChangePassword" });

        /**
         * Calls ChangePassword.
         * @function changePassword
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IChangePasswordRequest} request ChangePasswordRequest message or plain object
         * @returns {Promise<auth.ChangePasswordResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#sendEmailValidationCode}.
         * @memberof auth.AuthService
         * @typedef SendEmailValidationCodeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.SendEmailValidationCodeResponse} [response] SendEmailValidationCodeResponse
         */

        /**
         * Calls SendEmailValidationCode.
         * @function sendEmailValidationCode
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISendEmailValidationCodeRequest} request SendEmailValidationCodeRequest message or plain object
         * @param {auth.AuthService.SendEmailValidationCodeCallback} callback Node-style callback called with the error, if any, and SendEmailValidationCodeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.sendEmailValidationCode = function sendEmailValidationCode(request, callback) {
            return this.rpcCall(sendEmailValidationCode, $root.auth.SendEmailValidationCodeRequest, $root.auth.SendEmailValidationCodeResponse, request, callback);
        }, "name", { value: "SendEmailValidationCode" });

        /**
         * Calls SendEmailValidationCode.
         * @function sendEmailValidationCode
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISendEmailValidationCodeRequest} request SendEmailValidationCodeRequest message or plain object
         * @returns {Promise<auth.SendEmailValidationCodeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#validateEmail}.
         * @memberof auth.AuthService
         * @typedef ValidateEmailCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.ValidateEmailResponse} [response] ValidateEmailResponse
         */

        /**
         * Calls ValidateEmail.
         * @function validateEmail
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IValidateEmailRequest} request ValidateEmailRequest message or plain object
         * @param {auth.AuthService.ValidateEmailCallback} callback Node-style callback called with the error, if any, and ValidateEmailResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.validateEmail = function validateEmail(request, callback) {
            return this.rpcCall(validateEmail, $root.auth.ValidateEmailRequest, $root.auth.ValidateEmailResponse, request, callback);
        }, "name", { value: "ValidateEmail" });

        /**
         * Calls ValidateEmail.
         * @function validateEmail
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IValidateEmailRequest} request ValidateEmailRequest message or plain object
         * @returns {Promise<auth.ValidateEmailResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#getUserId}.
         * @memberof auth.AuthService
         * @typedef GetUserIdCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.GetUserIdResponse} [response] GetUserIdResponse
         */

        /**
         * Calls GetUserId.
         * @function getUserId
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserIdRequest} request GetUserIdRequest message or plain object
         * @param {auth.AuthService.GetUserIdCallback} callback Node-style callback called with the error, if any, and GetUserIdResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.getUserId = function getUserId(request, callback) {
            return this.rpcCall(getUserId, $root.auth.GetUserIdRequest, $root.auth.GetUserIdResponse, request, callback);
        }, "name", { value: "GetUserId" });

        /**
         * Calls GetUserId.
         * @function getUserId
         * @memberof auth.AuthService
         * @instance
         * @param {auth.IGetUserIdRequest} request GetUserIdRequest message or plain object
         * @returns {Promise<auth.GetUserIdResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link auth.AuthService#searchUser}.
         * @memberof auth.AuthService
         * @typedef SearchUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {auth.SearchUserResponse} [response] SearchUserResponse
         */

        /**
         * Calls SearchUser.
         * @function searchUser
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISearchUserRequest} request SearchUserRequest message or plain object
         * @param {auth.AuthService.SearchUserCallback} callback Node-style callback called with the error, if any, and SearchUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AuthService.prototype.searchUser = function searchUser(request, callback) {
            return this.rpcCall(searchUser, $root.auth.SearchUserRequest, $root.auth.SearchUserResponse, request, callback);
        }, "name", { value: "SearchUser" });

        /**
         * Calls SearchUser.
         * @function searchUser
         * @memberof auth.AuthService
         * @instance
         * @param {auth.ISearchUserRequest} request SearchUserRequest message or plain object
         * @returns {Promise<auth.SearchUserResponse>} Promise
         * @variation 2
         */

        return AuthService;
    })();

    auth.SignUpRequest = (function() {

        /**
         * Properties of a SignUpRequest.
         * @memberof auth
         * @interface ISignUpRequest
         * @property {auth.DomainName.Enum|null} [domainName] SignUpRequest domainName
         * @property {string|null} [firstName] SignUpRequest firstName
         * @property {string|null} [lastName] SignUpRequest lastName
         * @property {string|null} [email] SignUpRequest email
         * @property {string|null} [password] SignUpRequest password
         */

        /**
         * Constructs a new SignUpRequest.
         * @memberof auth
         * @classdesc Represents a SignUpRequest.
         * @implements ISignUpRequest
         * @constructor
         * @param {auth.ISignUpRequest=} [properties] Properties to set
         */
        function SignUpRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignUpRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.SignUpRequest
         * @instance
         */
        SignUpRequest.prototype.domainName = 0;

        /**
         * SignUpRequest firstName.
         * @member {string} firstName
         * @memberof auth.SignUpRequest
         * @instance
         */
        SignUpRequest.prototype.firstName = "";

        /**
         * SignUpRequest lastName.
         * @member {string} lastName
         * @memberof auth.SignUpRequest
         * @instance
         */
        SignUpRequest.prototype.lastName = "";

        /**
         * SignUpRequest email.
         * @member {string} email
         * @memberof auth.SignUpRequest
         * @instance
         */
        SignUpRequest.prototype.email = "";

        /**
         * SignUpRequest password.
         * @member {string} password
         * @memberof auth.SignUpRequest
         * @instance
         */
        SignUpRequest.prototype.password = "";

        /**
         * Creates a new SignUpRequest instance using the specified properties.
         * @function create
         * @memberof auth.SignUpRequest
         * @static
         * @param {auth.ISignUpRequest=} [properties] Properties to set
         * @returns {auth.SignUpRequest} SignUpRequest instance
         */
        SignUpRequest.create = function create(properties) {
            return new SignUpRequest(properties);
        };

        /**
         * Creates a SignUpRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SignUpRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SignUpRequest} SignUpRequest
         */
        SignUpRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SignUpRequest)
                return object;
            let message = new $root.auth.SignUpRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.firstName != null)
                message.firstName = String(object.firstName);
            if (object.lastName != null)
                message.lastName = String(object.lastName);
            if (object.email != null)
                message.email = String(object.email);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a SignUpRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SignUpRequest
         * @static
         * @param {auth.SignUpRequest} message SignUpRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignUpRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.firstName = "";
                object.lastName = "";
                object.email = "";
                object.password = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.firstName != null && message.hasOwnProperty("firstName"))
                object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
                object.lastName = message.lastName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            return object;
        };

        /**
         * Converts this SignUpRequest to JSON.
         * @function toJSON
         * @memberof auth.SignUpRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignUpRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignUpRequest;
    })();

    auth.SignUpResponse = (function() {

        /**
         * Properties of a SignUpResponse.
         * @memberof auth
         * @interface ISignUpResponse
         * @property {auth.IUser|null} [user] SignUpResponse user
         * @property {auth.IAuthCredential|null} [authCredential] SignUpResponse authCredential
         * @property {boolean|null} [status] SignUpResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] SignUpResponse responseCode
         * @property {string|null} [responseMessage] SignUpResponse responseMessage
         */

        /**
         * Constructs a new SignUpResponse.
         * @memberof auth
         * @classdesc Represents a SignUpResponse.
         * @implements ISignUpResponse
         * @constructor
         * @param {auth.ISignUpResponse=} [properties] Properties to set
         */
        function SignUpResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignUpResponse user.
         * @member {auth.IUser|null|undefined} user
         * @memberof auth.SignUpResponse
         * @instance
         */
        SignUpResponse.prototype.user = null;

        /**
         * SignUpResponse authCredential.
         * @member {auth.IAuthCredential|null|undefined} authCredential
         * @memberof auth.SignUpResponse
         * @instance
         */
        SignUpResponse.prototype.authCredential = null;

        /**
         * SignUpResponse status.
         * @member {boolean} status
         * @memberof auth.SignUpResponse
         * @instance
         */
        SignUpResponse.prototype.status = false;

        /**
         * SignUpResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.SignUpResponse
         * @instance
         */
        SignUpResponse.prototype.responseCode = 0;

        /**
         * SignUpResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.SignUpResponse
         * @instance
         */
        SignUpResponse.prototype.responseMessage = "";

        /**
         * Creates a new SignUpResponse instance using the specified properties.
         * @function create
         * @memberof auth.SignUpResponse
         * @static
         * @param {auth.ISignUpResponse=} [properties] Properties to set
         * @returns {auth.SignUpResponse} SignUpResponse instance
         */
        SignUpResponse.create = function create(properties) {
            return new SignUpResponse(properties);
        };

        /**
         * Creates a SignUpResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SignUpResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SignUpResponse} SignUpResponse
         */
        SignUpResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SignUpResponse)
                return object;
            let message = new $root.auth.SignUpResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".auth.SignUpResponse.user: object expected");
                message.user = $root.auth.User.fromObject(object.user);
            }
            if (object.authCredential != null) {
                if (typeof object.authCredential !== "object")
                    throw TypeError(".auth.SignUpResponse.authCredential: object expected");
                message.authCredential = $root.auth.AuthCredential.fromObject(object.authCredential);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a SignUpResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SignUpResponse
         * @static
         * @param {auth.SignUpResponse} message SignUpResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignUpResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.user = null;
                object.authCredential = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.auth.User.toObject(message.user, options);
            if (message.authCredential != null && message.hasOwnProperty("authCredential"))
                object.authCredential = $root.auth.AuthCredential.toObject(message.authCredential, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this SignUpResponse to JSON.
         * @function toJSON
         * @memberof auth.SignUpResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignUpResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignUpResponse;
    })();

    auth.SignInRequest = (function() {

        /**
         * Properties of a SignInRequest.
         * @memberof auth
         * @interface ISignInRequest
         * @property {auth.DomainName.Enum|null} [domainName] SignInRequest domainName
         * @property {auth.SignInType.Enum|null} [signInType] SignInRequest signInType
         * @property {string|null} [email] SignInRequest email
         * @property {string|null} [password] SignInRequest password
         * @property {string|null} [authToken] SignInRequest authToken
         * @property {string|null} [anonymousToken] SignInRequest anonymousToken
         */

        /**
         * Constructs a new SignInRequest.
         * @memberof auth
         * @classdesc Represents a SignInRequest.
         * @implements ISignInRequest
         * @constructor
         * @param {auth.ISignInRequest=} [properties] Properties to set
         */
        function SignInRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignInRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.domainName = 0;

        /**
         * SignInRequest signInType.
         * @member {auth.SignInType.Enum} signInType
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.signInType = 0;

        /**
         * SignInRequest email.
         * @member {string} email
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.email = "";

        /**
         * SignInRequest password.
         * @member {string} password
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.password = "";

        /**
         * SignInRequest authToken.
         * @member {string} authToken
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.authToken = "";

        /**
         * SignInRequest anonymousToken.
         * @member {string} anonymousToken
         * @memberof auth.SignInRequest
         * @instance
         */
        SignInRequest.prototype.anonymousToken = "";

        /**
         * Creates a new SignInRequest instance using the specified properties.
         * @function create
         * @memberof auth.SignInRequest
         * @static
         * @param {auth.ISignInRequest=} [properties] Properties to set
         * @returns {auth.SignInRequest} SignInRequest instance
         */
        SignInRequest.create = function create(properties) {
            return new SignInRequest(properties);
        };

        /**
         * Creates a SignInRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SignInRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SignInRequest} SignInRequest
         */
        SignInRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SignInRequest)
                return object;
            let message = new $root.auth.SignInRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            switch (object.signInType) {
            case "EMAIL_PASS":
            case 0:
                message.signInType = 0;
                break;
            case "USERNAME_PASS":
            case 1:
                message.signInType = 1;
                break;
            case "FACEBOOK":
            case 2:
                message.signInType = 2;
                break;
            case "GOOGLE":
            case 3:
                message.signInType = 3;
                break;
            case "PHONE":
            case 4:
                message.signInType = 4;
                break;
            case "FIREBASE":
            case 5:
                message.signInType = 5;
                break;
            case "GITHUB":
            case 6:
                message.signInType = 6;
                break;
            case "API_KEY":
            case 7:
                message.signInType = 7;
                break;
            case "ANONYMOUS":
            case 8:
                message.signInType = 8;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.password != null)
                message.password = String(object.password);
            if (object.authToken != null)
                message.authToken = String(object.authToken);
            if (object.anonymousToken != null)
                message.anonymousToken = String(object.anonymousToken);
            return message;
        };

        /**
         * Creates a plain object from a SignInRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SignInRequest
         * @static
         * @param {auth.SignInRequest} message SignInRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignInRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.signInType = options.enums === String ? "EMAIL_PASS" : 0;
                object.email = "";
                object.password = "";
                object.authToken = "";
                object.anonymousToken = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.signInType != null && message.hasOwnProperty("signInType"))
                object.signInType = options.enums === String ? $root.auth.SignInType.Enum[message.signInType] : message.signInType;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.authToken != null && message.hasOwnProperty("authToken"))
                object.authToken = message.authToken;
            if (message.anonymousToken != null && message.hasOwnProperty("anonymousToken"))
                object.anonymousToken = message.anonymousToken;
            return object;
        };

        /**
         * Converts this SignInRequest to JSON.
         * @function toJSON
         * @memberof auth.SignInRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignInRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignInRequest;
    })();

    auth.SignInResponse = (function() {

        /**
         * Properties of a SignInResponse.
         * @memberof auth
         * @interface ISignInResponse
         * @property {auth.IUser|null} [user] SignInResponse user
         * @property {auth.IAuthCredential|null} [authCredential] SignInResponse authCredential
         * @property {boolean|null} [status] SignInResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] SignInResponse responseCode
         * @property {string|null} [responseMessage] SignInResponse responseMessage
         */

        /**
         * Constructs a new SignInResponse.
         * @memberof auth
         * @classdesc Represents a SignInResponse.
         * @implements ISignInResponse
         * @constructor
         * @param {auth.ISignInResponse=} [properties] Properties to set
         */
        function SignInResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignInResponse user.
         * @member {auth.IUser|null|undefined} user
         * @memberof auth.SignInResponse
         * @instance
         */
        SignInResponse.prototype.user = null;

        /**
         * SignInResponse authCredential.
         * @member {auth.IAuthCredential|null|undefined} authCredential
         * @memberof auth.SignInResponse
         * @instance
         */
        SignInResponse.prototype.authCredential = null;

        /**
         * SignInResponse status.
         * @member {boolean} status
         * @memberof auth.SignInResponse
         * @instance
         */
        SignInResponse.prototype.status = false;

        /**
         * SignInResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.SignInResponse
         * @instance
         */
        SignInResponse.prototype.responseCode = 0;

        /**
         * SignInResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.SignInResponse
         * @instance
         */
        SignInResponse.prototype.responseMessage = "";

        /**
         * Creates a new SignInResponse instance using the specified properties.
         * @function create
         * @memberof auth.SignInResponse
         * @static
         * @param {auth.ISignInResponse=} [properties] Properties to set
         * @returns {auth.SignInResponse} SignInResponse instance
         */
        SignInResponse.create = function create(properties) {
            return new SignInResponse(properties);
        };

        /**
         * Creates a SignInResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SignInResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SignInResponse} SignInResponse
         */
        SignInResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SignInResponse)
                return object;
            let message = new $root.auth.SignInResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".auth.SignInResponse.user: object expected");
                message.user = $root.auth.User.fromObject(object.user);
            }
            if (object.authCredential != null) {
                if (typeof object.authCredential !== "object")
                    throw TypeError(".auth.SignInResponse.authCredential: object expected");
                message.authCredential = $root.auth.AuthCredential.fromObject(object.authCredential);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a SignInResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SignInResponse
         * @static
         * @param {auth.SignInResponse} message SignInResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignInResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.user = null;
                object.authCredential = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.auth.User.toObject(message.user, options);
            if (message.authCredential != null && message.hasOwnProperty("authCredential"))
                object.authCredential = $root.auth.AuthCredential.toObject(message.authCredential, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this SignInResponse to JSON.
         * @function toJSON
         * @memberof auth.SignInResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignInResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignInResponse;
    })();

    auth.GetUserRequest = (function() {

        /**
         * Properties of a GetUserRequest.
         * @memberof auth
         * @interface IGetUserRequest
         * @property {number|Long|null} [userId] GetUserRequest userId
         * @property {auth.IRequestPayload|null} [requestPayload] GetUserRequest requestPayload
         */

        /**
         * Constructs a new GetUserRequest.
         * @memberof auth
         * @classdesc Represents a GetUserRequest.
         * @implements IGetUserRequest
         * @constructor
         * @param {auth.IGetUserRequest=} [properties] Properties to set
         */
        function GetUserRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserRequest userId.
         * @member {number|Long} userId
         * @memberof auth.GetUserRequest
         * @instance
         */
        GetUserRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetUserRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.GetUserRequest
         * @instance
         */
        GetUserRequest.prototype.requestPayload = null;

        /**
         * Creates a new GetUserRequest instance using the specified properties.
         * @function create
         * @memberof auth.GetUserRequest
         * @static
         * @param {auth.IGetUserRequest=} [properties] Properties to set
         * @returns {auth.GetUserRequest} GetUserRequest instance
         */
        GetUserRequest.create = function create(properties) {
            return new GetUserRequest(properties);
        };

        /**
         * Creates a GetUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserRequest} GetUserRequest
         */
        GetUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserRequest)
                return object;
            let message = new $root.auth.GetUserRequest();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.GetUserRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserRequest
         * @static
         * @param {auth.GetUserRequest} message GetUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.requestPayload = null;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this GetUserRequest to JSON.
         * @function toJSON
         * @memberof auth.GetUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserRequest;
    })();

    auth.GetUserResponse = (function() {

        /**
         * Properties of a GetUserResponse.
         * @memberof auth
         * @interface IGetUserResponse
         * @property {auth.IUser|null} [user] GetUserResponse user
         * @property {boolean|null} [status] GetUserResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] GetUserResponse responseCode
         * @property {string|null} [responseMessage] GetUserResponse responseMessage
         */

        /**
         * Constructs a new GetUserResponse.
         * @memberof auth
         * @classdesc Represents a GetUserResponse.
         * @implements IGetUserResponse
         * @constructor
         * @param {auth.IGetUserResponse=} [properties] Properties to set
         */
        function GetUserResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserResponse user.
         * @member {auth.IUser|null|undefined} user
         * @memberof auth.GetUserResponse
         * @instance
         */
        GetUserResponse.prototype.user = null;

        /**
         * GetUserResponse status.
         * @member {boolean} status
         * @memberof auth.GetUserResponse
         * @instance
         */
        GetUserResponse.prototype.status = false;

        /**
         * GetUserResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.GetUserResponse
         * @instance
         */
        GetUserResponse.prototype.responseCode = 0;

        /**
         * GetUserResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.GetUserResponse
         * @instance
         */
        GetUserResponse.prototype.responseMessage = "";

        /**
         * Creates a new GetUserResponse instance using the specified properties.
         * @function create
         * @memberof auth.GetUserResponse
         * @static
         * @param {auth.IGetUserResponse=} [properties] Properties to set
         * @returns {auth.GetUserResponse} GetUserResponse instance
         */
        GetUserResponse.create = function create(properties) {
            return new GetUserResponse(properties);
        };

        /**
         * Creates a GetUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserResponse} GetUserResponse
         */
        GetUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserResponse)
                return object;
            let message = new $root.auth.GetUserResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".auth.GetUserResponse.user: object expected");
                message.user = $root.auth.User.fromObject(object.user);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a GetUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserResponse
         * @static
         * @param {auth.GetUserResponse} message GetUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.user = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.auth.User.toObject(message.user, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this GetUserResponse to JSON.
         * @function toJSON
         * @memberof auth.GetUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserResponse;
    })();

    auth.GetUserListRequest = (function() {

        /**
         * Properties of a GetUserListRequest.
         * @memberof auth
         * @interface IGetUserListRequest
         * @property {auth.DomainName.Enum|null} [domainName] GetUserListRequest domainName
         * @property {Array.<number|Long>|null} [userIds] GetUserListRequest userIds
         * @property {number|null} [offset] GetUserListRequest offset
         * @property {number|null} [limit] GetUserListRequest limit
         * @property {auth.IRequestPayload|null} [requestPayload] GetUserListRequest requestPayload
         */

        /**
         * Constructs a new GetUserListRequest.
         * @memberof auth
         * @classdesc Represents a GetUserListRequest.
         * @implements IGetUserListRequest
         * @constructor
         * @param {auth.IGetUserListRequest=} [properties] Properties to set
         */
        function GetUserListRequest(properties) {
            this.userIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserListRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.GetUserListRequest
         * @instance
         */
        GetUserListRequest.prototype.domainName = 0;

        /**
         * GetUserListRequest userIds.
         * @member {Array.<number|Long>} userIds
         * @memberof auth.GetUserListRequest
         * @instance
         */
        GetUserListRequest.prototype.userIds = $util.emptyArray;

        /**
         * GetUserListRequest offset.
         * @member {number} offset
         * @memberof auth.GetUserListRequest
         * @instance
         */
        GetUserListRequest.prototype.offset = 0;

        /**
         * GetUserListRequest limit.
         * @member {number} limit
         * @memberof auth.GetUserListRequest
         * @instance
         */
        GetUserListRequest.prototype.limit = 0;

        /**
         * GetUserListRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.GetUserListRequest
         * @instance
         */
        GetUserListRequest.prototype.requestPayload = null;

        /**
         * Creates a new GetUserListRequest instance using the specified properties.
         * @function create
         * @memberof auth.GetUserListRequest
         * @static
         * @param {auth.IGetUserListRequest=} [properties] Properties to set
         * @returns {auth.GetUserListRequest} GetUserListRequest instance
         */
        GetUserListRequest.create = function create(properties) {
            return new GetUserListRequest(properties);
        };

        /**
         * Creates a GetUserListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserListRequest} GetUserListRequest
         */
        GetUserListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserListRequest)
                return object;
            let message = new $root.auth.GetUserListRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.userIds) {
                if (!Array.isArray(object.userIds))
                    throw TypeError(".auth.GetUserListRequest.userIds: array expected");
                message.userIds = [];
                for (let i = 0; i < object.userIds.length; ++i)
                    if ($util.Long)
                        (message.userIds[i] = $util.Long.fromValue(object.userIds[i])).unsigned = false;
                    else if (typeof object.userIds[i] === "string")
                        message.userIds[i] = parseInt(object.userIds[i], 10);
                    else if (typeof object.userIds[i] === "number")
                        message.userIds[i] = object.userIds[i];
                    else if (typeof object.userIds[i] === "object")
                        message.userIds[i] = new $util.LongBits(object.userIds[i].low >>> 0, object.userIds[i].high >>> 0).toNumber();
            }
            if (object.offset != null)
                message.offset = object.offset | 0;
            if (object.limit != null)
                message.limit = object.limit | 0;
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.GetUserListRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserListRequest
         * @static
         * @param {auth.GetUserListRequest} message GetUserListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userIds = [];
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.offset = 0;
                object.limit = 0;
                object.requestPayload = null;
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.userIds && message.userIds.length) {
                object.userIds = [];
                for (let j = 0; j < message.userIds.length; ++j)
                    if (typeof message.userIds[j] === "number")
                        object.userIds[j] = options.longs === String ? String(message.userIds[j]) : message.userIds[j];
                    else
                        object.userIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.userIds[j]) : options.longs === Number ? new $util.LongBits(message.userIds[j].low >>> 0, message.userIds[j].high >>> 0).toNumber() : message.userIds[j];
            }
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this GetUserListRequest to JSON.
         * @function toJSON
         * @memberof auth.GetUserListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserListRequest;
    })();

    auth.GetUserListResponse = (function() {

        /**
         * Properties of a GetUserListResponse.
         * @memberof auth
         * @interface IGetUserListResponse
         * @property {Array.<auth.IUser>|null} [userList] GetUserListResponse userList
         * @property {common.ResponseCode.Enum|null} [responseCode] GetUserListResponse responseCode
         * @property {string|null} [responseMessage] GetUserListResponse responseMessage
         */

        /**
         * Constructs a new GetUserListResponse.
         * @memberof auth
         * @classdesc Represents a GetUserListResponse.
         * @implements IGetUserListResponse
         * @constructor
         * @param {auth.IGetUserListResponse=} [properties] Properties to set
         */
        function GetUserListResponse(properties) {
            this.userList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserListResponse userList.
         * @member {Array.<auth.IUser>} userList
         * @memberof auth.GetUserListResponse
         * @instance
         */
        GetUserListResponse.prototype.userList = $util.emptyArray;

        /**
         * GetUserListResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.GetUserListResponse
         * @instance
         */
        GetUserListResponse.prototype.responseCode = 0;

        /**
         * GetUserListResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.GetUserListResponse
         * @instance
         */
        GetUserListResponse.prototype.responseMessage = "";

        /**
         * Creates a new GetUserListResponse instance using the specified properties.
         * @function create
         * @memberof auth.GetUserListResponse
         * @static
         * @param {auth.IGetUserListResponse=} [properties] Properties to set
         * @returns {auth.GetUserListResponse} GetUserListResponse instance
         */
        GetUserListResponse.create = function create(properties) {
            return new GetUserListResponse(properties);
        };

        /**
         * Creates a GetUserListResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserListResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserListResponse} GetUserListResponse
         */
        GetUserListResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserListResponse)
                return object;
            let message = new $root.auth.GetUserListResponse();
            if (object.userList) {
                if (!Array.isArray(object.userList))
                    throw TypeError(".auth.GetUserListResponse.userList: array expected");
                message.userList = [];
                for (let i = 0; i < object.userList.length; ++i) {
                    if (typeof object.userList[i] !== "object")
                        throw TypeError(".auth.GetUserListResponse.userList: object expected");
                    message.userList[i] = $root.auth.User.fromObject(object.userList[i]);
                }
            }
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a GetUserListResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserListResponse
         * @static
         * @param {auth.GetUserListResponse} message GetUserListResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserListResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userList = [];
            if (options.defaults) {
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.userList && message.userList.length) {
                object.userList = [];
                for (let j = 0; j < message.userList.length; ++j)
                    object.userList[j] = $root.auth.User.toObject(message.userList[j], options);
            }
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this GetUserListResponse to JSON.
         * @function toJSON
         * @memberof auth.GetUserListResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserListResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserListResponse;
    })();

    auth.GetUserIDVersionListRequest = (function() {

        /**
         * Properties of a GetUserIDVersionListRequest.
         * @memberof auth
         * @interface IGetUserIDVersionListRequest
         * @property {number|null} [offset] GetUserIDVersionListRequest offset
         * @property {number|null} [limit] GetUserIDVersionListRequest limit
         * @property {Array.<number|Long>|null} [userIds] GetUserIDVersionListRequest userIds
         * @property {auth.IRequestPayload|null} [requestPayload] GetUserIDVersionListRequest requestPayload
         */

        /**
         * Constructs a new GetUserIDVersionListRequest.
         * @memberof auth
         * @classdesc Represents a GetUserIDVersionListRequest.
         * @implements IGetUserIDVersionListRequest
         * @constructor
         * @param {auth.IGetUserIDVersionListRequest=} [properties] Properties to set
         */
        function GetUserIDVersionListRequest(properties) {
            this.userIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserIDVersionListRequest offset.
         * @member {number} offset
         * @memberof auth.GetUserIDVersionListRequest
         * @instance
         */
        GetUserIDVersionListRequest.prototype.offset = 0;

        /**
         * GetUserIDVersionListRequest limit.
         * @member {number} limit
         * @memberof auth.GetUserIDVersionListRequest
         * @instance
         */
        GetUserIDVersionListRequest.prototype.limit = 0;

        /**
         * GetUserIDVersionListRequest userIds.
         * @member {Array.<number|Long>} userIds
         * @memberof auth.GetUserIDVersionListRequest
         * @instance
         */
        GetUserIDVersionListRequest.prototype.userIds = $util.emptyArray;

        /**
         * GetUserIDVersionListRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.GetUserIDVersionListRequest
         * @instance
         */
        GetUserIDVersionListRequest.prototype.requestPayload = null;

        /**
         * Creates a new GetUserIDVersionListRequest instance using the specified properties.
         * @function create
         * @memberof auth.GetUserIDVersionListRequest
         * @static
         * @param {auth.IGetUserIDVersionListRequest=} [properties] Properties to set
         * @returns {auth.GetUserIDVersionListRequest} GetUserIDVersionListRequest instance
         */
        GetUserIDVersionListRequest.create = function create(properties) {
            return new GetUserIDVersionListRequest(properties);
        };

        /**
         * Creates a GetUserIDVersionListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserIDVersionListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserIDVersionListRequest} GetUserIDVersionListRequest
         */
        GetUserIDVersionListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserIDVersionListRequest)
                return object;
            let message = new $root.auth.GetUserIDVersionListRequest();
            if (object.offset != null)
                message.offset = object.offset | 0;
            if (object.limit != null)
                message.limit = object.limit | 0;
            if (object.userIds) {
                if (!Array.isArray(object.userIds))
                    throw TypeError(".auth.GetUserIDVersionListRequest.userIds: array expected");
                message.userIds = [];
                for (let i = 0; i < object.userIds.length; ++i)
                    if ($util.Long)
                        (message.userIds[i] = $util.Long.fromValue(object.userIds[i])).unsigned = false;
                    else if (typeof object.userIds[i] === "string")
                        message.userIds[i] = parseInt(object.userIds[i], 10);
                    else if (typeof object.userIds[i] === "number")
                        message.userIds[i] = object.userIds[i];
                    else if (typeof object.userIds[i] === "object")
                        message.userIds[i] = new $util.LongBits(object.userIds[i].low >>> 0, object.userIds[i].high >>> 0).toNumber();
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.GetUserIDVersionListRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserIDVersionListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserIDVersionListRequest
         * @static
         * @param {auth.GetUserIDVersionListRequest} message GetUserIDVersionListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserIDVersionListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userIds = [];
            if (options.defaults) {
                object.offset = 0;
                object.limit = 0;
                object.requestPayload = null;
            }
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            if (message.userIds && message.userIds.length) {
                object.userIds = [];
                for (let j = 0; j < message.userIds.length; ++j)
                    if (typeof message.userIds[j] === "number")
                        object.userIds[j] = options.longs === String ? String(message.userIds[j]) : message.userIds[j];
                    else
                        object.userIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.userIds[j]) : options.longs === Number ? new $util.LongBits(message.userIds[j].low >>> 0, message.userIds[j].high >>> 0).toNumber() : message.userIds[j];
            }
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this GetUserIDVersionListRequest to JSON.
         * @function toJSON
         * @memberof auth.GetUserIDVersionListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserIDVersionListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserIDVersionListRequest;
    })();

    auth.GetUserIDVersionListResponse = (function() {

        /**
         * Properties of a GetUserIDVersionListResponse.
         * @memberof auth
         * @interface IGetUserIDVersionListResponse
         * @property {Array.<auth.IUserIDVersion>|null} [userIdVersionList] GetUserIDVersionListResponse userIdVersionList
         * @property {common.ResponseCode.Enum|null} [responseCode] GetUserIDVersionListResponse responseCode
         * @property {string|null} [responseMessage] GetUserIDVersionListResponse responseMessage
         */

        /**
         * Constructs a new GetUserIDVersionListResponse.
         * @memberof auth
         * @classdesc Represents a GetUserIDVersionListResponse.
         * @implements IGetUserIDVersionListResponse
         * @constructor
         * @param {auth.IGetUserIDVersionListResponse=} [properties] Properties to set
         */
        function GetUserIDVersionListResponse(properties) {
            this.userIdVersionList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserIDVersionListResponse userIdVersionList.
         * @member {Array.<auth.IUserIDVersion>} userIdVersionList
         * @memberof auth.GetUserIDVersionListResponse
         * @instance
         */
        GetUserIDVersionListResponse.prototype.userIdVersionList = $util.emptyArray;

        /**
         * GetUserIDVersionListResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.GetUserIDVersionListResponse
         * @instance
         */
        GetUserIDVersionListResponse.prototype.responseCode = 0;

        /**
         * GetUserIDVersionListResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.GetUserIDVersionListResponse
         * @instance
         */
        GetUserIDVersionListResponse.prototype.responseMessage = "";

        /**
         * Creates a new GetUserIDVersionListResponse instance using the specified properties.
         * @function create
         * @memberof auth.GetUserIDVersionListResponse
         * @static
         * @param {auth.IGetUserIDVersionListResponse=} [properties] Properties to set
         * @returns {auth.GetUserIDVersionListResponse} GetUserIDVersionListResponse instance
         */
        GetUserIDVersionListResponse.create = function create(properties) {
            return new GetUserIDVersionListResponse(properties);
        };

        /**
         * Creates a GetUserIDVersionListResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserIDVersionListResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserIDVersionListResponse} GetUserIDVersionListResponse
         */
        GetUserIDVersionListResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserIDVersionListResponse)
                return object;
            let message = new $root.auth.GetUserIDVersionListResponse();
            if (object.userIdVersionList) {
                if (!Array.isArray(object.userIdVersionList))
                    throw TypeError(".auth.GetUserIDVersionListResponse.userIdVersionList: array expected");
                message.userIdVersionList = [];
                for (let i = 0; i < object.userIdVersionList.length; ++i) {
                    if (typeof object.userIdVersionList[i] !== "object")
                        throw TypeError(".auth.GetUserIDVersionListResponse.userIdVersionList: object expected");
                    message.userIdVersionList[i] = $root.auth.UserIDVersion.fromObject(object.userIdVersionList[i]);
                }
            }
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a GetUserIDVersionListResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserIDVersionListResponse
         * @static
         * @param {auth.GetUserIDVersionListResponse} message GetUserIDVersionListResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserIDVersionListResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userIdVersionList = [];
            if (options.defaults) {
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.userIdVersionList && message.userIdVersionList.length) {
                object.userIdVersionList = [];
                for (let j = 0; j < message.userIdVersionList.length; ++j)
                    object.userIdVersionList[j] = $root.auth.UserIDVersion.toObject(message.userIdVersionList[j], options);
            }
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this GetUserIDVersionListResponse to JSON.
         * @function toJSON
         * @memberof auth.GetUserIDVersionListResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserIDVersionListResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserIDVersionListResponse;
    })();

    auth.UpdateUserProfileRequest = (function() {

        /**
         * Properties of an UpdateUserProfileRequest.
         * @memberof auth
         * @interface IUpdateUserProfileRequest
         * @property {number|Long|null} [userId] UpdateUserProfileRequest userId
         * @property {Array.<auth.IUpdateOperation>|null} [updateOperations] UpdateUserProfileRequest updateOperations
         * @property {auth.IRequestPayload|null} [requestPayload] UpdateUserProfileRequest requestPayload
         */

        /**
         * Constructs a new UpdateUserProfileRequest.
         * @memberof auth
         * @classdesc Represents an UpdateUserProfileRequest.
         * @implements IUpdateUserProfileRequest
         * @constructor
         * @param {auth.IUpdateUserProfileRequest=} [properties] Properties to set
         */
        function UpdateUserProfileRequest(properties) {
            this.updateOperations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserProfileRequest userId.
         * @member {number|Long} userId
         * @memberof auth.UpdateUserProfileRequest
         * @instance
         */
        UpdateUserProfileRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UpdateUserProfileRequest updateOperations.
         * @member {Array.<auth.IUpdateOperation>} updateOperations
         * @memberof auth.UpdateUserProfileRequest
         * @instance
         */
        UpdateUserProfileRequest.prototype.updateOperations = $util.emptyArray;

        /**
         * UpdateUserProfileRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.UpdateUserProfileRequest
         * @instance
         */
        UpdateUserProfileRequest.prototype.requestPayload = null;

        /**
         * Creates a new UpdateUserProfileRequest instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserProfileRequest
         * @static
         * @param {auth.IUpdateUserProfileRequest=} [properties] Properties to set
         * @returns {auth.UpdateUserProfileRequest} UpdateUserProfileRequest instance
         */
        UpdateUserProfileRequest.create = function create(properties) {
            return new UpdateUserProfileRequest(properties);
        };

        /**
         * Creates an UpdateUserProfileRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserProfileRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserProfileRequest} UpdateUserProfileRequest
         */
        UpdateUserProfileRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserProfileRequest)
                return object;
            let message = new $root.auth.UpdateUserProfileRequest();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.updateOperations) {
                if (!Array.isArray(object.updateOperations))
                    throw TypeError(".auth.UpdateUserProfileRequest.updateOperations: array expected");
                message.updateOperations = [];
                for (let i = 0; i < object.updateOperations.length; ++i) {
                    if (typeof object.updateOperations[i] !== "object")
                        throw TypeError(".auth.UpdateUserProfileRequest.updateOperations: object expected");
                    message.updateOperations[i] = $root.auth.UpdateOperation.fromObject(object.updateOperations[i]);
                }
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.UpdateUserProfileRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserProfileRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserProfileRequest
         * @static
         * @param {auth.UpdateUserProfileRequest} message UpdateUserProfileRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserProfileRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.updateOperations = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.requestPayload = null;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.updateOperations && message.updateOperations.length) {
                object.updateOperations = [];
                for (let j = 0; j < message.updateOperations.length; ++j)
                    object.updateOperations[j] = $root.auth.UpdateOperation.toObject(message.updateOperations[j], options);
            }
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this UpdateUserProfileRequest to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserProfileRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserProfileRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserProfileRequest;
    })();

    auth.UpdateUserProfileResponse = (function() {

        /**
         * Properties of an UpdateUserProfileResponse.
         * @memberof auth
         * @interface IUpdateUserProfileResponse
         * @property {auth.IUser|null} [user] UpdateUserProfileResponse user
         * @property {boolean|null} [status] UpdateUserProfileResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] UpdateUserProfileResponse responseCode
         * @property {string|null} [responseMessage] UpdateUserProfileResponse responseMessage
         */

        /**
         * Constructs a new UpdateUserProfileResponse.
         * @memberof auth
         * @classdesc Represents an UpdateUserProfileResponse.
         * @implements IUpdateUserProfileResponse
         * @constructor
         * @param {auth.IUpdateUserProfileResponse=} [properties] Properties to set
         */
        function UpdateUserProfileResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserProfileResponse user.
         * @member {auth.IUser|null|undefined} user
         * @memberof auth.UpdateUserProfileResponse
         * @instance
         */
        UpdateUserProfileResponse.prototype.user = null;

        /**
         * UpdateUserProfileResponse status.
         * @member {boolean} status
         * @memberof auth.UpdateUserProfileResponse
         * @instance
         */
        UpdateUserProfileResponse.prototype.status = false;

        /**
         * UpdateUserProfileResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.UpdateUserProfileResponse
         * @instance
         */
        UpdateUserProfileResponse.prototype.responseCode = 0;

        /**
         * UpdateUserProfileResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.UpdateUserProfileResponse
         * @instance
         */
        UpdateUserProfileResponse.prototype.responseMessage = "";

        /**
         * Creates a new UpdateUserProfileResponse instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserProfileResponse
         * @static
         * @param {auth.IUpdateUserProfileResponse=} [properties] Properties to set
         * @returns {auth.UpdateUserProfileResponse} UpdateUserProfileResponse instance
         */
        UpdateUserProfileResponse.create = function create(properties) {
            return new UpdateUserProfileResponse(properties);
        };

        /**
         * Creates an UpdateUserProfileResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserProfileResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserProfileResponse} UpdateUserProfileResponse
         */
        UpdateUserProfileResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserProfileResponse)
                return object;
            let message = new $root.auth.UpdateUserProfileResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".auth.UpdateUserProfileResponse.user: object expected");
                message.user = $root.auth.User.fromObject(object.user);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserProfileResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserProfileResponse
         * @static
         * @param {auth.UpdateUserProfileResponse} message UpdateUserProfileResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserProfileResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.user = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.auth.User.toObject(message.user, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this UpdateUserProfileResponse to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserProfileResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserProfileResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserProfileResponse;
    })();

    auth.UpdateUserRoleRequest = (function() {

        /**
         * Properties of an UpdateUserRoleRequest.
         * @memberof auth
         * @interface IUpdateUserRoleRequest
         * @property {number|Long|null} [userId] UpdateUserRoleRequest userId
         * @property {auth.UserRole.Enum|null} [userRole] UpdateUserRoleRequest userRole
         * @property {auth.IRequestPayload|null} [requestPayload] UpdateUserRoleRequest requestPayload
         */

        /**
         * Constructs a new UpdateUserRoleRequest.
         * @memberof auth
         * @classdesc Represents an UpdateUserRoleRequest.
         * @implements IUpdateUserRoleRequest
         * @constructor
         * @param {auth.IUpdateUserRoleRequest=} [properties] Properties to set
         */
        function UpdateUserRoleRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserRoleRequest userId.
         * @member {number|Long} userId
         * @memberof auth.UpdateUserRoleRequest
         * @instance
         */
        UpdateUserRoleRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UpdateUserRoleRequest userRole.
         * @member {auth.UserRole.Enum} userRole
         * @memberof auth.UpdateUserRoleRequest
         * @instance
         */
        UpdateUserRoleRequest.prototype.userRole = 0;

        /**
         * UpdateUserRoleRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.UpdateUserRoleRequest
         * @instance
         */
        UpdateUserRoleRequest.prototype.requestPayload = null;

        /**
         * Creates a new UpdateUserRoleRequest instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserRoleRequest
         * @static
         * @param {auth.IUpdateUserRoleRequest=} [properties] Properties to set
         * @returns {auth.UpdateUserRoleRequest} UpdateUserRoleRequest instance
         */
        UpdateUserRoleRequest.create = function create(properties) {
            return new UpdateUserRoleRequest(properties);
        };

        /**
         * Creates an UpdateUserRoleRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserRoleRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserRoleRequest} UpdateUserRoleRequest
         */
        UpdateUserRoleRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserRoleRequest)
                return object;
            let message = new $root.auth.UpdateUserRoleRequest();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            switch (object.userRole) {
            case "GENERAL":
            case 0:
                message.userRole = 0;
                break;
            case "MODERATOR":
            case 1:
                message.userRole = 1;
                break;
            case "ADMIN":
            case 2:
                message.userRole = 2;
                break;
            case "SUPER_ADMIN":
            case 3:
                message.userRole = 3;
                break;
            case "OWNER":
            case 4:
                message.userRole = 4;
                break;
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.UpdateUserRoleRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserRoleRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserRoleRequest
         * @static
         * @param {auth.UpdateUserRoleRequest} message UpdateUserRoleRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserRoleRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.userRole = options.enums === String ? "GENERAL" : 0;
                object.requestPayload = null;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.userRole != null && message.hasOwnProperty("userRole"))
                object.userRole = options.enums === String ? $root.auth.UserRole.Enum[message.userRole] : message.userRole;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this UpdateUserRoleRequest to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserRoleRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserRoleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserRoleRequest;
    })();

    auth.UpdateUserRoleResponse = (function() {

        /**
         * Properties of an UpdateUserRoleResponse.
         * @memberof auth
         * @interface IUpdateUserRoleResponse
         * @property {auth.IUser|null} [user] UpdateUserRoleResponse user
         * @property {boolean|null} [status] UpdateUserRoleResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] UpdateUserRoleResponse responseCode
         * @property {string|null} [responseMessage] UpdateUserRoleResponse responseMessage
         */

        /**
         * Constructs a new UpdateUserRoleResponse.
         * @memberof auth
         * @classdesc Represents an UpdateUserRoleResponse.
         * @implements IUpdateUserRoleResponse
         * @constructor
         * @param {auth.IUpdateUserRoleResponse=} [properties] Properties to set
         */
        function UpdateUserRoleResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserRoleResponse user.
         * @member {auth.IUser|null|undefined} user
         * @memberof auth.UpdateUserRoleResponse
         * @instance
         */
        UpdateUserRoleResponse.prototype.user = null;

        /**
         * UpdateUserRoleResponse status.
         * @member {boolean} status
         * @memberof auth.UpdateUserRoleResponse
         * @instance
         */
        UpdateUserRoleResponse.prototype.status = false;

        /**
         * UpdateUserRoleResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.UpdateUserRoleResponse
         * @instance
         */
        UpdateUserRoleResponse.prototype.responseCode = 0;

        /**
         * UpdateUserRoleResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.UpdateUserRoleResponse
         * @instance
         */
        UpdateUserRoleResponse.prototype.responseMessage = "";

        /**
         * Creates a new UpdateUserRoleResponse instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserRoleResponse
         * @static
         * @param {auth.IUpdateUserRoleResponse=} [properties] Properties to set
         * @returns {auth.UpdateUserRoleResponse} UpdateUserRoleResponse instance
         */
        UpdateUserRoleResponse.create = function create(properties) {
            return new UpdateUserRoleResponse(properties);
        };

        /**
         * Creates an UpdateUserRoleResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserRoleResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserRoleResponse} UpdateUserRoleResponse
         */
        UpdateUserRoleResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserRoleResponse)
                return object;
            let message = new $root.auth.UpdateUserRoleResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".auth.UpdateUserRoleResponse.user: object expected");
                message.user = $root.auth.User.fromObject(object.user);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserRoleResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserRoleResponse
         * @static
         * @param {auth.UpdateUserRoleResponse} message UpdateUserRoleResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserRoleResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.user = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.auth.User.toObject(message.user, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this UpdateUserRoleResponse to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserRoleResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserRoleResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserRoleResponse;
    })();

    auth.UpdateUserStatusRequest = (function() {

        /**
         * Properties of an UpdateUserStatusRequest.
         * @memberof auth
         * @interface IUpdateUserStatusRequest
         * @property {number|Long|null} [userId] UpdateUserStatusRequest userId
         * @property {auth.UserActiveStatus.Enum|null} [userStatus] UpdateUserStatusRequest userStatus
         * @property {auth.IRequestPayload|null} [requestPayload] UpdateUserStatusRequest requestPayload
         */

        /**
         * Constructs a new UpdateUserStatusRequest.
         * @memberof auth
         * @classdesc Represents an UpdateUserStatusRequest.
         * @implements IUpdateUserStatusRequest
         * @constructor
         * @param {auth.IUpdateUserStatusRequest=} [properties] Properties to set
         */
        function UpdateUserStatusRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserStatusRequest userId.
         * @member {number|Long} userId
         * @memberof auth.UpdateUserStatusRequest
         * @instance
         */
        UpdateUserStatusRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UpdateUserStatusRequest userStatus.
         * @member {auth.UserActiveStatus.Enum} userStatus
         * @memberof auth.UpdateUserStatusRequest
         * @instance
         */
        UpdateUserStatusRequest.prototype.userStatus = 0;

        /**
         * UpdateUserStatusRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.UpdateUserStatusRequest
         * @instance
         */
        UpdateUserStatusRequest.prototype.requestPayload = null;

        /**
         * Creates a new UpdateUserStatusRequest instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserStatusRequest
         * @static
         * @param {auth.IUpdateUserStatusRequest=} [properties] Properties to set
         * @returns {auth.UpdateUserStatusRequest} UpdateUserStatusRequest instance
         */
        UpdateUserStatusRequest.create = function create(properties) {
            return new UpdateUserStatusRequest(properties);
        };

        /**
         * Creates an UpdateUserStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserStatusRequest} UpdateUserStatusRequest
         */
        UpdateUserStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserStatusRequest)
                return object;
            let message = new $root.auth.UpdateUserStatusRequest();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            switch (object.userStatus) {
            case "ACTIVE":
            case 0:
                message.userStatus = 0;
                break;
            case "IN_ACTIVE":
            case 1:
                message.userStatus = 1;
                break;
            case "BANNED":
            case 2:
                message.userStatus = 2;
                break;
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.UpdateUserStatusRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserStatusRequest
         * @static
         * @param {auth.UpdateUserStatusRequest} message UpdateUserStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.userStatus = options.enums === String ? "ACTIVE" : 0;
                object.requestPayload = null;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.userStatus != null && message.hasOwnProperty("userStatus"))
                object.userStatus = options.enums === String ? $root.auth.UserActiveStatus.Enum[message.userStatus] : message.userStatus;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this UpdateUserStatusRequest to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserStatusRequest;
    })();

    auth.UpdateUserStatusResponse = (function() {

        /**
         * Properties of an UpdateUserStatusResponse.
         * @memberof auth
         * @interface IUpdateUserStatusResponse
         * @property {boolean|null} [status] UpdateUserStatusResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] UpdateUserStatusResponse responseCode
         * @property {string|null} [responseMessage] UpdateUserStatusResponse responseMessage
         */

        /**
         * Constructs a new UpdateUserStatusResponse.
         * @memberof auth
         * @classdesc Represents an UpdateUserStatusResponse.
         * @implements IUpdateUserStatusResponse
         * @constructor
         * @param {auth.IUpdateUserStatusResponse=} [properties] Properties to set
         */
        function UpdateUserStatusResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserStatusResponse status.
         * @member {boolean} status
         * @memberof auth.UpdateUserStatusResponse
         * @instance
         */
        UpdateUserStatusResponse.prototype.status = false;

        /**
         * UpdateUserStatusResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.UpdateUserStatusResponse
         * @instance
         */
        UpdateUserStatusResponse.prototype.responseCode = 0;

        /**
         * UpdateUserStatusResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.UpdateUserStatusResponse
         * @instance
         */
        UpdateUserStatusResponse.prototype.responseMessage = "";

        /**
         * Creates a new UpdateUserStatusResponse instance using the specified properties.
         * @function create
         * @memberof auth.UpdateUserStatusResponse
         * @static
         * @param {auth.IUpdateUserStatusResponse=} [properties] Properties to set
         * @returns {auth.UpdateUserStatusResponse} UpdateUserStatusResponse instance
         */
        UpdateUserStatusResponse.create = function create(properties) {
            return new UpdateUserStatusResponse(properties);
        };

        /**
         * Creates an UpdateUserStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateUserStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateUserStatusResponse} UpdateUserStatusResponse
         */
        UpdateUserStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateUserStatusResponse)
                return object;
            let message = new $root.auth.UpdateUserStatusResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateUserStatusResponse
         * @static
         * @param {auth.UpdateUserStatusResponse} message UpdateUserStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserStatusResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this UpdateUserStatusResponse to JSON.
         * @function toJSON
         * @memberof auth.UpdateUserStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserStatusResponse;
    })();

    auth.GetActiveUserListRequest = (function() {

        /**
         * Properties of a GetActiveUserListRequest.
         * @memberof auth
         * @interface IGetActiveUserListRequest
         * @property {auth.DomainName.Enum|null} [domainName] GetActiveUserListRequest domainName
         * @property {auth.IRequestPayload|null} [requestPayload] GetActiveUserListRequest requestPayload
         */

        /**
         * Constructs a new GetActiveUserListRequest.
         * @memberof auth
         * @classdesc Represents a GetActiveUserListRequest.
         * @implements IGetActiveUserListRequest
         * @constructor
         * @param {auth.IGetActiveUserListRequest=} [properties] Properties to set
         */
        function GetActiveUserListRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetActiveUserListRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.GetActiveUserListRequest
         * @instance
         */
        GetActiveUserListRequest.prototype.domainName = 0;

        /**
         * GetActiveUserListRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.GetActiveUserListRequest
         * @instance
         */
        GetActiveUserListRequest.prototype.requestPayload = null;

        /**
         * Creates a new GetActiveUserListRequest instance using the specified properties.
         * @function create
         * @memberof auth.GetActiveUserListRequest
         * @static
         * @param {auth.IGetActiveUserListRequest=} [properties] Properties to set
         * @returns {auth.GetActiveUserListRequest} GetActiveUserListRequest instance
         */
        GetActiveUserListRequest.create = function create(properties) {
            return new GetActiveUserListRequest(properties);
        };

        /**
         * Creates a GetActiveUserListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetActiveUserListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetActiveUserListRequest} GetActiveUserListRequest
         */
        GetActiveUserListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetActiveUserListRequest)
                return object;
            let message = new $root.auth.GetActiveUserListRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.GetActiveUserListRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetActiveUserListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetActiveUserListRequest
         * @static
         * @param {auth.GetActiveUserListRequest} message GetActiveUserListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetActiveUserListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.requestPayload = null;
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this GetActiveUserListRequest to JSON.
         * @function toJSON
         * @memberof auth.GetActiveUserListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetActiveUserListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetActiveUserListRequest;
    })();

    auth.GetActiveUserListResponse = (function() {

        /**
         * Properties of a GetActiveUserListResponse.
         * @memberof auth
         * @interface IGetActiveUserListResponse
         * @property {Array.<number|Long>|null} [userIds] GetActiveUserListResponse userIds
         * @property {common.ResponseCode.Enum|null} [responseCode] GetActiveUserListResponse responseCode
         * @property {string|null} [responseMessage] GetActiveUserListResponse responseMessage
         */

        /**
         * Constructs a new GetActiveUserListResponse.
         * @memberof auth
         * @classdesc Represents a GetActiveUserListResponse.
         * @implements IGetActiveUserListResponse
         * @constructor
         * @param {auth.IGetActiveUserListResponse=} [properties] Properties to set
         */
        function GetActiveUserListResponse(properties) {
            this.userIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetActiveUserListResponse userIds.
         * @member {Array.<number|Long>} userIds
         * @memberof auth.GetActiveUserListResponse
         * @instance
         */
        GetActiveUserListResponse.prototype.userIds = $util.emptyArray;

        /**
         * GetActiveUserListResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.GetActiveUserListResponse
         * @instance
         */
        GetActiveUserListResponse.prototype.responseCode = 0;

        /**
         * GetActiveUserListResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.GetActiveUserListResponse
         * @instance
         */
        GetActiveUserListResponse.prototype.responseMessage = "";

        /**
         * Creates a new GetActiveUserListResponse instance using the specified properties.
         * @function create
         * @memberof auth.GetActiveUserListResponse
         * @static
         * @param {auth.IGetActiveUserListResponse=} [properties] Properties to set
         * @returns {auth.GetActiveUserListResponse} GetActiveUserListResponse instance
         */
        GetActiveUserListResponse.create = function create(properties) {
            return new GetActiveUserListResponse(properties);
        };

        /**
         * Creates a GetActiveUserListResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetActiveUserListResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetActiveUserListResponse} GetActiveUserListResponse
         */
        GetActiveUserListResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetActiveUserListResponse)
                return object;
            let message = new $root.auth.GetActiveUserListResponse();
            if (object.userIds) {
                if (!Array.isArray(object.userIds))
                    throw TypeError(".auth.GetActiveUserListResponse.userIds: array expected");
                message.userIds = [];
                for (let i = 0; i < object.userIds.length; ++i)
                    if ($util.Long)
                        (message.userIds[i] = $util.Long.fromValue(object.userIds[i])).unsigned = false;
                    else if (typeof object.userIds[i] === "string")
                        message.userIds[i] = parseInt(object.userIds[i], 10);
                    else if (typeof object.userIds[i] === "number")
                        message.userIds[i] = object.userIds[i];
                    else if (typeof object.userIds[i] === "object")
                        message.userIds[i] = new $util.LongBits(object.userIds[i].low >>> 0, object.userIds[i].high >>> 0).toNumber();
            }
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a GetActiveUserListResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetActiveUserListResponse
         * @static
         * @param {auth.GetActiveUserListResponse} message GetActiveUserListResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetActiveUserListResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userIds = [];
            if (options.defaults) {
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.userIds && message.userIds.length) {
                object.userIds = [];
                for (let j = 0; j < message.userIds.length; ++j)
                    if (typeof message.userIds[j] === "number")
                        object.userIds[j] = options.longs === String ? String(message.userIds[j]) : message.userIds[j];
                    else
                        object.userIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.userIds[j]) : options.longs === Number ? new $util.LongBits(message.userIds[j].low >>> 0, message.userIds[j].high >>> 0).toNumber() : message.userIds[j];
            }
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this GetActiveUserListResponse to JSON.
         * @function toJSON
         * @memberof auth.GetActiveUserListResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetActiveUserListResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetActiveUserListResponse;
    })();

    auth.ValidateAuthCredentialRequest = (function() {

        /**
         * Properties of a ValidateAuthCredentialRequest.
         * @memberof auth
         * @interface IValidateAuthCredentialRequest
         * @property {auth.IAuthCredential|null} [authCredential] ValidateAuthCredentialRequest authCredential
         */

        /**
         * Constructs a new ValidateAuthCredentialRequest.
         * @memberof auth
         * @classdesc Represents a ValidateAuthCredentialRequest.
         * @implements IValidateAuthCredentialRequest
         * @constructor
         * @param {auth.IValidateAuthCredentialRequest=} [properties] Properties to set
         */
        function ValidateAuthCredentialRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateAuthCredentialRequest authCredential.
         * @member {auth.IAuthCredential|null|undefined} authCredential
         * @memberof auth.ValidateAuthCredentialRequest
         * @instance
         */
        ValidateAuthCredentialRequest.prototype.authCredential = null;

        /**
         * Creates a new ValidateAuthCredentialRequest instance using the specified properties.
         * @function create
         * @memberof auth.ValidateAuthCredentialRequest
         * @static
         * @param {auth.IValidateAuthCredentialRequest=} [properties] Properties to set
         * @returns {auth.ValidateAuthCredentialRequest} ValidateAuthCredentialRequest instance
         */
        ValidateAuthCredentialRequest.create = function create(properties) {
            return new ValidateAuthCredentialRequest(properties);
        };

        /**
         * Creates a ValidateAuthCredentialRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ValidateAuthCredentialRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ValidateAuthCredentialRequest} ValidateAuthCredentialRequest
         */
        ValidateAuthCredentialRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ValidateAuthCredentialRequest)
                return object;
            let message = new $root.auth.ValidateAuthCredentialRequest();
            if (object.authCredential != null) {
                if (typeof object.authCredential !== "object")
                    throw TypeError(".auth.ValidateAuthCredentialRequest.authCredential: object expected");
                message.authCredential = $root.auth.AuthCredential.fromObject(object.authCredential);
            }
            return message;
        };

        /**
         * Creates a plain object from a ValidateAuthCredentialRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ValidateAuthCredentialRequest
         * @static
         * @param {auth.ValidateAuthCredentialRequest} message ValidateAuthCredentialRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateAuthCredentialRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.authCredential = null;
            if (message.authCredential != null && message.hasOwnProperty("authCredential"))
                object.authCredential = $root.auth.AuthCredential.toObject(message.authCredential, options);
            return object;
        };

        /**
         * Converts this ValidateAuthCredentialRequest to JSON.
         * @function toJSON
         * @memberof auth.ValidateAuthCredentialRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateAuthCredentialRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValidateAuthCredentialRequest;
    })();

    auth.ValidateAuthCredentialResponse = (function() {

        /**
         * Properties of a ValidateAuthCredentialResponse.
         * @memberof auth
         * @interface IValidateAuthCredentialResponse
         * @property {boolean|null} [status] ValidateAuthCredentialResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] ValidateAuthCredentialResponse responseCode
         * @property {string|null} [responseMessage] ValidateAuthCredentialResponse responseMessage
         */

        /**
         * Constructs a new ValidateAuthCredentialResponse.
         * @memberof auth
         * @classdesc Represents a ValidateAuthCredentialResponse.
         * @implements IValidateAuthCredentialResponse
         * @constructor
         * @param {auth.IValidateAuthCredentialResponse=} [properties] Properties to set
         */
        function ValidateAuthCredentialResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateAuthCredentialResponse status.
         * @member {boolean} status
         * @memberof auth.ValidateAuthCredentialResponse
         * @instance
         */
        ValidateAuthCredentialResponse.prototype.status = false;

        /**
         * ValidateAuthCredentialResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.ValidateAuthCredentialResponse
         * @instance
         */
        ValidateAuthCredentialResponse.prototype.responseCode = 0;

        /**
         * ValidateAuthCredentialResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.ValidateAuthCredentialResponse
         * @instance
         */
        ValidateAuthCredentialResponse.prototype.responseMessage = "";

        /**
         * Creates a new ValidateAuthCredentialResponse instance using the specified properties.
         * @function create
         * @memberof auth.ValidateAuthCredentialResponse
         * @static
         * @param {auth.IValidateAuthCredentialResponse=} [properties] Properties to set
         * @returns {auth.ValidateAuthCredentialResponse} ValidateAuthCredentialResponse instance
         */
        ValidateAuthCredentialResponse.create = function create(properties) {
            return new ValidateAuthCredentialResponse(properties);
        };

        /**
         * Creates a ValidateAuthCredentialResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ValidateAuthCredentialResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ValidateAuthCredentialResponse} ValidateAuthCredentialResponse
         */
        ValidateAuthCredentialResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ValidateAuthCredentialResponse)
                return object;
            let message = new $root.auth.ValidateAuthCredentialResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a ValidateAuthCredentialResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ValidateAuthCredentialResponse
         * @static
         * @param {auth.ValidateAuthCredentialResponse} message ValidateAuthCredentialResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateAuthCredentialResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this ValidateAuthCredentialResponse to JSON.
         * @function toJSON
         * @memberof auth.ValidateAuthCredentialResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateAuthCredentialResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValidateAuthCredentialResponse;
    })();

    auth.RenewAuthCredentialRequest = (function() {

        /**
         * Properties of a RenewAuthCredentialRequest.
         * @memberof auth
         * @interface IRenewAuthCredentialRequest
         * @property {auth.IAuthCredential|null} [authCredential] RenewAuthCredentialRequest authCredential
         */

        /**
         * Constructs a new RenewAuthCredentialRequest.
         * @memberof auth
         * @classdesc Represents a RenewAuthCredentialRequest.
         * @implements IRenewAuthCredentialRequest
         * @constructor
         * @param {auth.IRenewAuthCredentialRequest=} [properties] Properties to set
         */
        function RenewAuthCredentialRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenewAuthCredentialRequest authCredential.
         * @member {auth.IAuthCredential|null|undefined} authCredential
         * @memberof auth.RenewAuthCredentialRequest
         * @instance
         */
        RenewAuthCredentialRequest.prototype.authCredential = null;

        /**
         * Creates a new RenewAuthCredentialRequest instance using the specified properties.
         * @function create
         * @memberof auth.RenewAuthCredentialRequest
         * @static
         * @param {auth.IRenewAuthCredentialRequest=} [properties] Properties to set
         * @returns {auth.RenewAuthCredentialRequest} RenewAuthCredentialRequest instance
         */
        RenewAuthCredentialRequest.create = function create(properties) {
            return new RenewAuthCredentialRequest(properties);
        };

        /**
         * Creates a RenewAuthCredentialRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.RenewAuthCredentialRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.RenewAuthCredentialRequest} RenewAuthCredentialRequest
         */
        RenewAuthCredentialRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.RenewAuthCredentialRequest)
                return object;
            let message = new $root.auth.RenewAuthCredentialRequest();
            if (object.authCredential != null) {
                if (typeof object.authCredential !== "object")
                    throw TypeError(".auth.RenewAuthCredentialRequest.authCredential: object expected");
                message.authCredential = $root.auth.AuthCredential.fromObject(object.authCredential);
            }
            return message;
        };

        /**
         * Creates a plain object from a RenewAuthCredentialRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.RenewAuthCredentialRequest
         * @static
         * @param {auth.RenewAuthCredentialRequest} message RenewAuthCredentialRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenewAuthCredentialRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.authCredential = null;
            if (message.authCredential != null && message.hasOwnProperty("authCredential"))
                object.authCredential = $root.auth.AuthCredential.toObject(message.authCredential, options);
            return object;
        };

        /**
         * Converts this RenewAuthCredentialRequest to JSON.
         * @function toJSON
         * @memberof auth.RenewAuthCredentialRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenewAuthCredentialRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RenewAuthCredentialRequest;
    })();

    auth.RenewAuthCredentialResponse = (function() {

        /**
         * Properties of a RenewAuthCredentialResponse.
         * @memberof auth
         * @interface IRenewAuthCredentialResponse
         * @property {auth.IAuthCredential|null} [newAuthCredential] RenewAuthCredentialResponse newAuthCredential
         * @property {boolean|null} [status] RenewAuthCredentialResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] RenewAuthCredentialResponse responseCode
         * @property {string|null} [responseMessage] RenewAuthCredentialResponse responseMessage
         */

        /**
         * Constructs a new RenewAuthCredentialResponse.
         * @memberof auth
         * @classdesc Represents a RenewAuthCredentialResponse.
         * @implements IRenewAuthCredentialResponse
         * @constructor
         * @param {auth.IRenewAuthCredentialResponse=} [properties] Properties to set
         */
        function RenewAuthCredentialResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenewAuthCredentialResponse newAuthCredential.
         * @member {auth.IAuthCredential|null|undefined} newAuthCredential
         * @memberof auth.RenewAuthCredentialResponse
         * @instance
         */
        RenewAuthCredentialResponse.prototype.newAuthCredential = null;

        /**
         * RenewAuthCredentialResponse status.
         * @member {boolean} status
         * @memberof auth.RenewAuthCredentialResponse
         * @instance
         */
        RenewAuthCredentialResponse.prototype.status = false;

        /**
         * RenewAuthCredentialResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.RenewAuthCredentialResponse
         * @instance
         */
        RenewAuthCredentialResponse.prototype.responseCode = 0;

        /**
         * RenewAuthCredentialResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.RenewAuthCredentialResponse
         * @instance
         */
        RenewAuthCredentialResponse.prototype.responseMessage = "";

        /**
         * Creates a new RenewAuthCredentialResponse instance using the specified properties.
         * @function create
         * @memberof auth.RenewAuthCredentialResponse
         * @static
         * @param {auth.IRenewAuthCredentialResponse=} [properties] Properties to set
         * @returns {auth.RenewAuthCredentialResponse} RenewAuthCredentialResponse instance
         */
        RenewAuthCredentialResponse.create = function create(properties) {
            return new RenewAuthCredentialResponse(properties);
        };

        /**
         * Creates a RenewAuthCredentialResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.RenewAuthCredentialResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.RenewAuthCredentialResponse} RenewAuthCredentialResponse
         */
        RenewAuthCredentialResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.RenewAuthCredentialResponse)
                return object;
            let message = new $root.auth.RenewAuthCredentialResponse();
            if (object.newAuthCredential != null) {
                if (typeof object.newAuthCredential !== "object")
                    throw TypeError(".auth.RenewAuthCredentialResponse.newAuthCredential: object expected");
                message.newAuthCredential = $root.auth.AuthCredential.fromObject(object.newAuthCredential);
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a RenewAuthCredentialResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.RenewAuthCredentialResponse
         * @static
         * @param {auth.RenewAuthCredentialResponse} message RenewAuthCredentialResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenewAuthCredentialResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.newAuthCredential = null;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.newAuthCredential != null && message.hasOwnProperty("newAuthCredential"))
                object.newAuthCredential = $root.auth.AuthCredential.toObject(message.newAuthCredential, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this RenewAuthCredentialResponse to JSON.
         * @function toJSON
         * @memberof auth.RenewAuthCredentialResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenewAuthCredentialResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RenewAuthCredentialResponse;
    })();

    auth.ChangePasswordRequest = (function() {

        /**
         * Properties of a ChangePasswordRequest.
         * @memberof auth
         * @interface IChangePasswordRequest
         * @property {auth.DomainName.Enum|null} [domainName] ChangePasswordRequest domainName
         * @property {string|null} [email] ChangePasswordRequest email
         * @property {string|null} [currentPassword] ChangePasswordRequest currentPassword
         * @property {string|null} [newPassword] ChangePasswordRequest newPassword
         */

        /**
         * Constructs a new ChangePasswordRequest.
         * @memberof auth
         * @classdesc Represents a ChangePasswordRequest.
         * @implements IChangePasswordRequest
         * @constructor
         * @param {auth.IChangePasswordRequest=} [properties] Properties to set
         */
        function ChangePasswordRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChangePasswordRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.ChangePasswordRequest
         * @instance
         */
        ChangePasswordRequest.prototype.domainName = 0;

        /**
         * ChangePasswordRequest email.
         * @member {string} email
         * @memberof auth.ChangePasswordRequest
         * @instance
         */
        ChangePasswordRequest.prototype.email = "";

        /**
         * ChangePasswordRequest currentPassword.
         * @member {string} currentPassword
         * @memberof auth.ChangePasswordRequest
         * @instance
         */
        ChangePasswordRequest.prototype.currentPassword = "";

        /**
         * ChangePasswordRequest newPassword.
         * @member {string} newPassword
         * @memberof auth.ChangePasswordRequest
         * @instance
         */
        ChangePasswordRequest.prototype.newPassword = "";

        /**
         * Creates a new ChangePasswordRequest instance using the specified properties.
         * @function create
         * @memberof auth.ChangePasswordRequest
         * @static
         * @param {auth.IChangePasswordRequest=} [properties] Properties to set
         * @returns {auth.ChangePasswordRequest} ChangePasswordRequest instance
         */
        ChangePasswordRequest.create = function create(properties) {
            return new ChangePasswordRequest(properties);
        };

        /**
         * Creates a ChangePasswordRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ChangePasswordRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ChangePasswordRequest} ChangePasswordRequest
         */
        ChangePasswordRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ChangePasswordRequest)
                return object;
            let message = new $root.auth.ChangePasswordRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.currentPassword != null)
                message.currentPassword = String(object.currentPassword);
            if (object.newPassword != null)
                message.newPassword = String(object.newPassword);
            return message;
        };

        /**
         * Creates a plain object from a ChangePasswordRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ChangePasswordRequest
         * @static
         * @param {auth.ChangePasswordRequest} message ChangePasswordRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChangePasswordRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.email = "";
                object.currentPassword = "";
                object.newPassword = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.currentPassword != null && message.hasOwnProperty("currentPassword"))
                object.currentPassword = message.currentPassword;
            if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                object.newPassword = message.newPassword;
            return object;
        };

        /**
         * Converts this ChangePasswordRequest to JSON.
         * @function toJSON
         * @memberof auth.ChangePasswordRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChangePasswordRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChangePasswordRequest;
    })();

    auth.ChangePasswordResponse = (function() {

        /**
         * Properties of a ChangePasswordResponse.
         * @memberof auth
         * @interface IChangePasswordResponse
         * @property {boolean|null} [status] ChangePasswordResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] ChangePasswordResponse responseCode
         * @property {string|null} [responseMessage] ChangePasswordResponse responseMessage
         */

        /**
         * Constructs a new ChangePasswordResponse.
         * @memberof auth
         * @classdesc Represents a ChangePasswordResponse.
         * @implements IChangePasswordResponse
         * @constructor
         * @param {auth.IChangePasswordResponse=} [properties] Properties to set
         */
        function ChangePasswordResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChangePasswordResponse status.
         * @member {boolean} status
         * @memberof auth.ChangePasswordResponse
         * @instance
         */
        ChangePasswordResponse.prototype.status = false;

        /**
         * ChangePasswordResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.ChangePasswordResponse
         * @instance
         */
        ChangePasswordResponse.prototype.responseCode = 0;

        /**
         * ChangePasswordResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.ChangePasswordResponse
         * @instance
         */
        ChangePasswordResponse.prototype.responseMessage = "";

        /**
         * Creates a new ChangePasswordResponse instance using the specified properties.
         * @function create
         * @memberof auth.ChangePasswordResponse
         * @static
         * @param {auth.IChangePasswordResponse=} [properties] Properties to set
         * @returns {auth.ChangePasswordResponse} ChangePasswordResponse instance
         */
        ChangePasswordResponse.create = function create(properties) {
            return new ChangePasswordResponse(properties);
        };

        /**
         * Creates a ChangePasswordResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ChangePasswordResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ChangePasswordResponse} ChangePasswordResponse
         */
        ChangePasswordResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ChangePasswordResponse)
                return object;
            let message = new $root.auth.ChangePasswordResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a ChangePasswordResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ChangePasswordResponse
         * @static
         * @param {auth.ChangePasswordResponse} message ChangePasswordResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChangePasswordResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this ChangePasswordResponse to JSON.
         * @function toJSON
         * @memberof auth.ChangePasswordResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChangePasswordResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChangePasswordResponse;
    })();

    auth.ResetPasswordRequest = (function() {

        /**
         * Properties of a ResetPasswordRequest.
         * @memberof auth
         * @interface IResetPasswordRequest
         * @property {auth.DomainName.Enum|null} [domainName] ResetPasswordRequest domainName
         * @property {string|null} [email] ResetPasswordRequest email
         * @property {string|null} [passwordResetCode] ResetPasswordRequest passwordResetCode
         * @property {string|null} [newPassword] ResetPasswordRequest newPassword
         */

        /**
         * Constructs a new ResetPasswordRequest.
         * @memberof auth
         * @classdesc Represents a ResetPasswordRequest.
         * @implements IResetPasswordRequest
         * @constructor
         * @param {auth.IResetPasswordRequest=} [properties] Properties to set
         */
        function ResetPasswordRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetPasswordRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.ResetPasswordRequest
         * @instance
         */
        ResetPasswordRequest.prototype.domainName = 0;

        /**
         * ResetPasswordRequest email.
         * @member {string} email
         * @memberof auth.ResetPasswordRequest
         * @instance
         */
        ResetPasswordRequest.prototype.email = "";

        /**
         * ResetPasswordRequest passwordResetCode.
         * @member {string} passwordResetCode
         * @memberof auth.ResetPasswordRequest
         * @instance
         */
        ResetPasswordRequest.prototype.passwordResetCode = "";

        /**
         * ResetPasswordRequest newPassword.
         * @member {string} newPassword
         * @memberof auth.ResetPasswordRequest
         * @instance
         */
        ResetPasswordRequest.prototype.newPassword = "";

        /**
         * Creates a new ResetPasswordRequest instance using the specified properties.
         * @function create
         * @memberof auth.ResetPasswordRequest
         * @static
         * @param {auth.IResetPasswordRequest=} [properties] Properties to set
         * @returns {auth.ResetPasswordRequest} ResetPasswordRequest instance
         */
        ResetPasswordRequest.create = function create(properties) {
            return new ResetPasswordRequest(properties);
        };

        /**
         * Creates a ResetPasswordRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ResetPasswordRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ResetPasswordRequest} ResetPasswordRequest
         */
        ResetPasswordRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ResetPasswordRequest)
                return object;
            let message = new $root.auth.ResetPasswordRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.passwordResetCode != null)
                message.passwordResetCode = String(object.passwordResetCode);
            if (object.newPassword != null)
                message.newPassword = String(object.newPassword);
            return message;
        };

        /**
         * Creates a plain object from a ResetPasswordRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ResetPasswordRequest
         * @static
         * @param {auth.ResetPasswordRequest} message ResetPasswordRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetPasswordRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.email = "";
                object.passwordResetCode = "";
                object.newPassword = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.passwordResetCode != null && message.hasOwnProperty("passwordResetCode"))
                object.passwordResetCode = message.passwordResetCode;
            if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                object.newPassword = message.newPassword;
            return object;
        };

        /**
         * Converts this ResetPasswordRequest to JSON.
         * @function toJSON
         * @memberof auth.ResetPasswordRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetPasswordRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetPasswordRequest;
    })();

    auth.ResetPasswordResponse = (function() {

        /**
         * Properties of a ResetPasswordResponse.
         * @memberof auth
         * @interface IResetPasswordResponse
         * @property {boolean|null} [status] ResetPasswordResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] ResetPasswordResponse responseCode
         * @property {string|null} [responseMessage] ResetPasswordResponse responseMessage
         */

        /**
         * Constructs a new ResetPasswordResponse.
         * @memberof auth
         * @classdesc Represents a ResetPasswordResponse.
         * @implements IResetPasswordResponse
         * @constructor
         * @param {auth.IResetPasswordResponse=} [properties] Properties to set
         */
        function ResetPasswordResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetPasswordResponse status.
         * @member {boolean} status
         * @memberof auth.ResetPasswordResponse
         * @instance
         */
        ResetPasswordResponse.prototype.status = false;

        /**
         * ResetPasswordResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.ResetPasswordResponse
         * @instance
         */
        ResetPasswordResponse.prototype.responseCode = 0;

        /**
         * ResetPasswordResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.ResetPasswordResponse
         * @instance
         */
        ResetPasswordResponse.prototype.responseMessage = "";

        /**
         * Creates a new ResetPasswordResponse instance using the specified properties.
         * @function create
         * @memberof auth.ResetPasswordResponse
         * @static
         * @param {auth.IResetPasswordResponse=} [properties] Properties to set
         * @returns {auth.ResetPasswordResponse} ResetPasswordResponse instance
         */
        ResetPasswordResponse.create = function create(properties) {
            return new ResetPasswordResponse(properties);
        };

        /**
         * Creates a ResetPasswordResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ResetPasswordResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ResetPasswordResponse} ResetPasswordResponse
         */
        ResetPasswordResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ResetPasswordResponse)
                return object;
            let message = new $root.auth.ResetPasswordResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a ResetPasswordResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ResetPasswordResponse
         * @static
         * @param {auth.ResetPasswordResponse} message ResetPasswordResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetPasswordResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this ResetPasswordResponse to JSON.
         * @function toJSON
         * @memberof auth.ResetPasswordResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetPasswordResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetPasswordResponse;
    })();

    auth.SendPasswordResetEmailRequest = (function() {

        /**
         * Properties of a SendPasswordResetEmailRequest.
         * @memberof auth
         * @interface ISendPasswordResetEmailRequest
         * @property {auth.DomainName.Enum|null} [domainName] SendPasswordResetEmailRequest domainName
         * @property {string|null} [email] SendPasswordResetEmailRequest email
         */

        /**
         * Constructs a new SendPasswordResetEmailRequest.
         * @memberof auth
         * @classdesc Represents a SendPasswordResetEmailRequest.
         * @implements ISendPasswordResetEmailRequest
         * @constructor
         * @param {auth.ISendPasswordResetEmailRequest=} [properties] Properties to set
         */
        function SendPasswordResetEmailRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendPasswordResetEmailRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.SendPasswordResetEmailRequest
         * @instance
         */
        SendPasswordResetEmailRequest.prototype.domainName = 0;

        /**
         * SendPasswordResetEmailRequest email.
         * @member {string} email
         * @memberof auth.SendPasswordResetEmailRequest
         * @instance
         */
        SendPasswordResetEmailRequest.prototype.email = "";

        /**
         * Creates a new SendPasswordResetEmailRequest instance using the specified properties.
         * @function create
         * @memberof auth.SendPasswordResetEmailRequest
         * @static
         * @param {auth.ISendPasswordResetEmailRequest=} [properties] Properties to set
         * @returns {auth.SendPasswordResetEmailRequest} SendPasswordResetEmailRequest instance
         */
        SendPasswordResetEmailRequest.create = function create(properties) {
            return new SendPasswordResetEmailRequest(properties);
        };

        /**
         * Creates a SendPasswordResetEmailRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SendPasswordResetEmailRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SendPasswordResetEmailRequest} SendPasswordResetEmailRequest
         */
        SendPasswordResetEmailRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SendPasswordResetEmailRequest)
                return object;
            let message = new $root.auth.SendPasswordResetEmailRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a SendPasswordResetEmailRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SendPasswordResetEmailRequest
         * @static
         * @param {auth.SendPasswordResetEmailRequest} message SendPasswordResetEmailRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendPasswordResetEmailRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.email = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this SendPasswordResetEmailRequest to JSON.
         * @function toJSON
         * @memberof auth.SendPasswordResetEmailRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendPasswordResetEmailRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SendPasswordResetEmailRequest;
    })();

    auth.SendPasswordResetEmailResponse = (function() {

        /**
         * Properties of a SendPasswordResetEmailResponse.
         * @memberof auth
         * @interface ISendPasswordResetEmailResponse
         * @property {boolean|null} [status] SendPasswordResetEmailResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] SendPasswordResetEmailResponse responseCode
         * @property {string|null} [responseMessage] SendPasswordResetEmailResponse responseMessage
         */

        /**
         * Constructs a new SendPasswordResetEmailResponse.
         * @memberof auth
         * @classdesc Represents a SendPasswordResetEmailResponse.
         * @implements ISendPasswordResetEmailResponse
         * @constructor
         * @param {auth.ISendPasswordResetEmailResponse=} [properties] Properties to set
         */
        function SendPasswordResetEmailResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendPasswordResetEmailResponse status.
         * @member {boolean} status
         * @memberof auth.SendPasswordResetEmailResponse
         * @instance
         */
        SendPasswordResetEmailResponse.prototype.status = false;

        /**
         * SendPasswordResetEmailResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.SendPasswordResetEmailResponse
         * @instance
         */
        SendPasswordResetEmailResponse.prototype.responseCode = 0;

        /**
         * SendPasswordResetEmailResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.SendPasswordResetEmailResponse
         * @instance
         */
        SendPasswordResetEmailResponse.prototype.responseMessage = "";

        /**
         * Creates a new SendPasswordResetEmailResponse instance using the specified properties.
         * @function create
         * @memberof auth.SendPasswordResetEmailResponse
         * @static
         * @param {auth.ISendPasswordResetEmailResponse=} [properties] Properties to set
         * @returns {auth.SendPasswordResetEmailResponse} SendPasswordResetEmailResponse instance
         */
        SendPasswordResetEmailResponse.create = function create(properties) {
            return new SendPasswordResetEmailResponse(properties);
        };

        /**
         * Creates a SendPasswordResetEmailResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SendPasswordResetEmailResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SendPasswordResetEmailResponse} SendPasswordResetEmailResponse
         */
        SendPasswordResetEmailResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SendPasswordResetEmailResponse)
                return object;
            let message = new $root.auth.SendPasswordResetEmailResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a SendPasswordResetEmailResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SendPasswordResetEmailResponse
         * @static
         * @param {auth.SendPasswordResetEmailResponse} message SendPasswordResetEmailResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendPasswordResetEmailResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this SendPasswordResetEmailResponse to JSON.
         * @function toJSON
         * @memberof auth.SendPasswordResetEmailResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendPasswordResetEmailResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SendPasswordResetEmailResponse;
    })();

    auth.SendEmailValidationCodeRequest = (function() {

        /**
         * Properties of a SendEmailValidationCodeRequest.
         * @memberof auth
         * @interface ISendEmailValidationCodeRequest
         * @property {auth.DomainName.Enum|null} [domainName] SendEmailValidationCodeRequest domainName
         * @property {string|null} [email] SendEmailValidationCodeRequest email
         */

        /**
         * Constructs a new SendEmailValidationCodeRequest.
         * @memberof auth
         * @classdesc Represents a SendEmailValidationCodeRequest.
         * @implements ISendEmailValidationCodeRequest
         * @constructor
         * @param {auth.ISendEmailValidationCodeRequest=} [properties] Properties to set
         */
        function SendEmailValidationCodeRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendEmailValidationCodeRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.SendEmailValidationCodeRequest
         * @instance
         */
        SendEmailValidationCodeRequest.prototype.domainName = 0;

        /**
         * SendEmailValidationCodeRequest email.
         * @member {string} email
         * @memberof auth.SendEmailValidationCodeRequest
         * @instance
         */
        SendEmailValidationCodeRequest.prototype.email = "";

        /**
         * Creates a new SendEmailValidationCodeRequest instance using the specified properties.
         * @function create
         * @memberof auth.SendEmailValidationCodeRequest
         * @static
         * @param {auth.ISendEmailValidationCodeRequest=} [properties] Properties to set
         * @returns {auth.SendEmailValidationCodeRequest} SendEmailValidationCodeRequest instance
         */
        SendEmailValidationCodeRequest.create = function create(properties) {
            return new SendEmailValidationCodeRequest(properties);
        };

        /**
         * Creates a SendEmailValidationCodeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SendEmailValidationCodeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SendEmailValidationCodeRequest} SendEmailValidationCodeRequest
         */
        SendEmailValidationCodeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SendEmailValidationCodeRequest)
                return object;
            let message = new $root.auth.SendEmailValidationCodeRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a SendEmailValidationCodeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SendEmailValidationCodeRequest
         * @static
         * @param {auth.SendEmailValidationCodeRequest} message SendEmailValidationCodeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendEmailValidationCodeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.email = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this SendEmailValidationCodeRequest to JSON.
         * @function toJSON
         * @memberof auth.SendEmailValidationCodeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendEmailValidationCodeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SendEmailValidationCodeRequest;
    })();

    auth.SendEmailValidationCodeResponse = (function() {

        /**
         * Properties of a SendEmailValidationCodeResponse.
         * @memberof auth
         * @interface ISendEmailValidationCodeResponse
         * @property {boolean|null} [status] SendEmailValidationCodeResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] SendEmailValidationCodeResponse responseCode
         * @property {string|null} [responseMessage] SendEmailValidationCodeResponse responseMessage
         */

        /**
         * Constructs a new SendEmailValidationCodeResponse.
         * @memberof auth
         * @classdesc Represents a SendEmailValidationCodeResponse.
         * @implements ISendEmailValidationCodeResponse
         * @constructor
         * @param {auth.ISendEmailValidationCodeResponse=} [properties] Properties to set
         */
        function SendEmailValidationCodeResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendEmailValidationCodeResponse status.
         * @member {boolean} status
         * @memberof auth.SendEmailValidationCodeResponse
         * @instance
         */
        SendEmailValidationCodeResponse.prototype.status = false;

        /**
         * SendEmailValidationCodeResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.SendEmailValidationCodeResponse
         * @instance
         */
        SendEmailValidationCodeResponse.prototype.responseCode = 0;

        /**
         * SendEmailValidationCodeResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.SendEmailValidationCodeResponse
         * @instance
         */
        SendEmailValidationCodeResponse.prototype.responseMessage = "";

        /**
         * Creates a new SendEmailValidationCodeResponse instance using the specified properties.
         * @function create
         * @memberof auth.SendEmailValidationCodeResponse
         * @static
         * @param {auth.ISendEmailValidationCodeResponse=} [properties] Properties to set
         * @returns {auth.SendEmailValidationCodeResponse} SendEmailValidationCodeResponse instance
         */
        SendEmailValidationCodeResponse.create = function create(properties) {
            return new SendEmailValidationCodeResponse(properties);
        };

        /**
         * Creates a SendEmailValidationCodeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SendEmailValidationCodeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SendEmailValidationCodeResponse} SendEmailValidationCodeResponse
         */
        SendEmailValidationCodeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SendEmailValidationCodeResponse)
                return object;
            let message = new $root.auth.SendEmailValidationCodeResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a SendEmailValidationCodeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SendEmailValidationCodeResponse
         * @static
         * @param {auth.SendEmailValidationCodeResponse} message SendEmailValidationCodeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendEmailValidationCodeResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this SendEmailValidationCodeResponse to JSON.
         * @function toJSON
         * @memberof auth.SendEmailValidationCodeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendEmailValidationCodeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SendEmailValidationCodeResponse;
    })();

    auth.ValidateEmailRequest = (function() {

        /**
         * Properties of a ValidateEmailRequest.
         * @memberof auth
         * @interface IValidateEmailRequest
         * @property {auth.DomainName.Enum|null} [domainName] ValidateEmailRequest domainName
         * @property {string|null} [email] ValidateEmailRequest email
         * @property {string|null} [validateToken] ValidateEmailRequest validateToken
         */

        /**
         * Constructs a new ValidateEmailRequest.
         * @memberof auth
         * @classdesc Represents a ValidateEmailRequest.
         * @implements IValidateEmailRequest
         * @constructor
         * @param {auth.IValidateEmailRequest=} [properties] Properties to set
         */
        function ValidateEmailRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateEmailRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.ValidateEmailRequest
         * @instance
         */
        ValidateEmailRequest.prototype.domainName = 0;

        /**
         * ValidateEmailRequest email.
         * @member {string} email
         * @memberof auth.ValidateEmailRequest
         * @instance
         */
        ValidateEmailRequest.prototype.email = "";

        /**
         * ValidateEmailRequest validateToken.
         * @member {string} validateToken
         * @memberof auth.ValidateEmailRequest
         * @instance
         */
        ValidateEmailRequest.prototype.validateToken = "";

        /**
         * Creates a new ValidateEmailRequest instance using the specified properties.
         * @function create
         * @memberof auth.ValidateEmailRequest
         * @static
         * @param {auth.IValidateEmailRequest=} [properties] Properties to set
         * @returns {auth.ValidateEmailRequest} ValidateEmailRequest instance
         */
        ValidateEmailRequest.create = function create(properties) {
            return new ValidateEmailRequest(properties);
        };

        /**
         * Creates a ValidateEmailRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ValidateEmailRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ValidateEmailRequest} ValidateEmailRequest
         */
        ValidateEmailRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ValidateEmailRequest)
                return object;
            let message = new $root.auth.ValidateEmailRequest();
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.validateToken != null)
                message.validateToken = String(object.validateToken);
            return message;
        };

        /**
         * Creates a plain object from a ValidateEmailRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ValidateEmailRequest
         * @static
         * @param {auth.ValidateEmailRequest} message ValidateEmailRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateEmailRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.email = "";
                object.validateToken = "";
            }
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.validateToken != null && message.hasOwnProperty("validateToken"))
                object.validateToken = message.validateToken;
            return object;
        };

        /**
         * Converts this ValidateEmailRequest to JSON.
         * @function toJSON
         * @memberof auth.ValidateEmailRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateEmailRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValidateEmailRequest;
    })();

    auth.ValidateEmailResponse = (function() {

        /**
         * Properties of a ValidateEmailResponse.
         * @memberof auth
         * @interface IValidateEmailResponse
         * @property {boolean|null} [status] ValidateEmailResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] ValidateEmailResponse responseCode
         * @property {string|null} [responseMessage] ValidateEmailResponse responseMessage
         */

        /**
         * Constructs a new ValidateEmailResponse.
         * @memberof auth
         * @classdesc Represents a ValidateEmailResponse.
         * @implements IValidateEmailResponse
         * @constructor
         * @param {auth.IValidateEmailResponse=} [properties] Properties to set
         */
        function ValidateEmailResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateEmailResponse status.
         * @member {boolean} status
         * @memberof auth.ValidateEmailResponse
         * @instance
         */
        ValidateEmailResponse.prototype.status = false;

        /**
         * ValidateEmailResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.ValidateEmailResponse
         * @instance
         */
        ValidateEmailResponse.prototype.responseCode = 0;

        /**
         * ValidateEmailResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.ValidateEmailResponse
         * @instance
         */
        ValidateEmailResponse.prototype.responseMessage = "";

        /**
         * Creates a new ValidateEmailResponse instance using the specified properties.
         * @function create
         * @memberof auth.ValidateEmailResponse
         * @static
         * @param {auth.IValidateEmailResponse=} [properties] Properties to set
         * @returns {auth.ValidateEmailResponse} ValidateEmailResponse instance
         */
        ValidateEmailResponse.create = function create(properties) {
            return new ValidateEmailResponse(properties);
        };

        /**
         * Creates a ValidateEmailResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.ValidateEmailResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.ValidateEmailResponse} ValidateEmailResponse
         */
        ValidateEmailResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.ValidateEmailResponse)
                return object;
            let message = new $root.auth.ValidateEmailResponse();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a ValidateEmailResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.ValidateEmailResponse
         * @static
         * @param {auth.ValidateEmailResponse} message ValidateEmailResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateEmailResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this ValidateEmailResponse to JSON.
         * @function toJSON
         * @memberof auth.ValidateEmailResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateEmailResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValidateEmailResponse;
    })();

    auth.GetUserIdRequest = (function() {

        /**
         * Properties of a GetUserIdRequest.
         * @memberof auth
         * @interface IGetUserIdRequest
         * @property {string|null} [username] GetUserIdRequest username
         * @property {auth.DomainName.Enum|null} [domainName] GetUserIdRequest domainName
         * @property {auth.IRequestPayload|null} [requestPayload] GetUserIdRequest requestPayload
         */

        /**
         * Constructs a new GetUserIdRequest.
         * @memberof auth
         * @classdesc Represents a GetUserIdRequest.
         * @implements IGetUserIdRequest
         * @constructor
         * @param {auth.IGetUserIdRequest=} [properties] Properties to set
         */
        function GetUserIdRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserIdRequest username.
         * @member {string} username
         * @memberof auth.GetUserIdRequest
         * @instance
         */
        GetUserIdRequest.prototype.username = "";

        /**
         * GetUserIdRequest domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.GetUserIdRequest
         * @instance
         */
        GetUserIdRequest.prototype.domainName = 0;

        /**
         * GetUserIdRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.GetUserIdRequest
         * @instance
         */
        GetUserIdRequest.prototype.requestPayload = null;

        /**
         * Creates a new GetUserIdRequest instance using the specified properties.
         * @function create
         * @memberof auth.GetUserIdRequest
         * @static
         * @param {auth.IGetUserIdRequest=} [properties] Properties to set
         * @returns {auth.GetUserIdRequest} GetUserIdRequest instance
         */
        GetUserIdRequest.create = function create(properties) {
            return new GetUserIdRequest(properties);
        };

        /**
         * Creates a GetUserIdRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserIdRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserIdRequest} GetUserIdRequest
         */
        GetUserIdRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserIdRequest)
                return object;
            let message = new $root.auth.GetUserIdRequest();
            if (object.username != null)
                message.username = String(object.username);
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.GetUserIdRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserIdRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserIdRequest
         * @static
         * @param {auth.GetUserIdRequest} message GetUserIdRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserIdRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.username = "";
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.requestPayload = null;
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this GetUserIdRequest to JSON.
         * @function toJSON
         * @memberof auth.GetUserIdRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserIdRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserIdRequest;
    })();

    auth.GetUserIdResponse = (function() {

        /**
         * Properties of a GetUserIdResponse.
         * @memberof auth
         * @interface IGetUserIdResponse
         * @property {number|Long|null} [userId] GetUserIdResponse userId
         * @property {boolean|null} [status] GetUserIdResponse status
         * @property {common.ResponseCode.Enum|null} [responseCode] GetUserIdResponse responseCode
         * @property {string|null} [responseMessage] GetUserIdResponse responseMessage
         */

        /**
         * Constructs a new GetUserIdResponse.
         * @memberof auth
         * @classdesc Represents a GetUserIdResponse.
         * @implements IGetUserIdResponse
         * @constructor
         * @param {auth.IGetUserIdResponse=} [properties] Properties to set
         */
        function GetUserIdResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserIdResponse userId.
         * @member {number|Long} userId
         * @memberof auth.GetUserIdResponse
         * @instance
         */
        GetUserIdResponse.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetUserIdResponse status.
         * @member {boolean} status
         * @memberof auth.GetUserIdResponse
         * @instance
         */
        GetUserIdResponse.prototype.status = false;

        /**
         * GetUserIdResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.GetUserIdResponse
         * @instance
         */
        GetUserIdResponse.prototype.responseCode = 0;

        /**
         * GetUserIdResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.GetUserIdResponse
         * @instance
         */
        GetUserIdResponse.prototype.responseMessage = "";

        /**
         * Creates a new GetUserIdResponse instance using the specified properties.
         * @function create
         * @memberof auth.GetUserIdResponse
         * @static
         * @param {auth.IGetUserIdResponse=} [properties] Properties to set
         * @returns {auth.GetUserIdResponse} GetUserIdResponse instance
         */
        GetUserIdResponse.create = function create(properties) {
            return new GetUserIdResponse(properties);
        };

        /**
         * Creates a GetUserIdResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.GetUserIdResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.GetUserIdResponse} GetUserIdResponse
         */
        GetUserIdResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.GetUserIdResponse)
                return object;
            let message = new $root.auth.GetUserIdResponse();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.status != null)
                message.status = Boolean(object.status);
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a GetUserIdResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.GetUserIdResponse
         * @static
         * @param {auth.GetUserIdResponse} message GetUserIdResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserIdResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.status = false;
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this GetUserIdResponse to JSON.
         * @function toJSON
         * @memberof auth.GetUserIdResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserIdResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserIdResponse;
    })();

    auth.SearchUserRequest = (function() {

        /**
         * Properties of a SearchUserRequest.
         * @memberof auth
         * @interface ISearchUserRequest
         * @property {string|null} [email] SearchUserRequest email
         * @property {string|null} [username] SearchUserRequest username
         * @property {string|null} [mobileNumber] SearchUserRequest mobileNumber
         * @property {string|null} [name] SearchUserRequest name
         * @property {auth.DomainName.Enum|null} [domain] SearchUserRequest domain
         * @property {auth.IRequestPayload|null} [requestPayload] SearchUserRequest requestPayload
         */

        /**
         * Constructs a new SearchUserRequest.
         * @memberof auth
         * @classdesc Represents a SearchUserRequest.
         * @implements ISearchUserRequest
         * @constructor
         * @param {auth.ISearchUserRequest=} [properties] Properties to set
         */
        function SearchUserRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchUserRequest email.
         * @member {string} email
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.email = "";

        /**
         * SearchUserRequest username.
         * @member {string} username
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.username = "";

        /**
         * SearchUserRequest mobileNumber.
         * @member {string} mobileNumber
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.mobileNumber = "";

        /**
         * SearchUserRequest name.
         * @member {string} name
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.name = "";

        /**
         * SearchUserRequest domain.
         * @member {auth.DomainName.Enum} domain
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.domain = 0;

        /**
         * SearchUserRequest requestPayload.
         * @member {auth.IRequestPayload|null|undefined} requestPayload
         * @memberof auth.SearchUserRequest
         * @instance
         */
        SearchUserRequest.prototype.requestPayload = null;

        /**
         * Creates a new SearchUserRequest instance using the specified properties.
         * @function create
         * @memberof auth.SearchUserRequest
         * @static
         * @param {auth.ISearchUserRequest=} [properties] Properties to set
         * @returns {auth.SearchUserRequest} SearchUserRequest instance
         */
        SearchUserRequest.create = function create(properties) {
            return new SearchUserRequest(properties);
        };

        /**
         * Creates a SearchUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SearchUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SearchUserRequest} SearchUserRequest
         */
        SearchUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SearchUserRequest)
                return object;
            let message = new $root.auth.SearchUserRequest();
            if (object.email != null)
                message.email = String(object.email);
            if (object.username != null)
                message.username = String(object.username);
            if (object.mobileNumber != null)
                message.mobileNumber = String(object.mobileNumber);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.domain) {
            case "DUNGULIE":
            case 0:
                message.domain = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domain = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domain = 2;
                break;
            case "TIMELY":
            case 3:
                message.domain = 3;
                break;
            }
            if (object.requestPayload != null) {
                if (typeof object.requestPayload !== "object")
                    throw TypeError(".auth.SearchUserRequest.requestPayload: object expected");
                message.requestPayload = $root.auth.RequestPayload.fromObject(object.requestPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SearchUserRequest
         * @static
         * @param {auth.SearchUserRequest} message SearchUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.username = "";
                object.mobileNumber = "";
                object.name = "";
                object.domain = options.enums === String ? "DUNGULIE" : 0;
                object.requestPayload = null;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
                object.mobileNumber = message.mobileNumber;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.domain != null && message.hasOwnProperty("domain"))
                object.domain = options.enums === String ? $root.auth.DomainName.Enum[message.domain] : message.domain;
            if (message.requestPayload != null && message.hasOwnProperty("requestPayload"))
                object.requestPayload = $root.auth.RequestPayload.toObject(message.requestPayload, options);
            return object;
        };

        /**
         * Converts this SearchUserRequest to JSON.
         * @function toJSON
         * @memberof auth.SearchUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchUserRequest;
    })();

    auth.SearchUserResponse = (function() {

        /**
         * Properties of a SearchUserResponse.
         * @memberof auth
         * @interface ISearchUserResponse
         * @property {Array.<auth.IUser>|null} [userList] SearchUserResponse userList
         * @property {common.ResponseCode.Enum|null} [responseCode] SearchUserResponse responseCode
         * @property {string|null} [responseMessage] SearchUserResponse responseMessage
         */

        /**
         * Constructs a new SearchUserResponse.
         * @memberof auth
         * @classdesc Represents a SearchUserResponse.
         * @implements ISearchUserResponse
         * @constructor
         * @param {auth.ISearchUserResponse=} [properties] Properties to set
         */
        function SearchUserResponse(properties) {
            this.userList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchUserResponse userList.
         * @member {Array.<auth.IUser>} userList
         * @memberof auth.SearchUserResponse
         * @instance
         */
        SearchUserResponse.prototype.userList = $util.emptyArray;

        /**
         * SearchUserResponse responseCode.
         * @member {common.ResponseCode.Enum} responseCode
         * @memberof auth.SearchUserResponse
         * @instance
         */
        SearchUserResponse.prototype.responseCode = 0;

        /**
         * SearchUserResponse responseMessage.
         * @member {string} responseMessage
         * @memberof auth.SearchUserResponse
         * @instance
         */
        SearchUserResponse.prototype.responseMessage = "";

        /**
         * Creates a new SearchUserResponse instance using the specified properties.
         * @function create
         * @memberof auth.SearchUserResponse
         * @static
         * @param {auth.ISearchUserResponse=} [properties] Properties to set
         * @returns {auth.SearchUserResponse} SearchUserResponse instance
         */
        SearchUserResponse.create = function create(properties) {
            return new SearchUserResponse(properties);
        };

        /**
         * Creates a SearchUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SearchUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SearchUserResponse} SearchUserResponse
         */
        SearchUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SearchUserResponse)
                return object;
            let message = new $root.auth.SearchUserResponse();
            if (object.userList) {
                if (!Array.isArray(object.userList))
                    throw TypeError(".auth.SearchUserResponse.userList: array expected");
                message.userList = [];
                for (let i = 0; i < object.userList.length; ++i) {
                    if (typeof object.userList[i] !== "object")
                        throw TypeError(".auth.SearchUserResponse.userList: object expected");
                    message.userList[i] = $root.auth.User.fromObject(object.userList[i]);
                }
            }
            switch (object.responseCode) {
            case "UNKNOWN":
            case 0:
                message.responseCode = 0;
                break;
            case "SUCCESS":
            case 1:
                message.responseCode = 1;
                break;
            case "AUTH_TOKEN_INVALID":
            case 2:
                message.responseCode = 2;
                break;
            case "AUTH_HAS_NO_PERMISSION":
            case 3:
                message.responseCode = 3;
                break;
            case "INPUT_INVALID":
            case 4:
                message.responseCode = 4;
                break;
            case "RESOURCE_NOT_FOUND":
            case 5:
                message.responseCode = 5;
                break;
            }
            if (object.responseMessage != null)
                message.responseMessage = String(object.responseMessage);
            return message;
        };

        /**
         * Creates a plain object from a SearchUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SearchUserResponse
         * @static
         * @param {auth.SearchUserResponse} message SearchUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchUserResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userList = [];
            if (options.defaults) {
                object.responseCode = options.enums === String ? "UNKNOWN" : 0;
                object.responseMessage = "";
            }
            if (message.userList && message.userList.length) {
                object.userList = [];
                for (let j = 0; j < message.userList.length; ++j)
                    object.userList[j] = $root.auth.User.toObject(message.userList[j], options);
            }
            if (message.responseCode != null && message.hasOwnProperty("responseCode"))
                object.responseCode = options.enums === String ? $root.common.ResponseCode.Enum[message.responseCode] : message.responseCode;
            if (message.responseMessage != null && message.hasOwnProperty("responseMessage"))
                object.responseMessage = message.responseMessage;
            return object;
        };

        /**
         * Converts this SearchUserResponse to JSON.
         * @function toJSON
         * @memberof auth.SearchUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchUserResponse;
    })();

    auth.User = (function() {

        /**
         * Properties of a User.
         * @memberof auth
         * @interface IUser
         * @property {number|Long|null} [id] User id
         * @property {string|null} [pageId] User pageId
         * @property {auth.DomainName.Enum|null} [domainName] User domainName
         * @property {auth.SignInType.Enum|null} [signInType] User signInType
         * @property {string|null} [username] User username
         * @property {string|null} [email] User email
         * @property {string|null} [phone] User phone
         * @property {string|null} [firstName] User firstName
         * @property {string|null} [lastName] User lastName
         * @property {string|null} [middleName] User middleName
         * @property {boolean|null} [emailVerified] User emailVerified
         * @property {boolean|null} [phoneVerified] User phoneVerified
         * @property {string|null} [facebookId] User facebookId
         * @property {string|null} [googleId] User googleId
         * @property {string|null} [firebaseId] User firebaseId
         * @property {string|null} [anonymousUuid] User anonymousUuid
         * @property {string|null} [profilePicUrl] User profilePicUrl
         * @property {string|null} [profileIconUrl] User profileIconUrl
         * @property {auth.Gender.Enum|null} [gender] User gender
         * @property {Array.<auth.IUserTab>|null} [userTabs] User userTabs
         * @property {auth.UserActiveStatus.Enum|null} [userActiveStatus] User userActiveStatus
         * @property {auth.UserRole.Enum|null} [userRole] User userRole
         * @property {auth.IDateOfBirth|null} [dateOfBirth] User dateOfBirth
         * @property {auth.ISocialLinks|null} [socialLinks] User socialLinks
         * @property {number|Long|null} [createdTime] User createdTime
         * @property {number|Long|null} [lastUpdatedTime] User lastUpdatedTime
         * @property {boolean|null} [deleteStatus] User deleteStatus
         * @property {number|null} [version] User version
         * @property {auth.IUserContactAddress|null} [contactAddress] User contactAddress
         */

        /**
         * Constructs a new User.
         * @memberof auth
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {auth.IUser=} [properties] Properties to set
         */
        function User(properties) {
            this.userTabs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User id.
         * @member {number|Long} id
         * @memberof auth.User
         * @instance
         */
        User.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * User pageId.
         * @member {string} pageId
         * @memberof auth.User
         * @instance
         */
        User.prototype.pageId = "";

        /**
         * User domainName.
         * @member {auth.DomainName.Enum} domainName
         * @memberof auth.User
         * @instance
         */
        User.prototype.domainName = 0;

        /**
         * User signInType.
         * @member {auth.SignInType.Enum} signInType
         * @memberof auth.User
         * @instance
         */
        User.prototype.signInType = 0;

        /**
         * User username.
         * @member {string} username
         * @memberof auth.User
         * @instance
         */
        User.prototype.username = "";

        /**
         * User email.
         * @member {string} email
         * @memberof auth.User
         * @instance
         */
        User.prototype.email = "";

        /**
         * User phone.
         * @member {string} phone
         * @memberof auth.User
         * @instance
         */
        User.prototype.phone = "";

        /**
         * User firstName.
         * @member {string} firstName
         * @memberof auth.User
         * @instance
         */
        User.prototype.firstName = "";

        /**
         * User lastName.
         * @member {string} lastName
         * @memberof auth.User
         * @instance
         */
        User.prototype.lastName = "";

        /**
         * User middleName.
         * @member {string} middleName
         * @memberof auth.User
         * @instance
         */
        User.prototype.middleName = "";

        /**
         * User emailVerified.
         * @member {boolean} emailVerified
         * @memberof auth.User
         * @instance
         */
        User.prototype.emailVerified = false;

        /**
         * User phoneVerified.
         * @member {boolean} phoneVerified
         * @memberof auth.User
         * @instance
         */
        User.prototype.phoneVerified = false;

        /**
         * User facebookId.
         * @member {string} facebookId
         * @memberof auth.User
         * @instance
         */
        User.prototype.facebookId = "";

        /**
         * User googleId.
         * @member {string} googleId
         * @memberof auth.User
         * @instance
         */
        User.prototype.googleId = "";

        /**
         * User firebaseId.
         * @member {string} firebaseId
         * @memberof auth.User
         * @instance
         */
        User.prototype.firebaseId = "";

        /**
         * User anonymousUuid.
         * @member {string} anonymousUuid
         * @memberof auth.User
         * @instance
         */
        User.prototype.anonymousUuid = "";

        /**
         * User profilePicUrl.
         * @member {string} profilePicUrl
         * @memberof auth.User
         * @instance
         */
        User.prototype.profilePicUrl = "";

        /**
         * User profileIconUrl.
         * @member {string} profileIconUrl
         * @memberof auth.User
         * @instance
         */
        User.prototype.profileIconUrl = "";

        /**
         * User gender.
         * @member {auth.Gender.Enum} gender
         * @memberof auth.User
         * @instance
         */
        User.prototype.gender = 0;

        /**
         * User userTabs.
         * @member {Array.<auth.IUserTab>} userTabs
         * @memberof auth.User
         * @instance
         */
        User.prototype.userTabs = $util.emptyArray;

        /**
         * User userActiveStatus.
         * @member {auth.UserActiveStatus.Enum} userActiveStatus
         * @memberof auth.User
         * @instance
         */
        User.prototype.userActiveStatus = 0;

        /**
         * User userRole.
         * @member {auth.UserRole.Enum} userRole
         * @memberof auth.User
         * @instance
         */
        User.prototype.userRole = 0;

        /**
         * User dateOfBirth.
         * @member {auth.IDateOfBirth|null|undefined} dateOfBirth
         * @memberof auth.User
         * @instance
         */
        User.prototype.dateOfBirth = null;

        /**
         * User socialLinks.
         * @member {auth.ISocialLinks|null|undefined} socialLinks
         * @memberof auth.User
         * @instance
         */
        User.prototype.socialLinks = null;

        /**
         * User createdTime.
         * @member {number|Long} createdTime
         * @memberof auth.User
         * @instance
         */
        User.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * User lastUpdatedTime.
         * @member {number|Long} lastUpdatedTime
         * @memberof auth.User
         * @instance
         */
        User.prototype.lastUpdatedTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * User deleteStatus.
         * @member {boolean} deleteStatus
         * @memberof auth.User
         * @instance
         */
        User.prototype.deleteStatus = false;

        /**
         * User version.
         * @member {number} version
         * @memberof auth.User
         * @instance
         */
        User.prototype.version = 0;

        /**
         * User contactAddress.
         * @member {auth.IUserContactAddress|null|undefined} contactAddress
         * @memberof auth.User
         * @instance
         */
        User.prototype.contactAddress = null;

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof auth.User
         * @static
         * @param {auth.IUser=} [properties] Properties to set
         * @returns {auth.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.User)
                return object;
            let message = new $root.auth.User();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.pageId != null)
                message.pageId = String(object.pageId);
            switch (object.domainName) {
            case "DUNGULIE":
            case 0:
                message.domainName = 0;
                break;
            case "HURRYUP":
            case 1:
                message.domainName = 1;
                break;
            case "ALGOMATRIX":
            case 2:
                message.domainName = 2;
                break;
            case "TIMELY":
            case 3:
                message.domainName = 3;
                break;
            }
            switch (object.signInType) {
            case "EMAIL_PASS":
            case 0:
                message.signInType = 0;
                break;
            case "USERNAME_PASS":
            case 1:
                message.signInType = 1;
                break;
            case "FACEBOOK":
            case 2:
                message.signInType = 2;
                break;
            case "GOOGLE":
            case 3:
                message.signInType = 3;
                break;
            case "PHONE":
            case 4:
                message.signInType = 4;
                break;
            case "FIREBASE":
            case 5:
                message.signInType = 5;
                break;
            case "GITHUB":
            case 6:
                message.signInType = 6;
                break;
            case "API_KEY":
            case 7:
                message.signInType = 7;
                break;
            case "ANONYMOUS":
            case 8:
                message.signInType = 8;
                break;
            }
            if (object.username != null)
                message.username = String(object.username);
            if (object.email != null)
                message.email = String(object.email);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.firstName != null)
                message.firstName = String(object.firstName);
            if (object.lastName != null)
                message.lastName = String(object.lastName);
            if (object.middleName != null)
                message.middleName = String(object.middleName);
            if (object.emailVerified != null)
                message.emailVerified = Boolean(object.emailVerified);
            if (object.phoneVerified != null)
                message.phoneVerified = Boolean(object.phoneVerified);
            if (object.facebookId != null)
                message.facebookId = String(object.facebookId);
            if (object.googleId != null)
                message.googleId = String(object.googleId);
            if (object.firebaseId != null)
                message.firebaseId = String(object.firebaseId);
            if (object.anonymousUuid != null)
                message.anonymousUuid = String(object.anonymousUuid);
            if (object.profilePicUrl != null)
                message.profilePicUrl = String(object.profilePicUrl);
            if (object.profileIconUrl != null)
                message.profileIconUrl = String(object.profileIconUrl);
            switch (object.gender) {
            case "NO_MENTION":
            case 0:
                message.gender = 0;
                break;
            case "MALE":
            case 1:
                message.gender = 1;
                break;
            case "FEMALE":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.userTabs) {
                if (!Array.isArray(object.userTabs))
                    throw TypeError(".auth.User.userTabs: array expected");
                message.userTabs = [];
                for (let i = 0; i < object.userTabs.length; ++i) {
                    if (typeof object.userTabs[i] !== "object")
                        throw TypeError(".auth.User.userTabs: object expected");
                    message.userTabs[i] = $root.auth.UserTab.fromObject(object.userTabs[i]);
                }
            }
            switch (object.userActiveStatus) {
            case "ACTIVE":
            case 0:
                message.userActiveStatus = 0;
                break;
            case "IN_ACTIVE":
            case 1:
                message.userActiveStatus = 1;
                break;
            case "BANNED":
            case 2:
                message.userActiveStatus = 2;
                break;
            }
            switch (object.userRole) {
            case "GENERAL":
            case 0:
                message.userRole = 0;
                break;
            case "MODERATOR":
            case 1:
                message.userRole = 1;
                break;
            case "ADMIN":
            case 2:
                message.userRole = 2;
                break;
            case "SUPER_ADMIN":
            case 3:
                message.userRole = 3;
                break;
            case "OWNER":
            case 4:
                message.userRole = 4;
                break;
            }
            if (object.dateOfBirth != null) {
                if (typeof object.dateOfBirth !== "object")
                    throw TypeError(".auth.User.dateOfBirth: object expected");
                message.dateOfBirth = $root.auth.DateOfBirth.fromObject(object.dateOfBirth);
            }
            if (object.socialLinks != null) {
                if (typeof object.socialLinks !== "object")
                    throw TypeError(".auth.User.socialLinks: object expected");
                message.socialLinks = $root.auth.SocialLinks.fromObject(object.socialLinks);
            }
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = false;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber();
            if (object.lastUpdatedTime != null)
                if ($util.Long)
                    (message.lastUpdatedTime = $util.Long.fromValue(object.lastUpdatedTime)).unsigned = false;
                else if (typeof object.lastUpdatedTime === "string")
                    message.lastUpdatedTime = parseInt(object.lastUpdatedTime, 10);
                else if (typeof object.lastUpdatedTime === "number")
                    message.lastUpdatedTime = object.lastUpdatedTime;
                else if (typeof object.lastUpdatedTime === "object")
                    message.lastUpdatedTime = new $util.LongBits(object.lastUpdatedTime.low >>> 0, object.lastUpdatedTime.high >>> 0).toNumber();
            if (object.deleteStatus != null)
                message.deleteStatus = Boolean(object.deleteStatus);
            if (object.version != null)
                message.version = object.version | 0;
            if (object.contactAddress != null) {
                if (typeof object.contactAddress !== "object")
                    throw TypeError(".auth.User.contactAddress: object expected");
                message.contactAddress = $root.auth.UserContactAddress.fromObject(object.contactAddress);
            }
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.User
         * @static
         * @param {auth.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.userTabs = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.pageId = "";
                object.domainName = options.enums === String ? "DUNGULIE" : 0;
                object.signInType = options.enums === String ? "EMAIL_PASS" : 0;
                object.username = "";
                object.email = "";
                object.phone = "";
                object.firstName = "";
                object.lastName = "";
                object.middleName = "";
                object.emailVerified = false;
                object.phoneVerified = false;
                object.facebookId = "";
                object.googleId = "";
                object.firebaseId = "";
                object.anonymousUuid = "";
                object.profilePicUrl = "";
                object.profileIconUrl = "";
                object.gender = options.enums === String ? "NO_MENTION" : 0;
                object.userActiveStatus = options.enums === String ? "ACTIVE" : 0;
                object.userRole = options.enums === String ? "GENERAL" : 0;
                object.dateOfBirth = null;
                object.socialLinks = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.lastUpdatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdatedTime = options.longs === String ? "0" : 0;
                object.deleteStatus = false;
                object.version = 0;
                object.contactAddress = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.pageId != null && message.hasOwnProperty("pageId"))
                object.pageId = message.pageId;
            if (message.domainName != null && message.hasOwnProperty("domainName"))
                object.domainName = options.enums === String ? $root.auth.DomainName.Enum[message.domainName] : message.domainName;
            if (message.signInType != null && message.hasOwnProperty("signInType"))
                object.signInType = options.enums === String ? $root.auth.SignInType.Enum[message.signInType] : message.signInType;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.firstName != null && message.hasOwnProperty("firstName"))
                object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
                object.lastName = message.lastName;
            if (message.middleName != null && message.hasOwnProperty("middleName"))
                object.middleName = message.middleName;
            if (message.emailVerified != null && message.hasOwnProperty("emailVerified"))
                object.emailVerified = message.emailVerified;
            if (message.phoneVerified != null && message.hasOwnProperty("phoneVerified"))
                object.phoneVerified = message.phoneVerified;
            if (message.facebookId != null && message.hasOwnProperty("facebookId"))
                object.facebookId = message.facebookId;
            if (message.googleId != null && message.hasOwnProperty("googleId"))
                object.googleId = message.googleId;
            if (message.firebaseId != null && message.hasOwnProperty("firebaseId"))
                object.firebaseId = message.firebaseId;
            if (message.anonymousUuid != null && message.hasOwnProperty("anonymousUuid"))
                object.anonymousUuid = message.anonymousUuid;
            if (message.profilePicUrl != null && message.hasOwnProperty("profilePicUrl"))
                object.profilePicUrl = message.profilePicUrl;
            if (message.profileIconUrl != null && message.hasOwnProperty("profileIconUrl"))
                object.profileIconUrl = message.profileIconUrl;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.auth.Gender.Enum[message.gender] : message.gender;
            if (message.userTabs && message.userTabs.length) {
                object.userTabs = [];
                for (let j = 0; j < message.userTabs.length; ++j)
                    object.userTabs[j] = $root.auth.UserTab.toObject(message.userTabs[j], options);
            }
            if (message.userActiveStatus != null && message.hasOwnProperty("userActiveStatus"))
                object.userActiveStatus = options.enums === String ? $root.auth.UserActiveStatus.Enum[message.userActiveStatus] : message.userActiveStatus;
            if (message.userRole != null && message.hasOwnProperty("userRole"))
                object.userRole = options.enums === String ? $root.auth.UserRole.Enum[message.userRole] : message.userRole;
            if (message.dateOfBirth != null && message.hasOwnProperty("dateOfBirth"))
                object.dateOfBirth = $root.auth.DateOfBirth.toObject(message.dateOfBirth, options);
            if (message.socialLinks != null && message.hasOwnProperty("socialLinks"))
                object.socialLinks = $root.auth.SocialLinks.toObject(message.socialLinks, options);
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber() : message.createdTime;
            if (message.lastUpdatedTime != null && message.hasOwnProperty("lastUpdatedTime"))
                if (typeof message.lastUpdatedTime === "number")
                    object.lastUpdatedTime = options.longs === String ? String(message.lastUpdatedTime) : message.lastUpdatedTime;
                else
                    object.lastUpdatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdatedTime) : options.longs === Number ? new $util.LongBits(message.lastUpdatedTime.low >>> 0, message.lastUpdatedTime.high >>> 0).toNumber() : message.lastUpdatedTime;
            if (message.deleteStatus != null && message.hasOwnProperty("deleteStatus"))
                object.deleteStatus = message.deleteStatus;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.contactAddress != null && message.hasOwnProperty("contactAddress"))
                object.contactAddress = $root.auth.UserContactAddress.toObject(message.contactAddress, options);
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof auth.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    auth.DomainName = (function() {

        /**
         * Properties of a DomainName.
         * @memberof auth
         * @interface IDomainName
         */

        /**
         * Constructs a new DomainName.
         * @memberof auth
         * @classdesc Represents a DomainName.
         * @implements IDomainName
         * @constructor
         * @param {auth.IDomainName=} [properties] Properties to set
         */
        function DomainName(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DomainName instance using the specified properties.
         * @function create
         * @memberof auth.DomainName
         * @static
         * @param {auth.IDomainName=} [properties] Properties to set
         * @returns {auth.DomainName} DomainName instance
         */
        DomainName.create = function create(properties) {
            return new DomainName(properties);
        };

        /**
         * Creates a DomainName message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.DomainName
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.DomainName} DomainName
         */
        DomainName.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.DomainName)
                return object;
            return new $root.auth.DomainName();
        };

        /**
         * Creates a plain object from a DomainName message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.DomainName
         * @static
         * @param {auth.DomainName} message DomainName
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DomainName.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DomainName to JSON.
         * @function toJSON
         * @memberof auth.DomainName
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DomainName.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.DomainName.Enum
         * @enum {number}
         * @property {number} DUNGULIE=0 DUNGULIE value
         * @property {number} HURRYUP=1 HURRYUP value
         * @property {number} ALGOMATRIX=2 ALGOMATRIX value
         * @property {number} TIMELY=3 TIMELY value
         */
        DomainName.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DUNGULIE"] = 0;
            values[valuesById[1] = "HURRYUP"] = 1;
            values[valuesById[2] = "ALGOMATRIX"] = 2;
            values[valuesById[3] = "TIMELY"] = 3;
            return values;
        })();

        return DomainName;
    })();

    auth.SignInType = (function() {

        /**
         * Properties of a SignInType.
         * @memberof auth
         * @interface ISignInType
         */

        /**
         * Constructs a new SignInType.
         * @memberof auth
         * @classdesc Represents a SignInType.
         * @implements ISignInType
         * @constructor
         * @param {auth.ISignInType=} [properties] Properties to set
         */
        function SignInType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SignInType instance using the specified properties.
         * @function create
         * @memberof auth.SignInType
         * @static
         * @param {auth.ISignInType=} [properties] Properties to set
         * @returns {auth.SignInType} SignInType instance
         */
        SignInType.create = function create(properties) {
            return new SignInType(properties);
        };

        /**
         * Creates a SignInType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SignInType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SignInType} SignInType
         */
        SignInType.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SignInType)
                return object;
            return new $root.auth.SignInType();
        };

        /**
         * Creates a plain object from a SignInType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SignInType
         * @static
         * @param {auth.SignInType} message SignInType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignInType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SignInType to JSON.
         * @function toJSON
         * @memberof auth.SignInType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignInType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.SignInType.Enum
         * @enum {number}
         * @property {number} EMAIL_PASS=0 EMAIL_PASS value
         * @property {number} USERNAME_PASS=1 USERNAME_PASS value
         * @property {number} FACEBOOK=2 FACEBOOK value
         * @property {number} GOOGLE=3 GOOGLE value
         * @property {number} PHONE=4 PHONE value
         * @property {number} FIREBASE=5 FIREBASE value
         * @property {number} GITHUB=6 GITHUB value
         * @property {number} API_KEY=7 API_KEY value
         * @property {number} ANONYMOUS=8 ANONYMOUS value
         */
        SignInType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EMAIL_PASS"] = 0;
            values[valuesById[1] = "USERNAME_PASS"] = 1;
            values[valuesById[2] = "FACEBOOK"] = 2;
            values[valuesById[3] = "GOOGLE"] = 3;
            values[valuesById[4] = "PHONE"] = 4;
            values[valuesById[5] = "FIREBASE"] = 5;
            values[valuesById[6] = "GITHUB"] = 6;
            values[valuesById[7] = "API_KEY"] = 7;
            values[valuesById[8] = "ANONYMOUS"] = 8;
            return values;
        })();

        return SignInType;
    })();

    auth.UserActiveStatus = (function() {

        /**
         * Properties of a UserActiveStatus.
         * @memberof auth
         * @interface IUserActiveStatus
         */

        /**
         * Constructs a new UserActiveStatus.
         * @memberof auth
         * @classdesc Represents a UserActiveStatus.
         * @implements IUserActiveStatus
         * @constructor
         * @param {auth.IUserActiveStatus=} [properties] Properties to set
         */
        function UserActiveStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UserActiveStatus instance using the specified properties.
         * @function create
         * @memberof auth.UserActiveStatus
         * @static
         * @param {auth.IUserActiveStatus=} [properties] Properties to set
         * @returns {auth.UserActiveStatus} UserActiveStatus instance
         */
        UserActiveStatus.create = function create(properties) {
            return new UserActiveStatus(properties);
        };

        /**
         * Creates a UserActiveStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UserActiveStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UserActiveStatus} UserActiveStatus
         */
        UserActiveStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UserActiveStatus)
                return object;
            return new $root.auth.UserActiveStatus();
        };

        /**
         * Creates a plain object from a UserActiveStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UserActiveStatus
         * @static
         * @param {auth.UserActiveStatus} message UserActiveStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserActiveStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UserActiveStatus to JSON.
         * @function toJSON
         * @memberof auth.UserActiveStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserActiveStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.UserActiveStatus.Enum
         * @enum {number}
         * @property {number} ACTIVE=0 ACTIVE value
         * @property {number} IN_ACTIVE=1 IN_ACTIVE value
         * @property {number} BANNED=2 BANNED value
         */
        UserActiveStatus.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ACTIVE"] = 0;
            values[valuesById[1] = "IN_ACTIVE"] = 1;
            values[valuesById[2] = "BANNED"] = 2;
            return values;
        })();

        return UserActiveStatus;
    })();

    auth.UserRole = (function() {

        /**
         * Properties of a UserRole.
         * @memberof auth
         * @interface IUserRole
         */

        /**
         * Constructs a new UserRole.
         * @memberof auth
         * @classdesc Represents a UserRole.
         * @implements IUserRole
         * @constructor
         * @param {auth.IUserRole=} [properties] Properties to set
         */
        function UserRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UserRole instance using the specified properties.
         * @function create
         * @memberof auth.UserRole
         * @static
         * @param {auth.IUserRole=} [properties] Properties to set
         * @returns {auth.UserRole} UserRole instance
         */
        UserRole.create = function create(properties) {
            return new UserRole(properties);
        };

        /**
         * Creates a UserRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UserRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UserRole} UserRole
         */
        UserRole.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UserRole)
                return object;
            return new $root.auth.UserRole();
        };

        /**
         * Creates a plain object from a UserRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UserRole
         * @static
         * @param {auth.UserRole} message UserRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserRole.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UserRole to JSON.
         * @function toJSON
         * @memberof auth.UserRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.UserRole.Enum
         * @enum {number}
         * @property {number} GENERAL=0 GENERAL value
         * @property {number} MODERATOR=1 MODERATOR value
         * @property {number} ADMIN=2 ADMIN value
         * @property {number} SUPER_ADMIN=3 SUPER_ADMIN value
         * @property {number} OWNER=4 OWNER value
         */
        UserRole.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "GENERAL"] = 0;
            values[valuesById[1] = "MODERATOR"] = 1;
            values[valuesById[2] = "ADMIN"] = 2;
            values[valuesById[3] = "SUPER_ADMIN"] = 3;
            values[valuesById[4] = "OWNER"] = 4;
            return values;
        })();

        return UserRole;
    })();

    auth.Gender = (function() {

        /**
         * Properties of a Gender.
         * @memberof auth
         * @interface IGender
         */

        /**
         * Constructs a new Gender.
         * @memberof auth
         * @classdesc Represents a Gender.
         * @implements IGender
         * @constructor
         * @param {auth.IGender=} [properties] Properties to set
         */
        function Gender(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Gender instance using the specified properties.
         * @function create
         * @memberof auth.Gender
         * @static
         * @param {auth.IGender=} [properties] Properties to set
         * @returns {auth.Gender} Gender instance
         */
        Gender.create = function create(properties) {
            return new Gender(properties);
        };

        /**
         * Creates a Gender message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.Gender
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.Gender} Gender
         */
        Gender.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.Gender)
                return object;
            return new $root.auth.Gender();
        };

        /**
         * Creates a plain object from a Gender message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.Gender
         * @static
         * @param {auth.Gender} message Gender
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Gender.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Gender to JSON.
         * @function toJSON
         * @memberof auth.Gender
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Gender.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.Gender.Enum
         * @enum {number}
         * @property {number} NO_MENTION=0 NO_MENTION value
         * @property {number} MALE=1 MALE value
         * @property {number} FEMALE=2 FEMALE value
         */
        Gender.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NO_MENTION"] = 0;
            values[valuesById[1] = "MALE"] = 1;
            values[valuesById[2] = "FEMALE"] = 2;
            return values;
        })();

        return Gender;
    })();

    auth.UserTab = (function() {

        /**
         * Properties of a UserTab.
         * @memberof auth
         * @interface IUserTab
         * @property {string|null} [tabId] UserTab tabId
         * @property {string|null} [displayName] UserTab displayName
         */

        /**
         * Constructs a new UserTab.
         * @memberof auth
         * @classdesc Represents a UserTab.
         * @implements IUserTab
         * @constructor
         * @param {auth.IUserTab=} [properties] Properties to set
         */
        function UserTab(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserTab tabId.
         * @member {string} tabId
         * @memberof auth.UserTab
         * @instance
         */
        UserTab.prototype.tabId = "";

        /**
         * UserTab displayName.
         * @member {string} displayName
         * @memberof auth.UserTab
         * @instance
         */
        UserTab.prototype.displayName = "";

        /**
         * Creates a new UserTab instance using the specified properties.
         * @function create
         * @memberof auth.UserTab
         * @static
         * @param {auth.IUserTab=} [properties] Properties to set
         * @returns {auth.UserTab} UserTab instance
         */
        UserTab.create = function create(properties) {
            return new UserTab(properties);
        };

        /**
         * Creates a UserTab message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UserTab
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UserTab} UserTab
         */
        UserTab.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UserTab)
                return object;
            let message = new $root.auth.UserTab();
            if (object.tabId != null)
                message.tabId = String(object.tabId);
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            return message;
        };

        /**
         * Creates a plain object from a UserTab message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UserTab
         * @static
         * @param {auth.UserTab} message UserTab
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserTab.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.tabId = "";
                object.displayName = "";
            }
            if (message.tabId != null && message.hasOwnProperty("tabId"))
                object.tabId = message.tabId;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            return object;
        };

        /**
         * Converts this UserTab to JSON.
         * @function toJSON
         * @memberof auth.UserTab
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserTab.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserTab;
    })();

    auth.SocialLinks = (function() {

        /**
         * Properties of a SocialLinks.
         * @memberof auth
         * @interface ISocialLinks
         * @property {string|null} [facebookUrl] SocialLinks facebookUrl
         * @property {string|null} [twitterUrl] SocialLinks twitterUrl
         * @property {string|null} [youtubeUrl] SocialLinks youtubeUrl
         * @property {string|null} [instagramUrl] SocialLinks instagramUrl
         * @property {string|null} [wikiUrl] SocialLinks wikiUrl
         */

        /**
         * Constructs a new SocialLinks.
         * @memberof auth
         * @classdesc Represents a SocialLinks.
         * @implements ISocialLinks
         * @constructor
         * @param {auth.ISocialLinks=} [properties] Properties to set
         */
        function SocialLinks(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SocialLinks facebookUrl.
         * @member {string} facebookUrl
         * @memberof auth.SocialLinks
         * @instance
         */
        SocialLinks.prototype.facebookUrl = "";

        /**
         * SocialLinks twitterUrl.
         * @member {string} twitterUrl
         * @memberof auth.SocialLinks
         * @instance
         */
        SocialLinks.prototype.twitterUrl = "";

        /**
         * SocialLinks youtubeUrl.
         * @member {string} youtubeUrl
         * @memberof auth.SocialLinks
         * @instance
         */
        SocialLinks.prototype.youtubeUrl = "";

        /**
         * SocialLinks instagramUrl.
         * @member {string} instagramUrl
         * @memberof auth.SocialLinks
         * @instance
         */
        SocialLinks.prototype.instagramUrl = "";

        /**
         * SocialLinks wikiUrl.
         * @member {string} wikiUrl
         * @memberof auth.SocialLinks
         * @instance
         */
        SocialLinks.prototype.wikiUrl = "";

        /**
         * Creates a new SocialLinks instance using the specified properties.
         * @function create
         * @memberof auth.SocialLinks
         * @static
         * @param {auth.ISocialLinks=} [properties] Properties to set
         * @returns {auth.SocialLinks} SocialLinks instance
         */
        SocialLinks.create = function create(properties) {
            return new SocialLinks(properties);
        };

        /**
         * Creates a SocialLinks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.SocialLinks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.SocialLinks} SocialLinks
         */
        SocialLinks.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.SocialLinks)
                return object;
            let message = new $root.auth.SocialLinks();
            if (object.facebookUrl != null)
                message.facebookUrl = String(object.facebookUrl);
            if (object.twitterUrl != null)
                message.twitterUrl = String(object.twitterUrl);
            if (object.youtubeUrl != null)
                message.youtubeUrl = String(object.youtubeUrl);
            if (object.instagramUrl != null)
                message.instagramUrl = String(object.instagramUrl);
            if (object.wikiUrl != null)
                message.wikiUrl = String(object.wikiUrl);
            return message;
        };

        /**
         * Creates a plain object from a SocialLinks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.SocialLinks
         * @static
         * @param {auth.SocialLinks} message SocialLinks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SocialLinks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.facebookUrl = "";
                object.twitterUrl = "";
                object.youtubeUrl = "";
                object.instagramUrl = "";
                object.wikiUrl = "";
            }
            if (message.facebookUrl != null && message.hasOwnProperty("facebookUrl"))
                object.facebookUrl = message.facebookUrl;
            if (message.twitterUrl != null && message.hasOwnProperty("twitterUrl"))
                object.twitterUrl = message.twitterUrl;
            if (message.youtubeUrl != null && message.hasOwnProperty("youtubeUrl"))
                object.youtubeUrl = message.youtubeUrl;
            if (message.instagramUrl != null && message.hasOwnProperty("instagramUrl"))
                object.instagramUrl = message.instagramUrl;
            if (message.wikiUrl != null && message.hasOwnProperty("wikiUrl"))
                object.wikiUrl = message.wikiUrl;
            return object;
        };

        /**
         * Converts this SocialLinks to JSON.
         * @function toJSON
         * @memberof auth.SocialLinks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SocialLinks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SocialLinks;
    })();

    auth.DateOfBirth = (function() {

        /**
         * Properties of a DateOfBirth.
         * @memberof auth
         * @interface IDateOfBirth
         * @property {number|null} [day] DateOfBirth day
         * @property {number|null} [month] DateOfBirth month
         * @property {number|null} [year] DateOfBirth year
         */

        /**
         * Constructs a new DateOfBirth.
         * @memberof auth
         * @classdesc Represents a DateOfBirth.
         * @implements IDateOfBirth
         * @constructor
         * @param {auth.IDateOfBirth=} [properties] Properties to set
         */
        function DateOfBirth(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DateOfBirth day.
         * @member {number} day
         * @memberof auth.DateOfBirth
         * @instance
         */
        DateOfBirth.prototype.day = 0;

        /**
         * DateOfBirth month.
         * @member {number} month
         * @memberof auth.DateOfBirth
         * @instance
         */
        DateOfBirth.prototype.month = 0;

        /**
         * DateOfBirth year.
         * @member {number} year
         * @memberof auth.DateOfBirth
         * @instance
         */
        DateOfBirth.prototype.year = 0;

        /**
         * Creates a new DateOfBirth instance using the specified properties.
         * @function create
         * @memberof auth.DateOfBirth
         * @static
         * @param {auth.IDateOfBirth=} [properties] Properties to set
         * @returns {auth.DateOfBirth} DateOfBirth instance
         */
        DateOfBirth.create = function create(properties) {
            return new DateOfBirth(properties);
        };

        /**
         * Creates a DateOfBirth message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.DateOfBirth
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.DateOfBirth} DateOfBirth
         */
        DateOfBirth.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.DateOfBirth)
                return object;
            let message = new $root.auth.DateOfBirth();
            if (object.day != null)
                message.day = object.day | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.year != null)
                message.year = object.year | 0;
            return message;
        };

        /**
         * Creates a plain object from a DateOfBirth message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.DateOfBirth
         * @static
         * @param {auth.DateOfBirth} message DateOfBirth
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DateOfBirth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.day = 0;
                object.month = 0;
                object.year = 0;
            }
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            return object;
        };

        /**
         * Converts this DateOfBirth to JSON.
         * @function toJSON
         * @memberof auth.DateOfBirth
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DateOfBirth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DateOfBirth;
    })();

    auth.UserContactAddress = (function() {

        /**
         * Properties of a UserContactAddress.
         * @memberof auth
         * @interface IUserContactAddress
         * @property {string|null} [title] UserContactAddress title
         * @property {string|null} [fullAddress] UserContactAddress fullAddress
         * @property {string|null} [road] UserContactAddress road
         * @property {string|null} [postCode] UserContactAddress postCode
         * @property {string|null} [policeStation] UserContactAddress policeStation
         * @property {string|null} [city] UserContactAddress city
         * @property {string|null} [country] UserContactAddress country
         * @property {Array.<string>|null} [phoneNumbers] UserContactAddress phoneNumbers
         * @property {Array.<string>|null} [emailAddresses] UserContactAddress emailAddresses
         */

        /**
         * Constructs a new UserContactAddress.
         * @memberof auth
         * @classdesc Represents a UserContactAddress.
         * @implements IUserContactAddress
         * @constructor
         * @param {auth.IUserContactAddress=} [properties] Properties to set
         */
        function UserContactAddress(properties) {
            this.phoneNumbers = [];
            this.emailAddresses = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserContactAddress title.
         * @member {string} title
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.title = "";

        /**
         * UserContactAddress fullAddress.
         * @member {string} fullAddress
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.fullAddress = "";

        /**
         * UserContactAddress road.
         * @member {string} road
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.road = "";

        /**
         * UserContactAddress postCode.
         * @member {string} postCode
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.postCode = "";

        /**
         * UserContactAddress policeStation.
         * @member {string} policeStation
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.policeStation = "";

        /**
         * UserContactAddress city.
         * @member {string} city
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.city = "";

        /**
         * UserContactAddress country.
         * @member {string} country
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.country = "";

        /**
         * UserContactAddress phoneNumbers.
         * @member {Array.<string>} phoneNumbers
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.phoneNumbers = $util.emptyArray;

        /**
         * UserContactAddress emailAddresses.
         * @member {Array.<string>} emailAddresses
         * @memberof auth.UserContactAddress
         * @instance
         */
        UserContactAddress.prototype.emailAddresses = $util.emptyArray;

        /**
         * Creates a new UserContactAddress instance using the specified properties.
         * @function create
         * @memberof auth.UserContactAddress
         * @static
         * @param {auth.IUserContactAddress=} [properties] Properties to set
         * @returns {auth.UserContactAddress} UserContactAddress instance
         */
        UserContactAddress.create = function create(properties) {
            return new UserContactAddress(properties);
        };

        /**
         * Creates a UserContactAddress message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UserContactAddress
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UserContactAddress} UserContactAddress
         */
        UserContactAddress.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UserContactAddress)
                return object;
            let message = new $root.auth.UserContactAddress();
            if (object.title != null)
                message.title = String(object.title);
            if (object.fullAddress != null)
                message.fullAddress = String(object.fullAddress);
            if (object.road != null)
                message.road = String(object.road);
            if (object.postCode != null)
                message.postCode = String(object.postCode);
            if (object.policeStation != null)
                message.policeStation = String(object.policeStation);
            if (object.city != null)
                message.city = String(object.city);
            if (object.country != null)
                message.country = String(object.country);
            if (object.phoneNumbers) {
                if (!Array.isArray(object.phoneNumbers))
                    throw TypeError(".auth.UserContactAddress.phoneNumbers: array expected");
                message.phoneNumbers = [];
                for (let i = 0; i < object.phoneNumbers.length; ++i)
                    message.phoneNumbers[i] = String(object.phoneNumbers[i]);
            }
            if (object.emailAddresses) {
                if (!Array.isArray(object.emailAddresses))
                    throw TypeError(".auth.UserContactAddress.emailAddresses: array expected");
                message.emailAddresses = [];
                for (let i = 0; i < object.emailAddresses.length; ++i)
                    message.emailAddresses[i] = String(object.emailAddresses[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a UserContactAddress message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UserContactAddress
         * @static
         * @param {auth.UserContactAddress} message UserContactAddress
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserContactAddress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.phoneNumbers = [];
                object.emailAddresses = [];
            }
            if (options.defaults) {
                object.title = "";
                object.fullAddress = "";
                object.road = "";
                object.postCode = "";
                object.policeStation = "";
                object.city = "";
                object.country = "";
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.fullAddress != null && message.hasOwnProperty("fullAddress"))
                object.fullAddress = message.fullAddress;
            if (message.road != null && message.hasOwnProperty("road"))
                object.road = message.road;
            if (message.postCode != null && message.hasOwnProperty("postCode"))
                object.postCode = message.postCode;
            if (message.policeStation != null && message.hasOwnProperty("policeStation"))
                object.policeStation = message.policeStation;
            if (message.city != null && message.hasOwnProperty("city"))
                object.city = message.city;
            if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
            if (message.phoneNumbers && message.phoneNumbers.length) {
                object.phoneNumbers = [];
                for (let j = 0; j < message.phoneNumbers.length; ++j)
                    object.phoneNumbers[j] = message.phoneNumbers[j];
            }
            if (message.emailAddresses && message.emailAddresses.length) {
                object.emailAddresses = [];
                for (let j = 0; j < message.emailAddresses.length; ++j)
                    object.emailAddresses[j] = message.emailAddresses[j];
            }
            return object;
        };

        /**
         * Converts this UserContactAddress to JSON.
         * @function toJSON
         * @memberof auth.UserContactAddress
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserContactAddress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserContactAddress;
    })();

    auth.UserIDVersion = (function() {

        /**
         * Properties of a UserIDVersion.
         * @memberof auth
         * @interface IUserIDVersion
         * @property {number|Long|null} [userId] UserIDVersion userId
         * @property {number|null} [version] UserIDVersion version
         */

        /**
         * Constructs a new UserIDVersion.
         * @memberof auth
         * @classdesc Represents a UserIDVersion.
         * @implements IUserIDVersion
         * @constructor
         * @param {auth.IUserIDVersion=} [properties] Properties to set
         */
        function UserIDVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserIDVersion userId.
         * @member {number|Long} userId
         * @memberof auth.UserIDVersion
         * @instance
         */
        UserIDVersion.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UserIDVersion version.
         * @member {number} version
         * @memberof auth.UserIDVersion
         * @instance
         */
        UserIDVersion.prototype.version = 0;

        /**
         * Creates a new UserIDVersion instance using the specified properties.
         * @function create
         * @memberof auth.UserIDVersion
         * @static
         * @param {auth.IUserIDVersion=} [properties] Properties to set
         * @returns {auth.UserIDVersion} UserIDVersion instance
         */
        UserIDVersion.create = function create(properties) {
            return new UserIDVersion(properties);
        };

        /**
         * Creates a UserIDVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UserIDVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UserIDVersion} UserIDVersion
         */
        UserIDVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UserIDVersion)
                return object;
            let message = new $root.auth.UserIDVersion();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.version != null)
                message.version = object.version | 0;
            return message;
        };

        /**
         * Creates a plain object from a UserIDVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UserIDVersion
         * @static
         * @param {auth.UserIDVersion} message UserIDVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserIDVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.version = 0;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this UserIDVersion to JSON.
         * @function toJSON
         * @memberof auth.UserIDVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserIDVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserIDVersion;
    })();

    auth.UpdateOperation = (function() {

        /**
         * Properties of an UpdateOperation.
         * @memberof auth
         * @interface IUpdateOperation
         * @property {auth.UpdateFieldName.Enum|null} [fieldName] UpdateOperation fieldName
         * @property {string|null} [str] UpdateOperation str
         * @property {auth.Gender.Enum|null} [gender] UpdateOperation gender
         * @property {auth.UserRole.Enum|null} [role] UpdateOperation role
         * @property {auth.UserActiveStatus.Enum|null} [activeStatus] UpdateOperation activeStatus
         * @property {boolean|null} [status] UpdateOperation status
         */

        /**
         * Constructs a new UpdateOperation.
         * @memberof auth
         * @classdesc Represents an UpdateOperation.
         * @implements IUpdateOperation
         * @constructor
         * @param {auth.IUpdateOperation=} [properties] Properties to set
         */
        function UpdateOperation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateOperation fieldName.
         * @member {auth.UpdateFieldName.Enum} fieldName
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.fieldName = 0;

        /**
         * UpdateOperation str.
         * @member {string} str
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.str = "";

        /**
         * UpdateOperation gender.
         * @member {auth.Gender.Enum} gender
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.gender = 0;

        /**
         * UpdateOperation role.
         * @member {auth.UserRole.Enum} role
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.role = 0;

        /**
         * UpdateOperation activeStatus.
         * @member {auth.UserActiveStatus.Enum} activeStatus
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.activeStatus = 0;

        /**
         * UpdateOperation status.
         * @member {boolean} status
         * @memberof auth.UpdateOperation
         * @instance
         */
        UpdateOperation.prototype.status = false;

        /**
         * Creates a new UpdateOperation instance using the specified properties.
         * @function create
         * @memberof auth.UpdateOperation
         * @static
         * @param {auth.IUpdateOperation=} [properties] Properties to set
         * @returns {auth.UpdateOperation} UpdateOperation instance
         */
        UpdateOperation.create = function create(properties) {
            return new UpdateOperation(properties);
        };

        /**
         * Creates an UpdateOperation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateOperation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateOperation} UpdateOperation
         */
        UpdateOperation.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateOperation)
                return object;
            let message = new $root.auth.UpdateOperation();
            switch (object.fieldName) {
            case "FIRST_NAME":
            case 0:
                message.fieldName = 0;
                break;
            case "LAST_NAME":
            case 1:
                message.fieldName = 1;
                break;
            case "PROFILE_PIC_URL":
            case 2:
                message.fieldName = 2;
                break;
            case "PROFILE_ICON_URL":
            case 3:
                message.fieldName = 3;
                break;
            case "GENDER":
            case 4:
                message.fieldName = 4;
                break;
            case "USER_ROLE_STATUS":
            case 5:
                message.fieldName = 5;
                break;
            case "USER_ACTIVE_STATUS":
            case 6:
                message.fieldName = 6;
                break;
            case "EMAIL_VERIFICATION_STATUS":
            case 7:
                message.fieldName = 7;
                break;
            case "PHONE_VERIFICATION_STATUS":
            case 8:
                message.fieldName = 8;
                break;
            case "EMAIL":
            case 9:
                message.fieldName = 9;
                break;
            case "PHONE":
            case 10:
                message.fieldName = 10;
                break;
            }
            if (object.str != null)
                message.str = String(object.str);
            switch (object.gender) {
            case "NO_MENTION":
            case 0:
                message.gender = 0;
                break;
            case "MALE":
            case 1:
                message.gender = 1;
                break;
            case "FEMALE":
            case 2:
                message.gender = 2;
                break;
            }
            switch (object.role) {
            case "GENERAL":
            case 0:
                message.role = 0;
                break;
            case "MODERATOR":
            case 1:
                message.role = 1;
                break;
            case "ADMIN":
            case 2:
                message.role = 2;
                break;
            case "SUPER_ADMIN":
            case 3:
                message.role = 3;
                break;
            case "OWNER":
            case 4:
                message.role = 4;
                break;
            }
            switch (object.activeStatus) {
            case "ACTIVE":
            case 0:
                message.activeStatus = 0;
                break;
            case "IN_ACTIVE":
            case 1:
                message.activeStatus = 1;
                break;
            case "BANNED":
            case 2:
                message.activeStatus = 2;
                break;
            }
            if (object.status != null)
                message.status = Boolean(object.status);
            return message;
        };

        /**
         * Creates a plain object from an UpdateOperation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateOperation
         * @static
         * @param {auth.UpdateOperation} message UpdateOperation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateOperation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fieldName = options.enums === String ? "FIRST_NAME" : 0;
                object.str = "";
                object.gender = options.enums === String ? "NO_MENTION" : 0;
                object.role = options.enums === String ? "GENERAL" : 0;
                object.activeStatus = options.enums === String ? "ACTIVE" : 0;
                object.status = false;
            }
            if (message.fieldName != null && message.hasOwnProperty("fieldName"))
                object.fieldName = options.enums === String ? $root.auth.UpdateFieldName.Enum[message.fieldName] : message.fieldName;
            if (message.str != null && message.hasOwnProperty("str"))
                object.str = message.str;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.auth.Gender.Enum[message.gender] : message.gender;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.auth.UserRole.Enum[message.role] : message.role;
            if (message.activeStatus != null && message.hasOwnProperty("activeStatus"))
                object.activeStatus = options.enums === String ? $root.auth.UserActiveStatus.Enum[message.activeStatus] : message.activeStatus;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this UpdateOperation to JSON.
         * @function toJSON
         * @memberof auth.UpdateOperation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateOperation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateOperation;
    })();

    auth.UpdateFieldName = (function() {

        /**
         * Properties of an UpdateFieldName.
         * @memberof auth
         * @interface IUpdateFieldName
         */

        /**
         * Constructs a new UpdateFieldName.
         * @memberof auth
         * @classdesc Represents an UpdateFieldName.
         * @implements IUpdateFieldName
         * @constructor
         * @param {auth.IUpdateFieldName=} [properties] Properties to set
         */
        function UpdateFieldName(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateFieldName instance using the specified properties.
         * @function create
         * @memberof auth.UpdateFieldName
         * @static
         * @param {auth.IUpdateFieldName=} [properties] Properties to set
         * @returns {auth.UpdateFieldName} UpdateFieldName instance
         */
        UpdateFieldName.create = function create(properties) {
            return new UpdateFieldName(properties);
        };

        /**
         * Creates an UpdateFieldName message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof auth.UpdateFieldName
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {auth.UpdateFieldName} UpdateFieldName
         */
        UpdateFieldName.fromObject = function fromObject(object) {
            if (object instanceof $root.auth.UpdateFieldName)
                return object;
            return new $root.auth.UpdateFieldName();
        };

        /**
         * Creates a plain object from an UpdateFieldName message. Also converts values to other types if specified.
         * @function toObject
         * @memberof auth.UpdateFieldName
         * @static
         * @param {auth.UpdateFieldName} message UpdateFieldName
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFieldName.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateFieldName to JSON.
         * @function toJSON
         * @memberof auth.UpdateFieldName
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFieldName.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name auth.UpdateFieldName.Enum
         * @enum {number}
         * @property {number} FIRST_NAME=0 FIRST_NAME value
         * @property {number} LAST_NAME=1 LAST_NAME value
         * @property {number} PROFILE_PIC_URL=2 PROFILE_PIC_URL value
         * @property {number} PROFILE_ICON_URL=3 PROFILE_ICON_URL value
         * @property {number} GENDER=4 GENDER value
         * @property {number} USER_ROLE_STATUS=5 USER_ROLE_STATUS value
         * @property {number} USER_ACTIVE_STATUS=6 USER_ACTIVE_STATUS value
         * @property {number} EMAIL_VERIFICATION_STATUS=7 EMAIL_VERIFICATION_STATUS value
         * @property {number} PHONE_VERIFICATION_STATUS=8 PHONE_VERIFICATION_STATUS value
         * @property {number} EMAIL=9 EMAIL value
         * @property {number} PHONE=10 PHONE value
         */
        UpdateFieldName.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "FIRST_NAME"] = 0;
            values[valuesById[1] = "LAST_NAME"] = 1;
            values[valuesById[2] = "PROFILE_PIC_URL"] = 2;
            values[valuesById[3] = "PROFILE_ICON_URL"] = 3;
            values[valuesById[4] = "GENDER"] = 4;
            values[valuesById[5] = "USER_ROLE_STATUS"] = 5;
            values[valuesById[6] = "USER_ACTIVE_STATUS"] = 6;
            values[valuesById[7] = "EMAIL_VERIFICATION_STATUS"] = 7;
            values[valuesById[8] = "PHONE_VERIFICATION_STATUS"] = 8;
            values[valuesById[9] = "EMAIL"] = 9;
            values[valuesById[10] = "PHONE"] = 10;
            return values;
        })();

        return UpdateFieldName;
    })();

    return auth;
})();

export const englishjanala = $root.englishjanala = (() => {

    /**
     * Namespace englishjanala.
     * @exports englishjanala
     * @namespace
     */
    const englishjanala = {};

    englishjanala.grammar = (function() {

        /**
         * Namespace grammar.
         * @memberof englishjanala
         * @namespace
         */
        const grammar = {};

        grammar.GrammarChapter = (function() {

            /**
             * Properties of a GrammarChapter.
             * @memberof englishjanala.grammar
             * @interface IGrammarChapter
             * @property {string|null} [id] GrammarChapter id
             * @property {string|null} [grammarCategoryId] GrammarChapter grammarCategoryId
             * @property {string|null} [name] GrammarChapter name
             * @property {string|null} [definition] GrammarChapter definition
             * @property {string|null} [rule] GrammarChapter rule
             * @property {string|null} [example] GrammarChapter example
             */

            /**
             * Constructs a new GrammarChapter.
             * @memberof englishjanala.grammar
             * @classdesc Represents a GrammarChapter.
             * @implements IGrammarChapter
             * @constructor
             * @param {englishjanala.grammar.IGrammarChapter=} [properties] Properties to set
             */
            function GrammarChapter(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GrammarChapter id.
             * @member {string} id
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.id = "";

            /**
             * GrammarChapter grammarCategoryId.
             * @member {string} grammarCategoryId
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.grammarCategoryId = "";

            /**
             * GrammarChapter name.
             * @member {string} name
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.name = "";

            /**
             * GrammarChapter definition.
             * @member {string} definition
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.definition = "";

            /**
             * GrammarChapter rule.
             * @member {string} rule
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.rule = "";

            /**
             * GrammarChapter example.
             * @member {string} example
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             */
            GrammarChapter.prototype.example = "";

            /**
             * Creates a new GrammarChapter instance using the specified properties.
             * @function create
             * @memberof englishjanala.grammar.GrammarChapter
             * @static
             * @param {englishjanala.grammar.IGrammarChapter=} [properties] Properties to set
             * @returns {englishjanala.grammar.GrammarChapter} GrammarChapter instance
             */
            GrammarChapter.create = function create(properties) {
                return new GrammarChapter(properties);
            };

            /**
             * Creates a GrammarChapter message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.grammar.GrammarChapter
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.grammar.GrammarChapter} GrammarChapter
             */
            GrammarChapter.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.grammar.GrammarChapter)
                    return object;
                let message = new $root.englishjanala.grammar.GrammarChapter();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.grammarCategoryId != null)
                    message.grammarCategoryId = String(object.grammarCategoryId);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.definition != null)
                    message.definition = String(object.definition);
                if (object.rule != null)
                    message.rule = String(object.rule);
                if (object.example != null)
                    message.example = String(object.example);
                return message;
            };

            /**
             * Creates a plain object from a GrammarChapter message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.grammar.GrammarChapter
             * @static
             * @param {englishjanala.grammar.GrammarChapter} message GrammarChapter
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GrammarChapter.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.grammarCategoryId = "";
                    object.name = "";
                    object.definition = "";
                    object.rule = "";
                    object.example = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.grammarCategoryId != null && message.hasOwnProperty("grammarCategoryId"))
                    object.grammarCategoryId = message.grammarCategoryId;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.definition != null && message.hasOwnProperty("definition"))
                    object.definition = message.definition;
                if (message.rule != null && message.hasOwnProperty("rule"))
                    object.rule = message.rule;
                if (message.example != null && message.hasOwnProperty("example"))
                    object.example = message.example;
                return object;
            };

            /**
             * Converts this GrammarChapter to JSON.
             * @function toJSON
             * @memberof englishjanala.grammar.GrammarChapter
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GrammarChapter.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GrammarChapter;
        })();

        grammar.GrammarCategory = (function() {

            /**
             * Properties of a GrammarCategory.
             * @memberof englishjanala.grammar
             * @interface IGrammarCategory
             * @property {string|null} [id] GrammarCategory id
             * @property {string|null} [name] GrammarCategory name
             * @property {string|null} [nameBn] GrammarCategory nameBn
             * @property {string|null} [iconUrl] GrammarCategory iconUrl
             * @property {Array.<englishjanala.grammar.IGrammarChapter>|null} [chapters] GrammarCategory chapters
             */

            /**
             * Constructs a new GrammarCategory.
             * @memberof englishjanala.grammar
             * @classdesc Represents a GrammarCategory.
             * @implements IGrammarCategory
             * @constructor
             * @param {englishjanala.grammar.IGrammarCategory=} [properties] Properties to set
             */
            function GrammarCategory(properties) {
                this.chapters = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GrammarCategory id.
             * @member {string} id
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             */
            GrammarCategory.prototype.id = "";

            /**
             * GrammarCategory name.
             * @member {string} name
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             */
            GrammarCategory.prototype.name = "";

            /**
             * GrammarCategory nameBn.
             * @member {string} nameBn
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             */
            GrammarCategory.prototype.nameBn = "";

            /**
             * GrammarCategory iconUrl.
             * @member {string} iconUrl
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             */
            GrammarCategory.prototype.iconUrl = "";

            /**
             * GrammarCategory chapters.
             * @member {Array.<englishjanala.grammar.IGrammarChapter>} chapters
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             */
            GrammarCategory.prototype.chapters = $util.emptyArray;

            /**
             * Creates a new GrammarCategory instance using the specified properties.
             * @function create
             * @memberof englishjanala.grammar.GrammarCategory
             * @static
             * @param {englishjanala.grammar.IGrammarCategory=} [properties] Properties to set
             * @returns {englishjanala.grammar.GrammarCategory} GrammarCategory instance
             */
            GrammarCategory.create = function create(properties) {
                return new GrammarCategory(properties);
            };

            /**
             * Creates a GrammarCategory message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.grammar.GrammarCategory
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.grammar.GrammarCategory} GrammarCategory
             */
            GrammarCategory.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.grammar.GrammarCategory)
                    return object;
                let message = new $root.englishjanala.grammar.GrammarCategory();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.nameBn != null)
                    message.nameBn = String(object.nameBn);
                if (object.iconUrl != null)
                    message.iconUrl = String(object.iconUrl);
                if (object.chapters) {
                    if (!Array.isArray(object.chapters))
                        throw TypeError(".englishjanala.grammar.GrammarCategory.chapters: array expected");
                    message.chapters = [];
                    for (let i = 0; i < object.chapters.length; ++i) {
                        if (typeof object.chapters[i] !== "object")
                            throw TypeError(".englishjanala.grammar.GrammarCategory.chapters: object expected");
                        message.chapters[i] = $root.englishjanala.grammar.GrammarChapter.fromObject(object.chapters[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GrammarCategory message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.grammar.GrammarCategory
             * @static
             * @param {englishjanala.grammar.GrammarCategory} message GrammarCategory
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GrammarCategory.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.chapters = [];
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.nameBn = "";
                    object.iconUrl = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.nameBn != null && message.hasOwnProperty("nameBn"))
                    object.nameBn = message.nameBn;
                if (message.iconUrl != null && message.hasOwnProperty("iconUrl"))
                    object.iconUrl = message.iconUrl;
                if (message.chapters && message.chapters.length) {
                    object.chapters = [];
                    for (let j = 0; j < message.chapters.length; ++j)
                        object.chapters[j] = $root.englishjanala.grammar.GrammarChapter.toObject(message.chapters[j], options);
                }
                return object;
            };

            /**
             * Converts this GrammarCategory to JSON.
             * @function toJSON
             * @memberof englishjanala.grammar.GrammarCategory
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GrammarCategory.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GrammarCategory;
        })();

        return grammar;
    })();

    englishjanala.translator = (function() {

        /**
         * Namespace translator.
         * @memberof englishjanala
         * @namespace
         */
        const translator = {};

        translator.TranslatorService = (function() {

            /**
             * Constructs a new TranslatorService service.
             * @memberof englishjanala.translator
             * @classdesc Represents a TranslatorService
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function TranslatorService(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (TranslatorService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = TranslatorService;

            /**
             * Creates new TranslatorService service using the specified rpc implementation.
             * @function create
             * @memberof englishjanala.translator.TranslatorService
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {TranslatorService} RPC service. Useful where requests and/or responses are streamed.
             */
            TranslatorService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            return TranslatorService;
        })();

        return translator;
    })();

    englishjanala.question = (function() {

        /**
         * Namespace question.
         * @memberof englishjanala
         * @namespace
         */
        const question = {};

        question.ResultItem = (function() {

            /**
             * Properties of a ResultItem.
             * @memberof englishjanala.question
             * @interface IResultItem
             * @property {englishjanala.question.IQuestion|null} [question] ResultItem question
             * @property {boolean|null} [answerStatus] ResultItem answerStatus
             */

            /**
             * Constructs a new ResultItem.
             * @memberof englishjanala.question
             * @classdesc Represents a ResultItem.
             * @implements IResultItem
             * @constructor
             * @param {englishjanala.question.IResultItem=} [properties] Properties to set
             */
            function ResultItem(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ResultItem question.
             * @member {englishjanala.question.IQuestion|null|undefined} question
             * @memberof englishjanala.question.ResultItem
             * @instance
             */
            ResultItem.prototype.question = null;

            /**
             * ResultItem answerStatus.
             * @member {boolean} answerStatus
             * @memberof englishjanala.question.ResultItem
             * @instance
             */
            ResultItem.prototype.answerStatus = false;

            /**
             * Creates a new ResultItem instance using the specified properties.
             * @function create
             * @memberof englishjanala.question.ResultItem
             * @static
             * @param {englishjanala.question.IResultItem=} [properties] Properties to set
             * @returns {englishjanala.question.ResultItem} ResultItem instance
             */
            ResultItem.create = function create(properties) {
                return new ResultItem(properties);
            };

            /**
             * Creates a ResultItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.question.ResultItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.question.ResultItem} ResultItem
             */
            ResultItem.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.question.ResultItem)
                    return object;
                let message = new $root.englishjanala.question.ResultItem();
                if (object.question != null) {
                    if (typeof object.question !== "object")
                        throw TypeError(".englishjanala.question.ResultItem.question: object expected");
                    message.question = $root.englishjanala.question.Question.fromObject(object.question);
                }
                if (object.answerStatus != null)
                    message.answerStatus = Boolean(object.answerStatus);
                return message;
            };

            /**
             * Creates a plain object from a ResultItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.question.ResultItem
             * @static
             * @param {englishjanala.question.ResultItem} message ResultItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResultItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.question = null;
                    object.answerStatus = false;
                }
                if (message.question != null && message.hasOwnProperty("question"))
                    object.question = $root.englishjanala.question.Question.toObject(message.question, options);
                if (message.answerStatus != null && message.hasOwnProperty("answerStatus"))
                    object.answerStatus = message.answerStatus;
                return object;
            };

            /**
             * Converts this ResultItem to JSON.
             * @function toJSON
             * @memberof englishjanala.question.ResultItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResultItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ResultItem;
        })();

        question.Question = (function() {

            /**
             * Properties of a Question.
             * @memberof englishjanala.question
             * @interface IQuestion
             * @property {string|null} [id] Question id
             * @property {string|null} [title] Question title
             * @property {englishjanala.question.QuestionType.Enum|null} [type] Question type
             * @property {Array.<string>|null} [answerOptions] Question answerOptions
             * @property {number|null} [ansId] Question ansId
             * @property {Array.<number>|null} [ansIds] Question ansIds
             */

            /**
             * Constructs a new Question.
             * @memberof englishjanala.question
             * @classdesc Represents a Question.
             * @implements IQuestion
             * @constructor
             * @param {englishjanala.question.IQuestion=} [properties] Properties to set
             */
            function Question(properties) {
                this.answerOptions = [];
                this.ansIds = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Question id.
             * @member {string} id
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.id = "";

            /**
             * Question title.
             * @member {string} title
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.title = "";

            /**
             * Question type.
             * @member {englishjanala.question.QuestionType.Enum} type
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.type = 0;

            /**
             * Question answerOptions.
             * @member {Array.<string>} answerOptions
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.answerOptions = $util.emptyArray;

            /**
             * Question ansId.
             * @member {number} ansId
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.ansId = 0;

            /**
             * Question ansIds.
             * @member {Array.<number>} ansIds
             * @memberof englishjanala.question.Question
             * @instance
             */
            Question.prototype.ansIds = $util.emptyArray;

            /**
             * Creates a new Question instance using the specified properties.
             * @function create
             * @memberof englishjanala.question.Question
             * @static
             * @param {englishjanala.question.IQuestion=} [properties] Properties to set
             * @returns {englishjanala.question.Question} Question instance
             */
            Question.create = function create(properties) {
                return new Question(properties);
            };

            /**
             * Creates a Question message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.question.Question
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.question.Question} Question
             */
            Question.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.question.Question)
                    return object;
                let message = new $root.englishjanala.question.Question();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.title != null)
                    message.title = String(object.title);
                switch (object.type) {
                case "ANYONE":
                case 0:
                    message.type = 0;
                    break;
                case "MULTIPLE":
                case 1:
                    message.type = 1;
                    break;
                }
                if (object.answerOptions) {
                    if (!Array.isArray(object.answerOptions))
                        throw TypeError(".englishjanala.question.Question.answerOptions: array expected");
                    message.answerOptions = [];
                    for (let i = 0; i < object.answerOptions.length; ++i)
                        message.answerOptions[i] = String(object.answerOptions[i]);
                }
                if (object.ansId != null)
                    message.ansId = object.ansId | 0;
                if (object.ansIds) {
                    if (!Array.isArray(object.ansIds))
                        throw TypeError(".englishjanala.question.Question.ansIds: array expected");
                    message.ansIds = [];
                    for (let i = 0; i < object.ansIds.length; ++i)
                        message.ansIds[i] = object.ansIds[i] | 0;
                }
                return message;
            };

            /**
             * Creates a plain object from a Question message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.question.Question
             * @static
             * @param {englishjanala.question.Question} message Question
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Question.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.answerOptions = [];
                    object.ansIds = [];
                }
                if (options.defaults) {
                    object.id = "";
                    object.title = "";
                    object.type = options.enums === String ? "ANYONE" : 0;
                    object.ansId = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.title != null && message.hasOwnProperty("title"))
                    object.title = message.title;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.englishjanala.question.QuestionType.Enum[message.type] : message.type;
                if (message.answerOptions && message.answerOptions.length) {
                    object.answerOptions = [];
                    for (let j = 0; j < message.answerOptions.length; ++j)
                        object.answerOptions[j] = message.answerOptions[j];
                }
                if (message.ansId != null && message.hasOwnProperty("ansId"))
                    object.ansId = message.ansId;
                if (message.ansIds && message.ansIds.length) {
                    object.ansIds = [];
                    for (let j = 0; j < message.ansIds.length; ++j)
                        object.ansIds[j] = message.ansIds[j];
                }
                return object;
            };

            /**
             * Converts this Question to JSON.
             * @function toJSON
             * @memberof englishjanala.question.Question
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Question.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Question;
        })();

        question.QuestionType = (function() {

            /**
             * Properties of a QuestionType.
             * @memberof englishjanala.question
             * @interface IQuestionType
             */

            /**
             * Constructs a new QuestionType.
             * @memberof englishjanala.question
             * @classdesc Represents a QuestionType.
             * @implements IQuestionType
             * @constructor
             * @param {englishjanala.question.IQuestionType=} [properties] Properties to set
             */
            function QuestionType(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new QuestionType instance using the specified properties.
             * @function create
             * @memberof englishjanala.question.QuestionType
             * @static
             * @param {englishjanala.question.IQuestionType=} [properties] Properties to set
             * @returns {englishjanala.question.QuestionType} QuestionType instance
             */
            QuestionType.create = function create(properties) {
                return new QuestionType(properties);
            };

            /**
             * Creates a QuestionType message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.question.QuestionType
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.question.QuestionType} QuestionType
             */
            QuestionType.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.question.QuestionType)
                    return object;
                return new $root.englishjanala.question.QuestionType();
            };

            /**
             * Creates a plain object from a QuestionType message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.question.QuestionType
             * @static
             * @param {englishjanala.question.QuestionType} message QuestionType
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            QuestionType.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this QuestionType to JSON.
             * @function toJSON
             * @memberof englishjanala.question.QuestionType
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            QuestionType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name englishjanala.question.QuestionType.Enum
             * @enum {number}
             * @property {number} ANYONE=0 ANYONE value
             * @property {number} MULTIPLE=1 MULTIPLE value
             */
            QuestionType.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ANYONE"] = 0;
                values[valuesById[1] = "MULTIPLE"] = 1;
                return values;
            })();

            return QuestionType;
        })();

        return question;
    })();

    englishjanala.conversation = (function() {

        /**
         * Namespace conversation.
         * @memberof englishjanala
         * @namespace
         */
        const conversation = {};

        conversation.Chapter = (function() {

            /**
             * Properties of a Chapter.
             * @memberof englishjanala.conversation
             * @interface IChapter
             * @property {string|null} [id] Chapter id
             * @property {string|null} [name] Chapter name
             * @property {string|null} [nameBn] Chapter nameBn
             * @property {string|null} [categoryId] Chapter categoryId
             * @property {Array.<englishjanala.sentence.ISentence>|null} [sentences] Chapter sentences
             */

            /**
             * Constructs a new Chapter.
             * @memberof englishjanala.conversation
             * @classdesc Represents a Chapter.
             * @implements IChapter
             * @constructor
             * @param {englishjanala.conversation.IChapter=} [properties] Properties to set
             */
            function Chapter(properties) {
                this.sentences = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Chapter id.
             * @member {string} id
             * @memberof englishjanala.conversation.Chapter
             * @instance
             */
            Chapter.prototype.id = "";

            /**
             * Chapter name.
             * @member {string} name
             * @memberof englishjanala.conversation.Chapter
             * @instance
             */
            Chapter.prototype.name = "";

            /**
             * Chapter nameBn.
             * @member {string} nameBn
             * @memberof englishjanala.conversation.Chapter
             * @instance
             */
            Chapter.prototype.nameBn = "";

            /**
             * Chapter categoryId.
             * @member {string} categoryId
             * @memberof englishjanala.conversation.Chapter
             * @instance
             */
            Chapter.prototype.categoryId = "";

            /**
             * Chapter sentences.
             * @member {Array.<englishjanala.sentence.ISentence>} sentences
             * @memberof englishjanala.conversation.Chapter
             * @instance
             */
            Chapter.prototype.sentences = $util.emptyArray;

            /**
             * Creates a new Chapter instance using the specified properties.
             * @function create
             * @memberof englishjanala.conversation.Chapter
             * @static
             * @param {englishjanala.conversation.IChapter=} [properties] Properties to set
             * @returns {englishjanala.conversation.Chapter} Chapter instance
             */
            Chapter.create = function create(properties) {
                return new Chapter(properties);
            };

            /**
             * Creates a Chapter message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.conversation.Chapter
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.conversation.Chapter} Chapter
             */
            Chapter.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.conversation.Chapter)
                    return object;
                let message = new $root.englishjanala.conversation.Chapter();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.nameBn != null)
                    message.nameBn = String(object.nameBn);
                if (object.categoryId != null)
                    message.categoryId = String(object.categoryId);
                if (object.sentences) {
                    if (!Array.isArray(object.sentences))
                        throw TypeError(".englishjanala.conversation.Chapter.sentences: array expected");
                    message.sentences = [];
                    for (let i = 0; i < object.sentences.length; ++i) {
                        if (typeof object.sentences[i] !== "object")
                            throw TypeError(".englishjanala.conversation.Chapter.sentences: object expected");
                        message.sentences[i] = $root.englishjanala.sentence.Sentence.fromObject(object.sentences[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Chapter message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.conversation.Chapter
             * @static
             * @param {englishjanala.conversation.Chapter} message Chapter
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Chapter.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.sentences = [];
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.nameBn = "";
                    object.categoryId = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.nameBn != null && message.hasOwnProperty("nameBn"))
                    object.nameBn = message.nameBn;
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    object.categoryId = message.categoryId;
                if (message.sentences && message.sentences.length) {
                    object.sentences = [];
                    for (let j = 0; j < message.sentences.length; ++j)
                        object.sentences[j] = $root.englishjanala.sentence.Sentence.toObject(message.sentences[j], options);
                }
                return object;
            };

            /**
             * Converts this Chapter to JSON.
             * @function toJSON
             * @memberof englishjanala.conversation.Chapter
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Chapter.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Chapter;
        })();

        conversation.ConversationCategory = (function() {

            /**
             * Properties of a ConversationCategory.
             * @memberof englishjanala.conversation
             * @interface IConversationCategory
             * @property {string|null} [id] ConversationCategory id
             * @property {string|null} [name] ConversationCategory name
             * @property {string|null} [nameBn] ConversationCategory nameBn
             * @property {string|null} [iconUrl] ConversationCategory iconUrl
             * @property {Array.<englishjanala.conversation.IChapter>|null} [chapters] ConversationCategory chapters
             */

            /**
             * Constructs a new ConversationCategory.
             * @memberof englishjanala.conversation
             * @classdesc Represents a ConversationCategory.
             * @implements IConversationCategory
             * @constructor
             * @param {englishjanala.conversation.IConversationCategory=} [properties] Properties to set
             */
            function ConversationCategory(properties) {
                this.chapters = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ConversationCategory id.
             * @member {string} id
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             */
            ConversationCategory.prototype.id = "";

            /**
             * ConversationCategory name.
             * @member {string} name
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             */
            ConversationCategory.prototype.name = "";

            /**
             * ConversationCategory nameBn.
             * @member {string} nameBn
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             */
            ConversationCategory.prototype.nameBn = "";

            /**
             * ConversationCategory iconUrl.
             * @member {string} iconUrl
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             */
            ConversationCategory.prototype.iconUrl = "";

            /**
             * ConversationCategory chapters.
             * @member {Array.<englishjanala.conversation.IChapter>} chapters
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             */
            ConversationCategory.prototype.chapters = $util.emptyArray;

            /**
             * Creates a new ConversationCategory instance using the specified properties.
             * @function create
             * @memberof englishjanala.conversation.ConversationCategory
             * @static
             * @param {englishjanala.conversation.IConversationCategory=} [properties] Properties to set
             * @returns {englishjanala.conversation.ConversationCategory} ConversationCategory instance
             */
            ConversationCategory.create = function create(properties) {
                return new ConversationCategory(properties);
            };

            /**
             * Creates a ConversationCategory message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.conversation.ConversationCategory
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.conversation.ConversationCategory} ConversationCategory
             */
            ConversationCategory.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.conversation.ConversationCategory)
                    return object;
                let message = new $root.englishjanala.conversation.ConversationCategory();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.nameBn != null)
                    message.nameBn = String(object.nameBn);
                if (object.iconUrl != null)
                    message.iconUrl = String(object.iconUrl);
                if (object.chapters) {
                    if (!Array.isArray(object.chapters))
                        throw TypeError(".englishjanala.conversation.ConversationCategory.chapters: array expected");
                    message.chapters = [];
                    for (let i = 0; i < object.chapters.length; ++i) {
                        if (typeof object.chapters[i] !== "object")
                            throw TypeError(".englishjanala.conversation.ConversationCategory.chapters: object expected");
                        message.chapters[i] = $root.englishjanala.conversation.Chapter.fromObject(object.chapters[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ConversationCategory message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.conversation.ConversationCategory
             * @static
             * @param {englishjanala.conversation.ConversationCategory} message ConversationCategory
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ConversationCategory.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.chapters = [];
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.nameBn = "";
                    object.iconUrl = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.nameBn != null && message.hasOwnProperty("nameBn"))
                    object.nameBn = message.nameBn;
                if (message.iconUrl != null && message.hasOwnProperty("iconUrl"))
                    object.iconUrl = message.iconUrl;
                if (message.chapters && message.chapters.length) {
                    object.chapters = [];
                    for (let j = 0; j < message.chapters.length; ++j)
                        object.chapters[j] = $root.englishjanala.conversation.Chapter.toObject(message.chapters[j], options);
                }
                return object;
            };

            /**
             * Converts this ConversationCategory to JSON.
             * @function toJSON
             * @memberof englishjanala.conversation.ConversationCategory
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ConversationCategory.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ConversationCategory;
        })();

        return conversation;
    })();

    englishjanala.sentence = (function() {

        /**
         * Namespace sentence.
         * @memberof englishjanala
         * @namespace
         */
        const sentence = {};

        sentence.Sentence = (function() {

            /**
             * Properties of a Sentence.
             * @memberof englishjanala.sentence
             * @interface ISentence
             * @property {string|null} [en] Sentence en
             * @property {string|null} [bn] Sentence bn
             * @property {string|null} [phoneticBn] Sentence phoneticBn
             * @property {boolean|null} [isBookmarked] Sentence isBookmarked
             * @property {string|null} [chapterId] Sentence chapterId
             * @property {string|null} [conversationCategoryId] Sentence conversationCategoryId
             * @property {boolean|null} [isUserGenerated] Sentence isUserGenerated
             */

            /**
             * Constructs a new Sentence.
             * @memberof englishjanala.sentence
             * @classdesc Represents a Sentence.
             * @implements ISentence
             * @constructor
             * @param {englishjanala.sentence.ISentence=} [properties] Properties to set
             */
            function Sentence(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Sentence en.
             * @member {string} en
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.en = "";

            /**
             * Sentence bn.
             * @member {string} bn
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.bn = "";

            /**
             * Sentence phoneticBn.
             * @member {string} phoneticBn
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.phoneticBn = "";

            /**
             * Sentence isBookmarked.
             * @member {boolean} isBookmarked
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.isBookmarked = false;

            /**
             * Sentence chapterId.
             * @member {string} chapterId
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.chapterId = "";

            /**
             * Sentence conversationCategoryId.
             * @member {string} conversationCategoryId
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.conversationCategoryId = "";

            /**
             * Sentence isUserGenerated.
             * @member {boolean} isUserGenerated
             * @memberof englishjanala.sentence.Sentence
             * @instance
             */
            Sentence.prototype.isUserGenerated = false;

            /**
             * Creates a new Sentence instance using the specified properties.
             * @function create
             * @memberof englishjanala.sentence.Sentence
             * @static
             * @param {englishjanala.sentence.ISentence=} [properties] Properties to set
             * @returns {englishjanala.sentence.Sentence} Sentence instance
             */
            Sentence.create = function create(properties) {
                return new Sentence(properties);
            };

            /**
             * Creates a Sentence message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.sentence.Sentence
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.sentence.Sentence} Sentence
             */
            Sentence.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.sentence.Sentence)
                    return object;
                let message = new $root.englishjanala.sentence.Sentence();
                if (object.en != null)
                    message.en = String(object.en);
                if (object.bn != null)
                    message.bn = String(object.bn);
                if (object.phoneticBn != null)
                    message.phoneticBn = String(object.phoneticBn);
                if (object.isBookmarked != null)
                    message.isBookmarked = Boolean(object.isBookmarked);
                if (object.chapterId != null)
                    message.chapterId = String(object.chapterId);
                if (object.conversationCategoryId != null)
                    message.conversationCategoryId = String(object.conversationCategoryId);
                if (object.isUserGenerated != null)
                    message.isUserGenerated = Boolean(object.isUserGenerated);
                return message;
            };

            /**
             * Creates a plain object from a Sentence message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.sentence.Sentence
             * @static
             * @param {englishjanala.sentence.Sentence} message Sentence
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Sentence.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.en = "";
                    object.bn = "";
                    object.phoneticBn = "";
                    object.isBookmarked = false;
                    object.chapterId = "";
                    object.conversationCategoryId = "";
                    object.isUserGenerated = false;
                }
                if (message.en != null && message.hasOwnProperty("en"))
                    object.en = message.en;
                if (message.bn != null && message.hasOwnProperty("bn"))
                    object.bn = message.bn;
                if (message.phoneticBn != null && message.hasOwnProperty("phoneticBn"))
                    object.phoneticBn = message.phoneticBn;
                if (message.isBookmarked != null && message.hasOwnProperty("isBookmarked"))
                    object.isBookmarked = message.isBookmarked;
                if (message.chapterId != null && message.hasOwnProperty("chapterId"))
                    object.chapterId = message.chapterId;
                if (message.conversationCategoryId != null && message.hasOwnProperty("conversationCategoryId"))
                    object.conversationCategoryId = message.conversationCategoryId;
                if (message.isUserGenerated != null && message.hasOwnProperty("isUserGenerated"))
                    object.isUserGenerated = message.isUserGenerated;
                return object;
            };

            /**
             * Converts this Sentence to JSON.
             * @function toJSON
             * @memberof englishjanala.sentence.Sentence
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Sentence.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Sentence;
        })();

        return sentence;
    })();

    englishjanala.word = (function() {

        /**
         * Namespace word.
         * @memberof englishjanala
         * @namespace
         */
        const word = {};

        word.Word = (function() {

            /**
             * Properties of a Word.
             * @memberof englishjanala.word
             * @interface IWord
             * @property {string|null} [en] Word en
             * @property {string|null} [bn] Word bn
             * @property {string|null} [phoneticBn] Word phoneticBn
             * @property {boolean|null} [isBookmarked] Word isBookmarked
             * @property {string|null} [categoryId] Word categoryId
             * @property {boolean|null} [isUserGenerated] Word isUserGenerated
             */

            /**
             * Constructs a new Word.
             * @memberof englishjanala.word
             * @classdesc Represents a Word.
             * @implements IWord
             * @constructor
             * @param {englishjanala.word.IWord=} [properties] Properties to set
             */
            function Word(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Word en.
             * @member {string} en
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.en = "";

            /**
             * Word bn.
             * @member {string} bn
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.bn = "";

            /**
             * Word phoneticBn.
             * @member {string} phoneticBn
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.phoneticBn = "";

            /**
             * Word isBookmarked.
             * @member {boolean} isBookmarked
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.isBookmarked = false;

            /**
             * Word categoryId.
             * @member {string} categoryId
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.categoryId = "";

            /**
             * Word isUserGenerated.
             * @member {boolean} isUserGenerated
             * @memberof englishjanala.word.Word
             * @instance
             */
            Word.prototype.isUserGenerated = false;

            /**
             * Creates a new Word instance using the specified properties.
             * @function create
             * @memberof englishjanala.word.Word
             * @static
             * @param {englishjanala.word.IWord=} [properties] Properties to set
             * @returns {englishjanala.word.Word} Word instance
             */
            Word.create = function create(properties) {
                return new Word(properties);
            };

            /**
             * Creates a Word message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.word.Word
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.word.Word} Word
             */
            Word.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.word.Word)
                    return object;
                let message = new $root.englishjanala.word.Word();
                if (object.en != null)
                    message.en = String(object.en);
                if (object.bn != null)
                    message.bn = String(object.bn);
                if (object.phoneticBn != null)
                    message.phoneticBn = String(object.phoneticBn);
                if (object.isBookmarked != null)
                    message.isBookmarked = Boolean(object.isBookmarked);
                if (object.categoryId != null)
                    message.categoryId = String(object.categoryId);
                if (object.isUserGenerated != null)
                    message.isUserGenerated = Boolean(object.isUserGenerated);
                return message;
            };

            /**
             * Creates a plain object from a Word message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.word.Word
             * @static
             * @param {englishjanala.word.Word} message Word
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Word.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.en = "";
                    object.bn = "";
                    object.phoneticBn = "";
                    object.isBookmarked = false;
                    object.categoryId = "";
                    object.isUserGenerated = false;
                }
                if (message.en != null && message.hasOwnProperty("en"))
                    object.en = message.en;
                if (message.bn != null && message.hasOwnProperty("bn"))
                    object.bn = message.bn;
                if (message.phoneticBn != null && message.hasOwnProperty("phoneticBn"))
                    object.phoneticBn = message.phoneticBn;
                if (message.isBookmarked != null && message.hasOwnProperty("isBookmarked"))
                    object.isBookmarked = message.isBookmarked;
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    object.categoryId = message.categoryId;
                if (message.isUserGenerated != null && message.hasOwnProperty("isUserGenerated"))
                    object.isUserGenerated = message.isUserGenerated;
                return object;
            };

            /**
             * Converts this Word to JSON.
             * @function toJSON
             * @memberof englishjanala.word.Word
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Word.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Word;
        })();

        word.WordCategory = (function() {

            /**
             * Properties of a WordCategory.
             * @memberof englishjanala.word
             * @interface IWordCategory
             * @property {string|null} [id] WordCategory id
             * @property {string|null} [name] WordCategory name
             * @property {string|null} [nameBn] WordCategory nameBn
             * @property {string|null} [iconUrl] WordCategory iconUrl
             * @property {Array.<englishjanala.word.IWord>|null} [words] WordCategory words
             */

            /**
             * Constructs a new WordCategory.
             * @memberof englishjanala.word
             * @classdesc Represents a WordCategory.
             * @implements IWordCategory
             * @constructor
             * @param {englishjanala.word.IWordCategory=} [properties] Properties to set
             */
            function WordCategory(properties) {
                this.words = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WordCategory id.
             * @member {string} id
             * @memberof englishjanala.word.WordCategory
             * @instance
             */
            WordCategory.prototype.id = "";

            /**
             * WordCategory name.
             * @member {string} name
             * @memberof englishjanala.word.WordCategory
             * @instance
             */
            WordCategory.prototype.name = "";

            /**
             * WordCategory nameBn.
             * @member {string} nameBn
             * @memberof englishjanala.word.WordCategory
             * @instance
             */
            WordCategory.prototype.nameBn = "";

            /**
             * WordCategory iconUrl.
             * @member {string} iconUrl
             * @memberof englishjanala.word.WordCategory
             * @instance
             */
            WordCategory.prototype.iconUrl = "";

            /**
             * WordCategory words.
             * @member {Array.<englishjanala.word.IWord>} words
             * @memberof englishjanala.word.WordCategory
             * @instance
             */
            WordCategory.prototype.words = $util.emptyArray;

            /**
             * Creates a new WordCategory instance using the specified properties.
             * @function create
             * @memberof englishjanala.word.WordCategory
             * @static
             * @param {englishjanala.word.IWordCategory=} [properties] Properties to set
             * @returns {englishjanala.word.WordCategory} WordCategory instance
             */
            WordCategory.create = function create(properties) {
                return new WordCategory(properties);
            };

            /**
             * Creates a WordCategory message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.word.WordCategory
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.word.WordCategory} WordCategory
             */
            WordCategory.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.word.WordCategory)
                    return object;
                let message = new $root.englishjanala.word.WordCategory();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.nameBn != null)
                    message.nameBn = String(object.nameBn);
                if (object.iconUrl != null)
                    message.iconUrl = String(object.iconUrl);
                if (object.words) {
                    if (!Array.isArray(object.words))
                        throw TypeError(".englishjanala.word.WordCategory.words: array expected");
                    message.words = [];
                    for (let i = 0; i < object.words.length; ++i) {
                        if (typeof object.words[i] !== "object")
                            throw TypeError(".englishjanala.word.WordCategory.words: object expected");
                        message.words[i] = $root.englishjanala.word.Word.fromObject(object.words[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a WordCategory message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.word.WordCategory
             * @static
             * @param {englishjanala.word.WordCategory} message WordCategory
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WordCategory.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.words = [];
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.nameBn = "";
                    object.iconUrl = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.nameBn != null && message.hasOwnProperty("nameBn"))
                    object.nameBn = message.nameBn;
                if (message.iconUrl != null && message.hasOwnProperty("iconUrl"))
                    object.iconUrl = message.iconUrl;
                if (message.words && message.words.length) {
                    object.words = [];
                    for (let j = 0; j < message.words.length; ++j)
                        object.words[j] = $root.englishjanala.word.Word.toObject(message.words[j], options);
                }
                return object;
            };

            /**
             * Converts this WordCategory to JSON.
             * @function toJSON
             * @memberof englishjanala.word.WordCategory
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WordCategory.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return WordCategory;
        })();

        return word;
    })();

    englishjanala.data = (function() {

        /**
         * Namespace data.
         * @memberof englishjanala
         * @namespace
         */
        const data = {};

        data.UserData = (function() {

            /**
             * Properties of a UserData.
             * @memberof englishjanala.data
             * @interface IUserData
             */

            /**
             * Constructs a new UserData.
             * @memberof englishjanala.data
             * @classdesc Represents a UserData.
             * @implements IUserData
             * @constructor
             * @param {englishjanala.data.IUserData=} [properties] Properties to set
             */
            function UserData(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UserData instance using the specified properties.
             * @function create
             * @memberof englishjanala.data.UserData
             * @static
             * @param {englishjanala.data.IUserData=} [properties] Properties to set
             * @returns {englishjanala.data.UserData} UserData instance
             */
            UserData.create = function create(properties) {
                return new UserData(properties);
            };

            /**
             * Creates a UserData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.data.UserData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.data.UserData} UserData
             */
            UserData.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.data.UserData)
                    return object;
                return new $root.englishjanala.data.UserData();
            };

            /**
             * Creates a plain object from a UserData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.data.UserData
             * @static
             * @param {englishjanala.data.UserData} message UserData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserData.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UserData to JSON.
             * @function toJSON
             * @memberof englishjanala.data.UserData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UserData;
        })();

        data.DictionaryData = (function() {

            /**
             * Properties of a DictionaryData.
             * @memberof englishjanala.data
             * @interface IDictionaryData
             * @property {Array.<englishjanala.word.IWord>|null} [en_2Bn] DictionaryData en_2Bn
             * @property {Array.<englishjanala.word.IWord>|null} [bn_2En] DictionaryData bn_2En
             */

            /**
             * Constructs a new DictionaryData.
             * @memberof englishjanala.data
             * @classdesc Represents a DictionaryData.
             * @implements IDictionaryData
             * @constructor
             * @param {englishjanala.data.IDictionaryData=} [properties] Properties to set
             */
            function DictionaryData(properties) {
                this.en_2Bn = [];
                this.bn_2En = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DictionaryData en_2Bn.
             * @member {Array.<englishjanala.word.IWord>} en_2Bn
             * @memberof englishjanala.data.DictionaryData
             * @instance
             */
            DictionaryData.prototype.en_2Bn = $util.emptyArray;

            /**
             * DictionaryData bn_2En.
             * @member {Array.<englishjanala.word.IWord>} bn_2En
             * @memberof englishjanala.data.DictionaryData
             * @instance
             */
            DictionaryData.prototype.bn_2En = $util.emptyArray;

            /**
             * Creates a new DictionaryData instance using the specified properties.
             * @function create
             * @memberof englishjanala.data.DictionaryData
             * @static
             * @param {englishjanala.data.IDictionaryData=} [properties] Properties to set
             * @returns {englishjanala.data.DictionaryData} DictionaryData instance
             */
            DictionaryData.create = function create(properties) {
                return new DictionaryData(properties);
            };

            /**
             * Creates a DictionaryData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.data.DictionaryData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.data.DictionaryData} DictionaryData
             */
            DictionaryData.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.data.DictionaryData)
                    return object;
                let message = new $root.englishjanala.data.DictionaryData();
                if (object.en_2Bn) {
                    if (!Array.isArray(object.en_2Bn))
                        throw TypeError(".englishjanala.data.DictionaryData.en_2Bn: array expected");
                    message.en_2Bn = [];
                    for (let i = 0; i < object.en_2Bn.length; ++i) {
                        if (typeof object.en_2Bn[i] !== "object")
                            throw TypeError(".englishjanala.data.DictionaryData.en_2Bn: object expected");
                        message.en_2Bn[i] = $root.englishjanala.word.Word.fromObject(object.en_2Bn[i]);
                    }
                }
                if (object.bn_2En) {
                    if (!Array.isArray(object.bn_2En))
                        throw TypeError(".englishjanala.data.DictionaryData.bn_2En: array expected");
                    message.bn_2En = [];
                    for (let i = 0; i < object.bn_2En.length; ++i) {
                        if (typeof object.bn_2En[i] !== "object")
                            throw TypeError(".englishjanala.data.DictionaryData.bn_2En: object expected");
                        message.bn_2En[i] = $root.englishjanala.word.Word.fromObject(object.bn_2En[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a DictionaryData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.data.DictionaryData
             * @static
             * @param {englishjanala.data.DictionaryData} message DictionaryData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DictionaryData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.en_2Bn = [];
                    object.bn_2En = [];
                }
                if (message.en_2Bn && message.en_2Bn.length) {
                    object.en_2Bn = [];
                    for (let j = 0; j < message.en_2Bn.length; ++j)
                        object.en_2Bn[j] = $root.englishjanala.word.Word.toObject(message.en_2Bn[j], options);
                }
                if (message.bn_2En && message.bn_2En.length) {
                    object.bn_2En = [];
                    for (let j = 0; j < message.bn_2En.length; ++j)
                        object.bn_2En[j] = $root.englishjanala.word.Word.toObject(message.bn_2En[j], options);
                }
                return object;
            };

            /**
             * Converts this DictionaryData to JSON.
             * @function toJSON
             * @memberof englishjanala.data.DictionaryData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DictionaryData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DictionaryData;
        })();

        data.AppData = (function() {

            /**
             * Properties of an AppData.
             * @memberof englishjanala.data
             * @interface IAppData
             * @property {Array.<englishjanala.word.IWordCategory>|null} [wordCategories] AppData wordCategories
             * @property {Array.<englishjanala.conversation.IConversationCategory>|null} [conversationCategories] AppData conversationCategories
             * @property {Array.<englishjanala.grammar.IGrammarCategory>|null} [grammarCategories] AppData grammarCategories
             */

            /**
             * Constructs a new AppData.
             * @memberof englishjanala.data
             * @classdesc Represents an AppData.
             * @implements IAppData
             * @constructor
             * @param {englishjanala.data.IAppData=} [properties] Properties to set
             */
            function AppData(properties) {
                this.wordCategories = [];
                this.conversationCategories = [];
                this.grammarCategories = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppData wordCategories.
             * @member {Array.<englishjanala.word.IWordCategory>} wordCategories
             * @memberof englishjanala.data.AppData
             * @instance
             */
            AppData.prototype.wordCategories = $util.emptyArray;

            /**
             * AppData conversationCategories.
             * @member {Array.<englishjanala.conversation.IConversationCategory>} conversationCategories
             * @memberof englishjanala.data.AppData
             * @instance
             */
            AppData.prototype.conversationCategories = $util.emptyArray;

            /**
             * AppData grammarCategories.
             * @member {Array.<englishjanala.grammar.IGrammarCategory>} grammarCategories
             * @memberof englishjanala.data.AppData
             * @instance
             */
            AppData.prototype.grammarCategories = $util.emptyArray;

            /**
             * Creates a new AppData instance using the specified properties.
             * @function create
             * @memberof englishjanala.data.AppData
             * @static
             * @param {englishjanala.data.IAppData=} [properties] Properties to set
             * @returns {englishjanala.data.AppData} AppData instance
             */
            AppData.create = function create(properties) {
                return new AppData(properties);
            };

            /**
             * Creates an AppData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof englishjanala.data.AppData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {englishjanala.data.AppData} AppData
             */
            AppData.fromObject = function fromObject(object) {
                if (object instanceof $root.englishjanala.data.AppData)
                    return object;
                let message = new $root.englishjanala.data.AppData();
                if (object.wordCategories) {
                    if (!Array.isArray(object.wordCategories))
                        throw TypeError(".englishjanala.data.AppData.wordCategories: array expected");
                    message.wordCategories = [];
                    for (let i = 0; i < object.wordCategories.length; ++i) {
                        if (typeof object.wordCategories[i] !== "object")
                            throw TypeError(".englishjanala.data.AppData.wordCategories: object expected");
                        message.wordCategories[i] = $root.englishjanala.word.WordCategory.fromObject(object.wordCategories[i]);
                    }
                }
                if (object.conversationCategories) {
                    if (!Array.isArray(object.conversationCategories))
                        throw TypeError(".englishjanala.data.AppData.conversationCategories: array expected");
                    message.conversationCategories = [];
                    for (let i = 0; i < object.conversationCategories.length; ++i) {
                        if (typeof object.conversationCategories[i] !== "object")
                            throw TypeError(".englishjanala.data.AppData.conversationCategories: object expected");
                        message.conversationCategories[i] = $root.englishjanala.conversation.ConversationCategory.fromObject(object.conversationCategories[i]);
                    }
                }
                if (object.grammarCategories) {
                    if (!Array.isArray(object.grammarCategories))
                        throw TypeError(".englishjanala.data.AppData.grammarCategories: array expected");
                    message.grammarCategories = [];
                    for (let i = 0; i < object.grammarCategories.length; ++i) {
                        if (typeof object.grammarCategories[i] !== "object")
                            throw TypeError(".englishjanala.data.AppData.grammarCategories: object expected");
                        message.grammarCategories[i] = $root.englishjanala.grammar.GrammarCategory.fromObject(object.grammarCategories[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof englishjanala.data.AppData
             * @static
             * @param {englishjanala.data.AppData} message AppData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.wordCategories = [];
                    object.conversationCategories = [];
                    object.grammarCategories = [];
                }
                if (message.wordCategories && message.wordCategories.length) {
                    object.wordCategories = [];
                    for (let j = 0; j < message.wordCategories.length; ++j)
                        object.wordCategories[j] = $root.englishjanala.word.WordCategory.toObject(message.wordCategories[j], options);
                }
                if (message.conversationCategories && message.conversationCategories.length) {
                    object.conversationCategories = [];
                    for (let j = 0; j < message.conversationCategories.length; ++j)
                        object.conversationCategories[j] = $root.englishjanala.conversation.ConversationCategory.toObject(message.conversationCategories[j], options);
                }
                if (message.grammarCategories && message.grammarCategories.length) {
                    object.grammarCategories = [];
                    for (let j = 0; j < message.grammarCategories.length; ++j)
                        object.grammarCategories[j] = $root.englishjanala.grammar.GrammarCategory.toObject(message.grammarCategories[j], options);
                }
                return object;
            };

            /**
             * Converts this AppData to JSON.
             * @function toJSON
             * @memberof englishjanala.data.AppData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppData;
        })();

        return data;
    })();

    return englishjanala;
})();

export { $root as default };
